// 引入组件 Raphael
import Raphael from 'raphael'
// 引入组件 jQuery
import $ from 'jquery'
// 缓存数据
import Store from '@/store/index'
// 引入组件 HanshMap
import {HashMap} from '@/static_dazzle/plugins/tools/hashmap'
// 公共变量
import GlobalVariable from '@/global/global-variable'
// 公共参数
import GlobalParam from '@/global/global-param'
// 公共方法 坐标转换
import GlobalMap from '@/global/global-map'

//监听DIV尺寸改变
(function($,h,c){var a=$([]),e=$.resize=$.extend($.resize,{}),i,k="setTimeout",j="resize",d=j+"-special-event",b="delay",f="throttleWindow";e[b]=250;e[f]=true;$.event.special[j]={setup:function(){if(!e[f]&&this[k]){return false}var l=$(this);a=a.add(l);$.data(this,d,{w:l.width(),h:l.height()});if(a.length===1){g()}},teardown:function(){if(!e[f]&&this[k]){return false}var l=$(this);a=a.not(l);l.removeData(d);if(!a.length){clearTimeout(i)}},add:function(l){if(!e[f]&&this[k]){return false}var n;function m(s,o,p){var q=$(this),r=$.data(this,d);r.w=o!==c?o:q.width();r.h=p!==c?p:q.height();n.apply(this,arguments)}if($.isFunction(l)){n=l;return m}else{n=l.handler;l.handler=m}}};function g(){i=h[k](function(){a.each(function(){var n=$(this),m=n.width(),l=n.height(),o=$.data(this,d);if(m!==o.w||l!==o.h){n.trigger(j,[o.w=m,o.h=l])}});g()},e[b])}})($,window);

// svg 地图 画布
export function svgDrawMap(containerId, options) {
	// pagePath
	var pagePath = GlobalVariable.PAGE_PATH + '/static';

	//图元库
	var posiIconsObj = {};
	// 轨迹 外部方法 绘制静态图元
	var creatStaticPel;
	// 轨迹 外部方法 绘制静态图元
	var startMorePlay;

	var that = this,
		_that = this;
	
	var pageZoom = ChangeRatio();														// 调整浏览器显示比例【仅能查看】* body zoom
	var mapBaseWidth=8000,mapBaseHeight=3553,mapBaseWidthScale=4/0.025,mapBaseHeightScale=4/0.025;	//基础宽度，高度，宽度像素与毫米比,高度像素与毫米比,
	var base_people_width = 0.6,base_people_height = 0.6;								// 基础 人员大小
	var base_track_width = 0.36, base_track_height = 0.36;								// 基础 追踪图标大小
	var base_txt_oheight = 0.2;															// 基础 文本与人员头部距离
	var base_bs_width = 0.5,base_bs_height = 0.5;										// 基础 基站大小
	var base_camera_width = 0.5,base_camera_height = 0.5;								// 基础 摄像头大小
	var base_flagimg_width = 0.5,base_flagimg_height = 0.38;							// 基础 旗帜大小
	var base_toolkit_width = 0.5,base_toolkit_height = 0.5;								// 基础 工具柜大小

	// 当前区域 参数
	var mapWidth,mapHeight,mapUrl,mapWidthScale,mapHeightScale;			//地图信息
	var mapStartX = 0, mapStartY = 0;									// 坐标转换 相对地图 起始点 X, Y（一级区域 不起作用）
	var startPointX = 0, startPointY = 0;								// 地图原点 实际坐标
	var offsetX = 0, offsetY = 0;										// 地图原点相对于区域原点 偏移量 （offset + pStartPoint 相当于startPoint）
	var mapLevel = 2;													// 地图等级 1区域 2地图
	var mapInfo = {};													// 地图信息 option
	var ratioX = 0, ratioY = 0;											// x,y方向比率
	
	// 父级区域 参数
	var pHasMapFlag = false;											// 父级（区域）有地图
	var pStartPointX = 0, pStartPointY = 0;								// 父级（区域）起始点 实际坐标
	var pMapWidthScale, pMapHeightScale;								// 宽度比, 高度比
	// 相对于 父级区域 参数
	var pOffsetX = 0, pOffsetY = 0;										// 相对父级地图偏移量
	var scaleToPmapW = 1;												// 相对于父级地图 放大倍数 宽度
	var scaleToPmapH = 1;												// 相对于父级地图 放大倍数 高度

	// @param svg变量
	var mapX,mapY,svgWidth,svgHeight,svgImgScale,imgHeightWidthScale;
	var _initX = 0, _initY = 0;// 记录原始值
	var mapMove=true,mapZoom=true,minWidth,maxWidth,minHeight,maxHeight=450,zoomLength=50,zoomWidth=0;
	var autoZoomFlag = true;

	// 缩放限制
	var limitFlag = true;
	var boxHeight,boxWidth,boxHeightWidthScale;

	var paper,paperMap;													//画布
	
	var people_posi_img = pagePath + "/images/map/mapIcons-1/posi-xmarker-blue.png";				//人员定位图片 images/map/people_posi.png
	var people_alarm_img = pagePath + "/images/map/mapIcons-1/posi-xmarker-blue.gif";				//人员报警图片 images/map/people_alarm.png
	
	var white_people_posi_img = pagePath + '/images/map/mapIcons-1/people-white.png';			//人员 定位 图片 白色
	var white_people_alarm_img = pagePath + '/images/map/mapIcons-1/people-white.gif';			//人员 报警 图片 白色
	var red_people_posi_img = pagePath + '/images/map/mapIcons-1/people-red.png';				//人员 定位 图片 红色
	var red_people_alarm_img = pagePath + '/images/map/mapIcons-1/people-red.gif';				//人员 报警 图片 红色
	var yellow_people_posi_img = pagePath + '/images/map/mapIcons-1/people-yellow.png';			//人员 定位 图片 黄色
	var yellow_people_alarm_img = pagePath + '/images/map/mapIcons-1/people-yellow.gif';		//人员 报警 图片 黄色
	var people_off_img = pagePath + '/images/map/mapIcons-1/people-gray.png';					//人员 离线 图片
	
	var blue_xmarker_posi_img = pagePath + '/images/map/mapIcons-1/posi-xmarker-blue.png';			//人员 定位 图片 白色
	var blue_xmarker_alarm_img = pagePath + '/images/map/mapIcons-1/posi-xmarker-blue.gif';			//人员 报警 图片 白色
	var red_xmarker_posi_img = pagePath + '/images/map/mapIcons-1/posi-xmarker-red.png';				//人员 定位 图片 红色
	var red_xmarker_alarm_img = pagePath + '/images/map/mapIcons-1/posi-xmarker-red.gif';			//人员 报警 图片 红色
	var yellow_xmarker_posi_img = pagePath + '/images/map/mapIcons-1/posi-xmarker-yellow.png';		//人员 定位 图片 黄色
	var yellow_xmarker_alarm_img = pagePath + '/images/map/mapIcons-1/posi-xmarker-yellow.gif';		//人员 报警 图片 黄色
	var xmarker_off_img = pagePath + '/images/map/mapIcons-1/posi-xmarker-gray.png';					//人员 离线 图片
	
	var blue_car_posi_img = pagePath + '/images/map/mapIcons-1/car-blue.png';					//车辆 定位 图片 蓝色
	var blue_car_alarm_img = pagePath + '/images/map/mapIcons-1/car-blue.gif';					//车辆 报警 图片 蓝色
	var red_car_posi_img = pagePath + '/images/map/mapIcons-1/car-red.png';						//车辆 定位 图片 红色
	var red_car_alarm_img = pagePath + '/images/map/mapIcons-1/car-red.gif';					//车辆 报警 图片 红色
	var yellow_car_posi_img = pagePath + '/images/map/mapIcons-1/car-yellow.png';				//车辆 定位 图片 黄色
	var yellow_car_alarm_img = pagePath + '/images/map/mapIcons-1/car-yellow.gif';				//车辆 报警 图片 黄色
	var car_off_img = pagePath + '/images/map/mapIcons-1/car-gray.png';							//车辆 离线 图片
	
	// 隧道人员 blue
	var sdb_staff_posi_img = pagePath + '/images/map/suidaoIcons/blue_staff_normal.png';			// 隧道 工作人员 图片 定位
	var sdb_staff_sos_img = pagePath + '/images/map/suidaoIcons/blue_staff_normal.png';				// 隧道 工作人员 图片 求助报警
	var sdb_staff_lowpower_img = pagePath + '/images/map/suidaoIcons/blue_staff_lowpower.png';		// 隧道 工作人员 图片 低电报警
	var sdb_staff_alarm_img = pagePath + '/images/map/suidaoIcons/blue_staff_alarm.gif';			// 隧道 工作人员 图片 报警
	var sdb_staff_off_img = pagePath + '/images/map/suidaoIcons/blue_staff_off.png';				// 隧道 工作人员 图片 离线
	
	// 隧道人员 red
	var sdr_staff_posi_img = pagePath + '/images/map/suidaoIcons/red_staff_normal.png';				// 隧道 工作人员 图片 定位
	var sdr_staff_sos_img = pagePath + '/images/map/suidaoIcons/red_staff_normal.png';				// 隧道 工作人员 图片 求助报警
	var sdr_staff_lowpower_img = pagePath + '/images/map/suidaoIcons/red_staff_lowpower.png';		// 隧道 工作人员 图片 低电报警
	var sdr_staff_alarm_img = pagePath + '/images/map/suidaoIcons/red_staff_alarm.gif';				// 隧道 工作人员 图片 报警
	var sdr_staff_off_img = pagePath + '/images/map/suidaoIcons/red_staff_off.png';					// 隧道 工作人员 图片 离线
	
	// 车辆 car
	var car_posi_img = pagePath + '/images/map/mapIcons/car_normal.png';					// 车辆 图片 定位
	var car_lowpower_img = pagePath + '/images/map/mapIcons/car_lowpower.png';				// 车辆 图片 低电报警
	var car_alarm_img = pagePath + '/images/map/mapIcons/car_alarm.gif';					// 车辆 图片 报警
	var car_off_img = pagePath + '/images/map/mapIcons/car_off.png';						// 车辆 图片 离线
	
	// 车辆 天车吊钩
	var car_tc_posi_img = pagePath + '/images/map/mapIcons/car_tc_normal.png';					// 车辆 天车吊钩 图片 定位
	var car_tc_lowpower_img = pagePath + '/images/map/mapIcons/car_tc_lowpower.png';			// 车辆 天车吊钩 图片 低电报警
	var car_tc_alarm_img = pagePath + '/images/map/mapIcons/car_tc_alarm.gif';					// 车辆 天车吊钩 图片 报警
	var car_tc_off_img = pagePath + '/images/map/mapIcons/car_tc_off.png';						// 车辆 天车吊钩 图片 离线
	
	// 默认图元库 0：定位，1：报警, 4 离线, 5求助, 6 低电
	var people_imgs_default = {
		// 访客
		'1': {
			0: sdb_staff_posi_img,// 正常
			1: {
				5: sdb_staff_alarm_img,// 报警
				1: sdb_staff_sos_img,// 求助
				4: sdb_staff_off_img,// 离线
				7: sdb_staff_lowpower_img,// 低电
				'default': sdb_staff_alarm_img// 报警 默认
			}
		},
		// 施工人员
		'2': {
			0: sdb_staff_posi_img,// 正常
			1: {
				5: sdb_staff_alarm_img,// 报警
				1: sdb_staff_sos_img,// 求助
				4: sdb_staff_off_img,// 离线
				7: sdb_staff_lowpower_img,// 低电
				'default': sdb_staff_alarm_img// 报警 默认
			}
		},
		// 管理人员
		'3': {
			0: sdr_staff_posi_img,// 正常
			1: {
				5: sdr_staff_alarm_img,// 报警
				1: sdr_staff_sos_img,// 求助
				4: sdr_staff_off_img,// 离线
				7: sdr_staff_lowpower_img,// 低电
				'default': sdr_staff_alarm_img// 报警 默认
			}
		},
		// 施工
		'7': {
			0: sdb_staff_posi_img,// 正常
			1: {
				5: sdb_staff_alarm_img,// 报警
				1: sdb_staff_sos_img,// 求助
				4: sdb_staff_off_img,// 离线
				7: sdb_staff_lowpower_img,// 低电
				'default': sdb_staff_alarm_img// 报警 默认
			}
		},
		// 领导
		'8': {
			0: sdb_staff_posi_img,// 正常
			1: {
				5: sdb_staff_alarm_img,// 报警
				1: sdb_staff_sos_img,// 求助
				4: sdb_staff_off_img,// 离线
				7: sdb_staff_lowpower_img,// 低电
				'default': sdb_staff_alarm_img// 报警 默认
			}
		},
		// 访客
		'9': {
			0: sdb_staff_posi_img,// 正常
			1: {
				5: sdb_staff_alarm_img,// 报警
				1: sdb_staff_sos_img,// 求助
				4: sdb_staff_off_img,// 离线
				7: sdb_staff_lowpower_img,// 低电
				'default': sdb_staff_alarm_img// 报警 默认
			}
		},
		
		// 车辆 // --- 天车吊钩 ---
		'100': {
			0: car_posi_img,// 正常
			1: {
				5: car_alarm_img,// 报警
				4: car_off_img,// 离线
				7: car_lowpower_img,// 低电
				'default': car_alarm_img// 报警 默认
			}
		}
		
		/*
		'9': {
			0: blue_xmarker_posi_img,// 正常
			1: {
				5: blue_xmarker_alarm_img,// 报警
				1: blue_xmarker_alarm_img,// 求助
				4: blue_xmarker_alarm_img,// 离线
				7: blue_xmarker_alarm_img,// 低电
				'default': blue_xmarker_alarm_img// 报警 默认
			}
		},
		'7': {
			0: yellow_xmarker_posi_img,// 正常
			1: {
				5: yellow_xmarker_alarm_img,// 报警
				1: yellow_xmarker_alarm_img,// 求助
				4: yellow_xmarker_alarm_img,// 离线
				7: yellow_xmarker_alarm_img,// 低电
				'default': yellow_xmarker_alarm_img// 报警 默认
			}
		},
		'8': {
			0: red_xmarker_posi_img,// 正常
			1: {
				5: red_xmarker_alarm_img,// 报警
				1: red_xmarker_alarm_img,// 求助
				4: red_xmarker_alarm_img,// 离线
				7: red_xmarker_alarm_img,// 低电
				'default': red_xmarker_alarm_img// 报警 默认
			}
		}
		*/
	};

	var people_width = base_people_width * mapBaseWidthScale,
		people_height = base_people_height * mapBaseHeightScale;
	var cord_people_width = base_people_width * mapBaseWidthScale,
		cord_people_height = base_people_height * mapBaseHeightScale;

	var base_station_img=pagePath+"/images/map/base_station.png";		//基站图片
	var bs_width = base_bs_width * mapBaseWidthScale,
		bs_height = base_bs_height * mapBaseHeightScale;
	var cord_bs_width = base_bs_width * mapBaseWidthScale,
		cord_bs_height = base_bs_height * mapBaseHeightScale;

	var camera_img=pagePath+"/images/map/camera.png";					//摄像头图片
	var camera_width = base_camera_width * mapBaseWidthScale,
		camera_height = base_camera_height * mapBaseHeightScale;
	var cord_camera_width = base_camera_width * mapBaseWidthScale,
		cord_camera_height = base_camera_height * mapBaseHeightScale;

	var base_flagimg_img = pagePath + '/images/map/flag_50_38.png';		//旗帜 图片
	var flagimg_width = base_flagimg_width * mapBaseWidthScale,
		flagimg_height = base_flagimg_height * mapBaseHeightScale;
	var cord_flagimg_width = base_flagimg_width * mapBaseWidthScale,
		cord_flagimg_height = base_flagimg_height * mapBaseHeightScale;

	var toolkit_img=pagePath+"/images/map/base_station.png";		//工具柜图片
	var toolkit_width = base_toolkit_width * mapBaseWidthScale,
		toolkit_height = base_toolkit_height * mapBaseHeightScale;
	var cord_toolkit_width = base_toolkit_width * mapBaseWidthScale,
		cord_toolkit_height = base_toolkit_height * mapBaseHeightScale;

	var scaleX,scaleY,moveTime=2000;

	var offsetContX,//鼠标相对于容器 X 坐标
		offsetContY;//鼠标相对于容器 Y 坐标

	var offsetContX_draw,//鼠标相对于容器 X 坐标
		offsetContY_draw;//鼠标相对于容器 Y 坐标

	var move_point_start = pagePath + "/images/map/move_point_start.png";
	var move_point_posi = pagePath + "/images/map/move_point_posi.png";
	var move_point_alarm = pagePath + "/images/map/move_point_alarm.png";
	var move_point_end = pagePath + "/images/map/move_point_end.png";
	var move_point_width = 24,move_point_height = 24;

	var showPointMap = new HashMap();				//储存要显示的点
	var paperPointSetMap = new HashMap();			//显示轨迹点
	var movePointFlag = false;
	var currentMoveToPoint = 0;

	var dblclickPaper;  //双击svg地图
	var clickCameraImg; //点击摄像头  图元
    var clickBsImg;     // 点击基站 图元
    var clickTkImg;		// 点击工具柜 图元

	// 人员 变量
	var showPeopleMap = new HashMap();					// 显示人员map 数据
	var paperPeopleSetMap = new HashMap();				// 显示人员map svg
	var paperMovePeopleSetMap = new HashMap();			// 显示移动人员map svg
	// 文字
	var txt_oheight = base_txt_oheight * mapBaseHeightScale;					// 显示文字 与人员头部距离
	var cord_txt_oheight = base_txt_oheight * mapBaseHeightScale;					// 显示文字 与人员头部距离
	var showTxtMap = new HashMap();						// 显示文字map 数据
	var showTxtMap_black = new HashMap();				// 显示文字map 数据 黑名单
	var paperTxtSetMap = new HashMap();					// 显示文字map svg

	var peoplePosiNum = 0;
	var peopleAlarmNum = 0;

	var showRegionMap = new HashMap();					// 显示区域的map
	var lineMap = new HashMap();
	var circularImgMap = new HashMap();					// 点击点 圆

	// 追踪 变量
	var TRACKIMG = "TRACKIMG";
	var track_width = base_track_width * mapBaseWidthScale,
		track_height = base_track_height * mapBaseHeightScale;
	var cord_track_width = base_track_width * mapBaseWidthScale,
		cord_track_height = base_track_height * mapBaseHeightScale;
	var track_img = pagePath + "/images/map/icon_track_arrow.gif";			//跟踪 图标
	var showTrackImgMap = new HashMap();				// 跟踪的定位信息
	var paperTrackImgSetMap = new HashMap();				// 显示跟踪图标 svg

	// 轨迹 HashMap 变量
	var showPeopleTrackMap = new HashMap();				// 存储轨迹人员 位置 信息 数据
	var showLinePointsData = [];						// 显示 轨迹线 数据
	var paperLineSetMap = new HashMap();				// 显示 轨迹线 svg
	var TRACKLINE = 'TRACKLINE';

	// 实心圆 变量
	var paperDiscSetMap = new HashMap();				// 显示 实心圆
	var discImgMap = new HashMap();						// 缓存  数据值  实心圆
	var DISCID = 'DISCID';								// 缓存实心圆 数据 key
	var canDrawDisc = false;							// 双击svg 地图  画实心圆 flag
	var callBack_drawDisc;								// 回调  双击svg地图 实心圆

	// 电子围栏 变量
	var paperCircleMap = new HashMap();					// 缓存  点  电子围栏
	var paperLineMap = new HashMap();					// 缓存  线  电子围栏
	var displaceX = 0, displaceY = 0;					// 位移 X Y
	var pointGroup = [];								// 存储  坐标点
	var realPointGroup = [];								// 存储  坐标点 real
	var canDrawPoints = false;							// 双击svg 地图  画电子围栏 flag
	var canClosePoints = true;							// 电子围栏 是否可闭合
	var callBack_drawPoints;							// 回调  双击svg地图 实心圆

	// 电子围栏 list 变量
	var showRailMap = new HashMap();					// 显示所有基站 数据
	var paperRailSetMap = new HashMap();				// 显示所有基站 svg

	// 自定义区域 list 变量
	var inFingerDraw = false;							// 正在自定义绘制
	var showFingerRailMap = new HashMap();				// 显示所有 自定义区域 数据
	var paperFingerRailSetMap = new HashMap();			// 显示所有 自定义区域 svg

	// 虚线
	var showDottedLineMap = new HashMap();				// 显示所有 虚线 数据
	var paperDottedLineMap = new HashMap();				// 显示所有 虚线 svg
	var paperDottedTxtMap = new HashMap();				// 显示所有 虚线 txt svg

	// 圆点 变量
	var showDotsMap = new HashMap();					// 显示所有圆点 数据
	var paperDotsSetMap = new HashMap();				// 显示所有圆点 svg
	var paperDotTxtSetMap = new HashMap();				// 显示所有圆点 txt svg

	// 基站 变量
	var showStationMap = new HashMap();					// 显示所有基站 数据
	var paperStationSetMap = new HashMap();				// 显示所有基站 svg
	var paperBsTxtSetMap = new HashMap();				// 显示所有基站 txt svg

	// 摄像头 变量
	var showCamerasMap = new HashMap();					// 显示所有摄像头 数据
	var paperCamerasSetMap = new HashMap();				// 显示所有摄像头 svg

	// 旗帜 变量
	var showFlagimgMap = new HashMap();					// 显示所有旗帜 数据
	var paperFlagimgSetMap = new HashMap();				// 显示所有旗帜 svg
	var paperFlagTxtSetMap = new HashMap();				// 显示所有旗帜 txt svg

	// 工具柜 变量
	var showToolkitMap = new HashMap();					// 显示所有工具柜 数据
	var paperToolkitSetMap = new HashMap();				// 显示所有工具柜 svg
	var paperToolkitTxtSetMap = new HashMap();			// 显示所有工具柜 txt svg

	// 刻度尺 变量
	var showRuleLinesMap = new HashMap();				// 显示所有刻度尺 数据
	var paperRuleLinesSetMap = new HashMap();			// 显示所有刻度尺 svg
	var paperRuleLineTxtSetMap = new HashMap();			// 显示所有刻度尺 txt svg
	var map_cord_ruleLine = new HashMap();				// 记录刻度尺数据
	
	// 比例 变量
	var showScaleFlag = false;							// flag 允许显示 地图比例
	var SCALELINE = 'SCALELINE';						// key 比例坐标系
	var showScaleLinesMap = new HashMap();				// 显示所有比例 数据
	var paperScaleLinesSetMap = new HashMap();			// 显示所有比例 svg
	var paperScaleLineTxtSetMap = new HashMap();		// 显示所有比例 txt svg

	// 变量 实时轨迹
	var showIntimeLineMap = new HashMap();				// 缓存 展示实时轨迹线
	var paperIntimeLineSetMap = new HashMap();			// 缓存 展示实时轨迹线
	var flag_intime_line = false;						// 开关 展示 实时轨迹
	var intimeLineKey = 'INTIME_';						// 起始字符 展示 实时轨迹

	var isChangeContH = false;//!options || options.changeContH === undefined ? true : options.changeContH;			//是否改变容器高度
	var isChangeBodyH = false;//!options || options.changeBodyH === undefined ? true : options.changeBodyH;			//是否改变body高度

	var loadData;// svg 动作后 回调 loadData

	// 基站状态
	var bsStates = {0: '未安装', 1: '在线', 2: '离线'};
	// 工具柜状态
	var tkStates = {0: '未安装', 1: '离线', 2: '在线', 3: '报警'};

	// 播放状态
	var playFlag = false;

	// 获取人员图元icon
	this.getDefaultPeopleImgs = function () {
		return $.extend({}, people_imgs_default);
	};

	/**
	 * TODO 设置svg地图 缩放/拖拽限制
	 * @param _limitFlag 限制状态
	 */
	this.setLimitState = function (_limitFlag) {
		limitFlag = _limitFlag && true;
	};

	/**
	 * 地图 参数 必要
	 *
	 * @pram option obj {}
	 * @param option key
	 */
	this.setMapParams = function (option) {
		
		// 空值 中止
		if(isItEmpty(option)) return false;
		
		// 记录地图信息
		mapInfo = !isItEmpty( option ) ? Object.assign({}, option) : {};
		
		// 当前 地图信息  参数
		mapHeight = !isItEmpty( option.mapHeight ) ? parseFloat( option.mapHeight ) : mapHeight;
		mapWidth = !isItEmpty( option.mapWidth ) ? parseFloat( option.mapWidth ) : mapWidth;
		mapUrl = !isItEmpty( option.mapUrl ) ? option.mapUrl : mapUrl;
		mapLevel = !isItEmpty( option.mapLevel ) ? option.mapLevel : 2;
		
		mapWidthScale = !isItEmpty( option.widthScale ) ? option.widthScale : mapWidthScale;
		mapHeightScale = !isItEmpty( option.heightScale ) ? option.heightScale : mapHeightScale;
		
		mapWidthScale = !isItEmpty( option.scaleX ) ? option.scaleX : mapWidthScale;
		mapHeightScale = !isItEmpty( option.scaleY ) ? option.scaleY : mapHeightScale;
		scaleX = !isItEmpty( option.scaleX ) ? option.scaleX : scaleX;
		scaleY = !isItEmpty( option.scaleY ) ? option.scaleY : scaleY;

		// 相对于父级区域 参数  宽度比, 高度比 （一级区域 不起作用） 值等于 当前地图 宽度比、高度比 == 不起作用
		pMapWidthScale = !isItEmpty( option.pMapWidthScale ) ? option.pMapWidthScale : mapWidthScale;
		pMapHeightScale = !isItEmpty( option.pMapHeightScale ) ? option.pMapHeightScale : mapHeightScale;
		// 相对于父级区域 参数  偏移量 X, Y （一级区域 不起作用） 值为0 == 不起作用
		pOffsetX = !isItEmpty( option.parentMapStartX ) ? parseFloat( option.parentMapStartX ) : 0;
		pOffsetY = !isItEmpty( option.parentMapStartY ) ? parseFloat( option.parentMapStartY ) : 0;

		// 相对一级地图 起始点 X, Y（一级区域 不起作用） 值为0 == 不起作用
		//mapStartX = pOffsetX != 0 ? parseFloat( option.mapStartX ) : 0;
		//mapStartY = pOffsetY != 0 ? parseFloat( option.mapStartY ) : 0;
		mapStartX = !isItEmpty( option.startPointXPx ) ? parseFloat( option.startPointXPx ) : 0;
		mapStartY = !isItEmpty( option.startPointYPx ) ? parseFloat( option.startPointYPx ) : 0;
		
		// 地图原点 实际坐标
		startPointX = !isItEmpty( option.startPointX ) ? parseFloat( option.startPointX ) : 0;
		startPointY = !isItEmpty( option.startPointY ) ? parseFloat( option.startPointY ) : 0;
		// 地图原点相对于区域原点 偏移量 （offset + pStartPoint 相当于startPoint）
		offsetX = !isItEmpty( option.offsetX ) ? parseFloat( option.offsetX ) : 0;
		offsetY = !isItEmpty( option.offsetY ) ? parseFloat( option.offsetY ) : 0;
		// 父级（区域）起始点 实际坐标
		pStartPointX = !isItEmpty( option.pStartPointX ) ? parseFloat( option.pStartPointX ) : 0;
		pStartPointY = !isItEmpty( option.pStartPointY ) ? parseFloat( option.pStartPointY ) : 0;
		// 父级（区域）有地图
		pHasMapFlag = option.pHasMapFlag && true;
		
		// 换算 当前地图 相对于 父级地图 放大倍数 宽度
		if( !isItEmpty( option.widthScale ) ) {

			var mapWidthScales = mapWidthScale.split('/'),
				mapWidthScaleN = parseFloat( mapWidthScales[0] ) / parseFloat( mapWidthScales[1] );
			var pMapWidthScales = pMapWidthScale.split('/'),
				pMapWidthScaleN = parseFloat( pMapWidthScales[0] ) / parseFloat( pMapWidthScales[1] );
			scaleToPmapW = ( mapWidthScaleN / pMapWidthScaleN );

			// 图元尺寸
			people_width = parseInt( (base_people_width * mapWidthScaleN) );				// 人员图元 宽度
			track_width = parseInt( (base_track_width * mapWidthScaleN) );					// 追踪图标 宽度
			bs_width = parseInt( (base_bs_width * mapWidthScaleN) );						// 基站图元 宽度
			camera_width = parseInt( (base_camera_width * mapWidthScaleN) );				// 摄像头图元 宽度
			flagimg_width = parseInt( (base_flagimg_width * mapWidthScaleN) );				// 旗帜图元 宽度
			toolkit_width = parseInt( (base_toolkit_width * mapWidthScaleN) );				// 工具柜图元 宽度

			// 图元尺寸 记录
			cord_people_width = parseInt( (base_people_width * mapWidthScaleN) );			// 人员图元 宽度
			cord_track_width = parseInt( (base_track_width * mapWidthScaleN) );				// 追踪图标 宽度
			cord_bs_width = parseInt( (base_bs_width * mapWidthScaleN) );					// 基站图元 宽度
			cord_camera_width = parseInt( (base_camera_width * mapWidthScaleN) );			// 摄像头图元 宽度
			cord_flagimg_width = parseInt( (base_flagimg_width * mapWidthScaleN) );			// 旗帜图元 宽度
			cord_toolkit_width = parseInt( (base_toolkit_width * mapWidthScaleN) );			// 工具柜图元 宽度

		} else {

			scaleToPmapW = 1;

			// 图元尺寸 记录
			people_width = parseInt( (base_people_width * mapBaseWidthScale) );					// 人员图元 宽度
			track_width = parseInt( (base_track_width * mapBaseWidthScale) );					// 追踪图标 宽度
			bs_width = parseInt( (base_bs_width * mapBaseWidthScale) );							// 基站图元 宽度
			camera_width = parseInt( (base_camera_width * mapBaseWidthScale) );					// 摄像头图元 宽度
			flagimg_width = parseInt( (base_flagimg_width * mapBaseWidthScale) );				// 旗帜图元 宽度
			toolkit_width = parseInt( (base_toolkit_width * mapBaseWidthScale) );				// 工具柜图元 宽度

			// 图元尺寸
			cord_people_width = parseInt( (base_people_width * mapBaseWidthScale) );			// 人员图元 宽度
			cord_track_width = parseInt( (base_track_width * mapBaseWidthScale) );				// 追踪图标 宽度
			cord_bs_width = parseInt( (base_bs_width * mapBaseWidthScale) );					// 基站图元 宽度
			cord_camera_width = parseInt( (base_camera_width * mapBaseWidthScale) );			// 摄像头图元 宽度
			cord_flagimg_width = parseInt( (base_flagimg_width * mapBaseWidthScale) );			// 旗帜图元 宽度
			cord_toolkit_width = parseInt( (base_toolkit_width * mapBaseWidthScale) );			// 工具柜图元 宽度

		}

		// 换算 当前地图 相对于 父级地图 放大倍数 高度
		if( !isItEmpty( option.heightScale ) ) {

			var mapHeightScales = mapHeightScale.split('/'),
				mapHeightScaleN = parseFloat( mapHeightScales[0] ) / parseFloat( mapHeightScales[1] );
			var pMapHeightScales = pMapHeightScale.split('/'),
				pMapHeightScaleN = parseFloat( pMapHeightScales[0] ) / parseFloat( pMapHeightScales[1] );
			scaleToPmapH = ( mapHeightScaleN / pMapHeightScaleN );

			// 图元尺寸
			people_height = parseInt( (base_people_height * mapHeightScaleN) );				// 人员图元 高度
			track_height = parseInt( (base_track_height * mapHeightScaleN) );				// 追踪图标 高度
			// 文字
			txt_oheight = parseInt( (base_txt_oheight * mapHeightScaleN) );					// 显示文字 与人员头部距离
			bs_height = parseInt( (base_bs_height * mapHeightScaleN) );						// 基站图元 高度
			camera_height = parseInt( (base_camera_height * mapHeightScaleN) );				// 摄像头图元 高度
			// 旗帜
			flagimg_height = parseInt( (base_flagimg_height * mapHeightScaleN) );			// 旗帜图元 高度
			toolkit_height = parseInt( (base_toolkit_height * mapHeightScaleN) );			// 工具柜图元 高度

			// 图元尺寸 记录
			cord_people_height = parseInt( (base_people_height * mapHeightScaleN) );		// 人员图元 高度
			cord_track_height = parseInt( (base_track_height * mapHeightScaleN) );			// 追踪图标 高度
			// 文字
			cord_txt_oheight = parseInt( (base_txt_oheight * mapHeightScaleN) );			// 显示文字 与人员头部距离
			cord_bs_height = parseInt( (base_bs_height * mapHeightScaleN) );				// 基站图元 高度
			cord_camera_height = parseInt( (base_camera_height * mapHeightScaleN) );		// 摄像头图元 高度
			// 旗帜
			cord_flagimg_height = parseInt( (base_flagimg_height * mapHeightScaleN) );		// 旗帜图元 高度
			cord_toolkit_height = parseInt( (base_toolkit_height * mapHeightScaleN) );		// 工具柜图元 高度

		} else {

			scaleToPmapH = 1;

			// 图元尺寸
			people_height = parseInt( (base_people_height * mapBaseHeightScale) );			// 人员图元 高度
			track_height = parseInt( (base_track_height * mapBaseHeightScale) );			// 追踪图标 高度
			// 文字
			txt_oheight = parseInt( (base_txt_oheight * mapBaseHeightScale) );				// 显示文字 与人员头部距离
			bs_height = parseInt( (base_bs_height * mapBaseHeightScale) );					// 基站图元 高度
			camera_height = parseInt( (base_camera_height * mapBaseHeightScale) );			// 摄像头图元 高度
			// 旗帜
			flagimg_height = parseInt( (base_flagimg_height * mapBaseHeightScale) );		// 旗帜图元 高度
			toolkit_height = parseInt( (base_toolkit_height * mapBaseHeightScale) );		// 工具柜图元 高度

			// 图元尺寸 记录
			cord_people_height = parseInt( (base_people_height * mapBaseHeightScale) );		// 人员图元 高度
			cord_track_height = parseInt( (base_track_height * mapBaseHeightScale) );		// 追踪图标 高度
			// 文字
			cord_txt_oheight = parseInt( (base_txt_oheight * mapBaseHeightScale) );			// 显示文字 与人员头部距离
			cord_bs_height = parseInt( (base_bs_height * mapBaseHeightScale) );				// 基站图元 高度
			cord_camera_height = parseInt( (base_camera_height * mapBaseHeightScale) );		// 摄像头图元 高度
			// 旗帜
			cord_flagimg_height = parseInt( (base_flagimg_height * mapBaseHeightScale) );	// 旗帜图元 高度
			cord_toolkit_height = parseInt( (base_toolkit_height * mapBaseHeightScale) );	// 工具柜图元 高度

		}

	};// setMapParams
	
	/**
	 * 地图 参数 必要
	 *
	 * @pram option obj {}
	 * @param option key
	 */
	this.setMapParam = function (option) {

		// 空值 中止
		if(isItEmpty(option)) return false;
		
		if (option.mkey == 'scale') {
			// 参数 比例
			mapWidthScale = !isItEmpty( option.widthScale ) ? option.widthScale : mapWidthScale;
			mapHeightScale = !isItEmpty( option.heightScale ) ? option.heightScale : mapHeightScale;
			
			mapWidthScale = !isItEmpty( option.scaleX ) ? option.scaleX : mapWidthScale;
			mapHeightScale = !isItEmpty( option.scaleY ) ? option.scaleY : mapHeightScale;
			scaleX = !isItEmpty( option.scaleX ) ? option.scaleX : scaleX;
			scaleY = !isItEmpty( option.scaleY ) ? option.scaleY : scaleY;
			
			// 相对于父级区域 参数  宽度比, 高度比 （一级区域 不起作用） 值等于 当前地图 宽度比、高度比 == 不起作用
			pMapWidthScale = !isItEmpty( option.pMapWidthScale ) ? option.pMapWidthScale : mapWidthScale;
			pMapHeightScale = !isItEmpty( option.pMapHeightScale ) ? option.pMapHeightScale : mapHeightScale;
			
			// 换算 当前地图 相对于 父级地图 放大倍数 宽度
			if( !isItEmpty( option.widthScale ) ) {
	
				var mapWidthScales = mapWidthScale.split('/'),
					mapWidthScaleN = parseFloat( mapWidthScales[0] ) / parseFloat( mapWidthScales[1] );
				var pMapWidthScales = pMapWidthScale.split('/'),
					pMapWidthScaleN = parseFloat( pMapWidthScales[0] ) / parseFloat( pMapWidthScales[1] );
				scaleToPmapW = ( mapWidthScaleN / pMapWidthScaleN );
	
				// 图元尺寸
				people_width = parseInt( (base_people_width * mapWidthScaleN) );				// 人员图元 宽度
				track_width = parseInt( (base_track_width * mapWidthScaleN) );					// 追踪图标 宽度
				bs_width = parseInt( (base_bs_width * mapWidthScaleN) );						// 基站图元 宽度
				camera_width = parseInt( (base_camera_width * mapWidthScaleN) );				// 摄像头图元 宽度
				flagimg_width = parseInt( (base_flagimg_width * mapWidthScaleN) );				// 旗帜图元 宽度
				toolkit_width = parseInt( (base_toolkit_width * mapWidthScaleN) );				// 工具柜图元 宽度
	
				// 图元尺寸 记录
				cord_people_width = parseInt( (base_people_width * mapWidthScaleN) );			// 人员图元 宽度
				cord_track_width = parseInt( (base_track_width * mapWidthScaleN) );				// 追踪图标 宽度
				cord_bs_width = parseInt( (base_bs_width * mapWidthScaleN) );					// 基站图元 宽度
				cord_camera_width = parseInt( (base_camera_width * mapWidthScaleN) );			// 摄像头图元 宽度
				cord_flagimg_width = parseInt( (base_flagimg_width * mapWidthScaleN) );			// 旗帜图元 宽度
				cord_toolkit_width = parseInt( (base_toolkit_width * mapWidthScaleN) );			// 工具柜图元 宽度
	
			}
			
			// 换算 当前地图 相对于 父级地图 放大倍数 高度
			if( !isItEmpty( option.heightScale ) ) {
	
				var mapHeightScales = mapHeightScale.split('/'),
					mapHeightScaleN = parseFloat( mapHeightScales[0] ) / parseFloat( mapHeightScales[1] );
				var pMapHeightScales = pMapHeightScale.split('/'),
					pMapHeightScaleN = parseFloat( pMapHeightScales[0] ) / parseFloat( pMapHeightScales[1] );
				scaleToPmapH = ( mapHeightScaleN / pMapHeightScaleN );
	
				// 图元尺寸
				people_height = parseInt( (base_people_height * mapHeightScaleN) );				// 人员图元 高度
				track_height = parseInt( (base_track_height * mapHeightScaleN) );				// 追踪图标 高度
				// 文字
				txt_oheight = parseInt( (base_txt_oheight * mapHeightScaleN) );					// 显示文字 与人员头部距离
				bs_height = parseInt( (base_bs_height * mapHeightScaleN) );						// 基站图元 高度
				camera_height = parseInt( (base_camera_height * mapHeightScaleN) );				// 摄像头图元 高度
				// 旗帜
				flagimg_height = parseInt( (base_flagimg_height * mapHeightScaleN) );			// 旗帜图元 高度
				toolkit_height = parseInt( (base_toolkit_height * mapHeightScaleN) );			// 工具柜图元 高度
	
				// 图元尺寸 记录
				cord_people_height = parseInt( (base_people_height * mapHeightScaleN) );		// 人员图元 高度
				cord_track_height = parseInt( (base_track_height * mapHeightScaleN) );			// 追踪图标 高度
				// 文字
				cord_txt_oheight = parseInt( (base_txt_oheight * mapHeightScaleN) );			// 显示文字 与人员头部距离
				cord_bs_height = parseInt( (base_bs_height * mapHeightScaleN) );				// 基站图元 高度
				cord_camera_height = parseInt( (base_camera_height * mapHeightScaleN) );		// 摄像头图元 高度
				// 旗帜
				cord_flagimg_height = parseInt( (base_flagimg_height * mapHeightScaleN) );		// 旗帜图元 高度
				cord_toolkit_height = parseInt( (base_toolkit_height * mapHeightScaleN) );		// 工具柜图元 高度
	
			}
			
			// 创建比例图标
			creatScaleLineImg();
			
			return false;
		}// option.mkey == 'scale'

	};// this.setMapParam
	
	/**
	 * svg
	 * 方法 重置图元尺寸
	 */
	function resetImgSize() {

		// 人员图元 宽度
		people_width = cord_people_width * svgImgScale < 30 ? parseInt(30 / svgImgScale) : cord_people_width * svgImgScale > 40 ? parseInt(40 / svgImgScale) : cord_people_width;
		// 追踪图标 宽度
		track_width = cord_track_width * svgImgScale < 18 ? parseInt(18 / svgImgScale) : cord_track_width * svgImgScale > 27 ? parseInt(27 / svgImgScale) : cord_track_width;
		// 基站图元 宽度
		bs_width = cord_bs_width * svgImgScale < 20 ? parseInt(20 / svgImgScale) : cord_bs_width * svgImgScale > 40 ? parseInt(40 / svgImgScale) : cord_bs_width;
		// 摄像头图元 宽度
		camera_width = cord_camera_width * svgImgScale < 15 ? parseInt(15 / svgImgScale) : cord_camera_width * svgImgScale > 20 ? parseInt(20 / svgImgScale) : cord_camera_width;
		// 旗帜图元 宽度
		flagimg_width = cord_flagimg_width * svgImgScale < 15 ? parseInt(15 / svgImgScale) : cord_flagimg_width * svgImgScale > 35 ? parseInt(35 / svgImgScale) : cord_flagimg_width;
		// 工具柜图元 宽度
		toolkit_width = cord_toolkit_width * svgImgScale < 20 ? parseInt(20 / svgImgScale) : cord_toolkit_width * svgImgScale > 20 ? parseInt(20 / svgImgScale) : cord_toolkit_width;

		// 人员图元 高度
		people_height = cord_people_height * svgImgScale < 30 ? parseInt(30 / svgImgScale) : cord_people_height * svgImgScale > 40 ? parseInt(40 / svgImgScale) : cord_people_height;
		// 追踪图标 高度
		track_height = cord_track_height * svgImgScale < 18 ? parseInt(18 / svgImgScale) : cord_track_height * svgImgScale > 27 ? parseInt(27 / svgImgScale) : cord_track_height;
		// 基站图元 高度
		bs_height = cord_bs_height * svgImgScale < 20 ? parseInt(20 / svgImgScale) : cord_bs_height * svgImgScale > 40 ? parseInt(40 / svgImgScale) : cord_bs_height;
		// 摄像头图元 高度
		camera_height = cord_camera_height * svgImgScale < 15 ? parseInt(15 / svgImgScale) : cord_camera_height * svgImgScale > 20 ? parseInt(20 / svgImgScale) : cord_camera_height;
		// 旗帜图元 高度
		flagimg_height = cord_flagimg_height * svgImgScale < 15 ? parseInt(15 / svgImgScale) : cord_flagimg_height * svgImgScale > 35 ? parseInt(35 / svgImgScale) : cord_flagimg_height;
		// 工具柜图元 高度
		toolkit_height = cord_toolkit_height * svgImgScale < 20 ? parseInt(20 / svgImgScale) : cord_toolkit_height * svgImgScale > 20 ? parseInt(20 / svgImgScale) : cord_toolkit_height;

	};
	
	// ============================= real map 坐标转换 start =============================
	/**
	 * @Des 坐标转换  to 地图坐标
	 * @Auth
	 * @Date 
	 */
	function transToMap (point, type) {
		// 空值 中止
		if (
			isItEmpty(point) || 
			(type == 'X' && isItEmpty(mapWidthScale)) || 
			(type == 'Y' && isItEmpty(mapHeightScale))
		) {
			return NaN;
		}
		
		// 新数据
		var currPoint;
		if (type == 'Y') {
			// 坐标转换 Y
			
			// scaleY
			var scaleYs = mapHeightScale.split('/');
			scaleYs[0] = parseFloat( scaleYs[0] );
			scaleYs[1] = parseFloat( scaleYs[1] );
			
			if (pHasMapFlag) {
				currPoint = ( parseFloat(point) - (offsetY + pStartPointY) ) * scaleYs[0] / scaleYs[1] + mapStartY;
			} else {
				currPoint = ( parseFloat(point) - startPointY ) * scaleYs[0] / scaleYs[1] + mapStartY;
			}
		} else {
			// 坐标转换 X
			
			// scaleX
			var scaleXs = mapWidthScale.split('/');
			scaleXs[0] = parseFloat( scaleXs[0] );
			scaleXs[1] = parseFloat( scaleXs[1] );
			
			if (pHasMapFlag) {
				currPoint = ( parseFloat(point) - (offsetX + pStartPointX) ) * scaleXs[0] / scaleXs[1] + mapStartX;
			} else {
				currPoint = ( parseFloat(point) - startPointX ) * scaleXs[0] / scaleXs[1] + mapStartX;
			}
		}
		
		return parseInt(currPoint);
	}// transToMap
	
	/**
	 * @Des 坐标转换 to 实际坐标
	 * @Auth
	 * @Date 
	 */
	function transToReal (point, type) {
		// 空值 中止
		if (
			isItEmpty(point) ||
			(type == 'X' && isItEmpty(mapWidthScale)) || 
			(type == 'Y' && isItEmpty(mapHeightScale))
		) {
			return NaN;
		}
		
		// 新数据
		var currPoint;
		if (type == 'Y') {
			// 坐标转换 Y
			
			// scaleY
			var scaleYs = mapHeightScale.split('/');
			scaleYs[0] = parseFloat( scaleYs[0] );
			scaleYs[1] = parseFloat( scaleYs[1] );
			
			if (pHasMapFlag) {
				currPoint = ( parseFloat(point) - mapStartY ) * scaleYs[1] / scaleYs[0] + (offsetY + pStartPointY);
			} else {
				currPoint = ( parseFloat(point) - mapStartY ) * scaleYs[1] / scaleYs[0] + startPointY;
			}
		} else {
			// 坐标转换 X
			
			// scaleX
			var scaleXs = mapWidthScale.split('/');
			scaleXs[0] = parseFloat( scaleXs[0] );
			scaleXs[1] = parseFloat( scaleXs[1] );
			
			if (pHasMapFlag) {
				currPoint = ( parseFloat(point) - mapStartX ) * scaleXs[1] / scaleXs[0] + (offsetX + pStartPointX);
			} else {
				currPoint = ( parseFloat(point) - mapStartX ) * scaleXs[1] / scaleXs[0] + startPointX;
			}
		}
		
		return currPoint.toFixed(3);
	}// transToReal
	// ============================= real map 坐标转换 end =============================
	
	/**
	 * svg
	 * 方法 销毁svg
	 */
	this.destroySvg = function () {

		if(paper){
			paper.remove();
			paper = null;
		}
		// 关闭滚轮事件
		offWheelDelta();

	};

	/**
	 * 实心圆
	 * 设置 可否双击 svg 地图 取点
	 *
	 * @pram flag true: 可双击取点 false: 不可双击取点
	 */
	this.allowDrawDisc = function (flag, callBack) {
		canDrawPoints = false;	// 电子围栏

		// 实心圆
		canDrawDisc = flag && true;
		// 回调
		callBack_drawDisc = callBack;

		var cursorStyle = canDrawDisc ? 'crosshair' : 'pointer';
		paperMap && paperMap.attr({'cursor': cursorStyle});
	};

	/**
	 * 实心圆
	 * 获取 点集合
	 */
	this.getDrawDisc = function () {
		return discImgMap.get(DISCID);
	};

	/**
	 * 电子围栏
	 * 设置 可否双击 svg 地图 取点
	 *
	 * @pram flag true: 可双击取点 false: 不可双击取点
	 */
	this.allowDrawPoints = function (flag, callBack, lineObj) {

		canDrawDisc = false;	// 实心圆

		// 电子围栏
		canDrawPoints = flag && true;
		// 回调
		callBack_drawPoints = callBack;

		if(!isItEmpty(lineObj) && !isItEmpty(lineObj.color)) {

			lineColor = lineObj.color;

		}
		if(!isItEmpty(lineObj) && !isItEmpty(lineObj.width)) {
			lineWidth = lineObj.width;
		}
		if(!isItEmpty(lineObj) && !isItEmpty(lineObj.limitDis)) {
			limitDis = lineObj.limitDis;
		}

		var cursorStyle = canDrawPoints ? 'crosshair' : 'pointer';
		paperMap && paperMap.attr({'cursor': cursorStyle});

		// 清除 虚线
		that.clearDottedLine('DOTTEED_Line', 'destroy');
		if (canDrawPoints) {
			// 绑定事件
			$('#' + containerId)[0].addEventListener('mousemove', moveToDotted, false);
		} else {
			// 移除事件
			$('#' + containerId)[0].removeEventListener('mousemove', moveToDotted);
		}

	};

	/**
	 * 电子围栏
	 * 获取 点集合
	 */
	this.getDrowPoints = function () {
		//return Object.assign([], pointGroup);
		return Object.assign([], realPointGroup);
	};

	/**
	 * 电子围栏
	 * 设置 点集合 []
	 */
	this.setPointGroupData = function (pointGroupData, lineObj) {

		realPointGroup = Object.assign([], pointGroupData);
		pointGroup = [];
		$.each(pointGroupData, (index, poinXY) => {
			// 空值 跳过
			if (isItEmpty(poinXY)) {
				return true;
			}
			var point = poinXY.split(',');
			
			var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: point[0],y: point[1]}, ratioX, ratioY);
			var x = pointPx.xPx;// transToMap(point[0], 'X');
			var y = pointPx.yPx;// transToMap(point[1], 'Y');
			pointGroup.push([x, y].join(','));
		});
		

		if(!isItEmpty(lineObj) && !isItEmpty(lineObj.color)) {

			lineColor = lineObj.color;

		}
		if(!isItEmpty(lineObj) && !isItEmpty(lineObj.width)) {
			lineWidth = lineObj.width;
		}

		// 清除 虚线
		that.clearDottedLine('DOTTEED_Line', 'destroy');
	};
	
	// 设置 loadData 回调
	this.setLoadData = function (Fn) {

		var isFn = typeof Fn == 'function';

		if(isFn) {

			loadData = Fn;

		} else {

			console.log('请传入 function');

		}

	};


	/**
	 * 绑定事件
	 */
	(function initEvents() {

		//鼠标移动，记录光标相对 #'+ containerId +' 位置
		/*$("body").on('mousemove', '#'+ containerId, function(e){
			offsetContX_draw = e.offsetX / pageZoom;
			offsetContY_draw = e.offsetY / pageZoom;
		});*/

		// 监听 窗口改变
		/*$(window).resize(function(){
			if(paper){
				that.initSvg();
				if(typeof creatStaticPel == 'function'){
					//绘制静态图元
					var flag = creatStaticPel();
		        	if(flag){
		        		startMorePlay();
		        	}
				}
			}

		});*/

		$(function () {
			// 监听 窗口改变
			$('#'+ containerId).resize(function(){
				// 调整浏览器显示比例【仅能查看】* body zoom
				pageZoom = ChangeRatio();
				
				if(paper){
					that.initSvg();
					if(typeof creatStaticPel == 'function'){
						//绘制静态图元
						var flag = creatStaticPel();
			        	if(flag){
			        		startMorePlay();
			        	}
					}
				}

			});
		});

	})();



	/**
	 * 初始化svg
	 */
	this.initSvg = function (initX, initY) {

		// 可自动缩放
		autoZoomFlag = true;

		var $body = $("body"),
			$container = $('#'+ containerId);
		$body.css({"height":"100%"});

		imgHeightWidthScale = mapHeight/mapWidth;						//图片高宽比
		if(imgHeightWidthScale <= 1 || isChangeContH){
			// 图片 宽大于高
			minWidth = $container.width();								//svg最小宽度
			maxWidth = mapWidth * 2;									//svg最大宽度
			svgWidth = minWidth;										//svg初始最小宽度
			svgHeight = svgWidth * imgHeightWidthScale;					//svg初始最小高度
			minHeight = svgHeight;
		}else{
			// 图片高大于宽
			if($container.outerHeight() < $container.parent('div').height()){
				$container.css("height", $container.parent('div').height() + 'px');
			}
			minHeight = $container.height();							//svg最小宽度
			maxHeight = minHeight * 2;
			maxWidth = maxHeight / imgHeightWidthScale;					//svg最大宽度
			svgHeight = minHeight;										//svg初始最小宽度
			svgWidth =  svgHeight / imgHeightWidthScale;				//svg初始最小高度
			minWidth = svgWidth;
		}

		if(isChangeContH){
			//重置body高度
			var bodyHeight = $body.height();
			var oldH_container = $container.css({"height":"100%"}).height();
			var new_body_height = bodyHeight + (minHeight - oldH_container);
			var win_height = $(window).height();
			new_body_height = new_body_height >= win_height ? new_body_height : win_height;
			$body.height(new_body_height);
		}

		if(minHeight < 400){
			//$container.css("height",'400px');
		}else if(isChangeContH){
			$container.css("height",minHeight + 10);
		}
		if($container.outerHeight() < $container.parent('div').height()){
			$container.css("height", $container.parent('div').height() + 'px');
		}
		boxHeight = $('#'+ containerId).height();
		boxWidth = $('#'+ containerId).width();
		boxHeightWidthScale = boxHeight/boxWidth;

		// 显示在box之中
		if (imgHeightWidthScale <= boxHeightWidthScale) {
			// 比例 图片宽 大于 视图宽
			svgWidth = boxWidth;										//svg初始宽度
			svgHeight = svgWidth * imgHeightWidthScale;					//svg初始高度
			minWidth = svgWidth;										//svg最小宽度
			minHeight = svgHeight;										//svg最小宽度
		} else if (imgHeightWidthScale > boxHeightWidthScale) {
			// 比例 图片宽 小于 视图宽
			svgHeight = boxHeight;										//svg初始高度
			svgWidth = svgHeight / imgHeightWidthScale;					//svg初始宽度
			minWidth = svgWidth;										//svg最小宽度
			minHeight = svgHeight;										//svg最小宽度
		}
		// 居中
		_initX = (boxWidth - svgWidth) / 2;
		_initY = (boxHeight - svgHeight) / 2;

		// 传参优先
		_initX = !isItEmpty( parseInt(initX) ) ? parseInt(initX) : _initX;
		_initY = !isItEmpty( parseInt(initY) ) ? parseInt(initY) : _initY;

		mapX = _initX;
		mapY = _initY;

		zoomWidth = 0;

		svgImgScale = svgWidth/mapWidth;
		// 重置图元尺寸
		resetImgSize();

		if(!Raphael.svg){
			alert("本浏览器不支持SVG,请更换浏览器！");
			return false;
		}
		if(paper){
			paper.remove();
			paper = null;
		}
		paper = Raphael(containerId, $container.width(), $container.height());
		wheelDrawDelta();
		creatSvg();

		// 实心圆、电子围栏
		loadDrawData();

	};

	/**
	 * 滚轮滚动事件 关闭
	 */
	function offWheelDelta() {

		// 检测浏览器
		var browser = checkBrowser();

		if(browser == "firefox") {

			$('#'+ containerId).off("DOMMouseScroll");

		} else {

			$('#'+ containerId).off("mousewheel");

		}

	};

	/**
	 * 滚轮滚动事件
	 */
	function wheelDrawDelta() {

		// 检测浏览器
		var browser = checkBrowser();

		if(browser == "un"){
			layer.alert("未知浏览器");
			return false;
		}

		// 判断设备
		// if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) || /(Android)/i.test(navigator.userAgent)) {
		// 	console.log(setGesture(el));

			var zoomFlag = 0;

			var _clientX,_clientY;

			function setGesture(el) {
				//console.log(el);

	            var obj = {}; //定义一个对象
	            var istouch = false;
	            var start = [];
	            el.addEventListener("touchstart", function(e) {
					//console.log(e.touches.length);

					e.preventDefault();
					
					var now = e.touches; //得到第二组两个点
					offsetContX_draw = now[0].pageX / pageZoom;
					offsetContY_draw = now[0].pageY / pageZoom;
					
					// alert(e.touches.length);
	                if (e.touches.length >= 2) { //判断是否有两个点在屏幕上
	                    istouch = true;
	                    start = e.touches; //得到第一组两个点
	                    obj.gesturestart && obj.gesturestart.call(el); //执行gesturestart方法
					};
					// alert(start);
					//console.log(start);
	            }, false);
	            document.addEventListener("touchmove", function(e) {
	                e.preventDefault();
	                if (e.touches.length >= 2 && istouch) {
	                    var now = e.touches; //得到第二组两个点
	                    var scale = getDistance(now[0], now[1]) / getDistance(start[0], start[1]); //得到缩放比例，getDistance是勾股定理的一个方法
	                    var rotation = getAngle(now[0], now[1]) - getAngle(start[0], start[1]); //得到旋转角度，getAngle是得到夹角的一个方法
	                    e.scale = scale.toFixed(2);
	                    e.rotation = rotation.toFixed(2);

	                    _clientX = now[0].pageX / pageZoom;
	                    _clientY = now[0].pageY / pageZoom;

	                    offsetContX_draw = now[0].pageX / pageZoom;
	                    offsetContY_draw = now[0].pageY / pageZoom;

	                    obj.gesturemove && obj.gesturemove.call(el, e); //执行gesturemove方法

	                };
	            }, false);
	            document.addEventListener("touchend", function(e) {
	                if (istouch) {
	                    istouch = false;
	                    obj.gestureend && obj.gestureend.call(el); //执行gestureend方法
	                };
	            }, false);
	            return obj;
	        };

	        function getDistance(p1, p2) {
	            var x = p2.pageX - p1.pageX,
	                y = p2.pageY - p1.pageY;
				return Math.sqrt((x * x) + (y * y));
				alert(x);
				alert(y);

	        };

	        function getAngle(p1, p2) {
	            var x = p1.pageX - p2.pageX,
	                y = p1.pageY - p2.pageY;
	            return Math.atan2(y, x) * 180 / Math.PI;
	        };

			var box = document.querySelector('#'+ containerId);
			 box = box .querySelector('svg');
			// var box =$('#container_map');
			// console.log(box);

	        var boxGesture = setGesture(box); //得到一个对象
			boxGesture.gesturestart = function() { //双指开始
				//console.log(box.style.backgroundColor);

				mapMove = false;

				// box.style.backgroundColor = "yellow";
	            // alert(document.write(JSON.stringify(e)));

	        };
	        var zoom_scal;
	        boxGesture.gesturemove = function(e) { //双指移动
	            //box.innerHTML = e.scale + "<br />" + e.rotation;
	            //box.style.transform = "scale(" + e.scale + ") rotate(" + e.rotation + "deg)"; //改变目标元素的大小和角度

	        	//$('.mapTab').html(e.scale);

	        	zoomFlag = e.scale > 1 ? 1 : e.scale < 1 ? -1 : 0;

	        	return false;
	        	if (!isItEmpty(zoom_scal)) {
	        		zoomFlag = e.scale > zoom_scal ? 1 : e.scale < zoom_scal ? -1 : 0;
	        	} else {
	        		zoomFlag = e.scale > 1 ? 1 : e.scale < 1 ? -1 : 0;
	        	}
	        	zoom_scal = e.scale;

	        	mapMove = false;
	        	if(mapZoom){

					// 可自动缩放
					autoZoomFlag = false;

					var clientX = _clientX;
					var clientY = _clientY;

					var maxX = mapX + svgWidth;
					var minX = mapX;
					var maxY = mapY + svgHeight;
					var minY = mapY;
					if(offsetContX_draw > maxX || offsetContX_draw < minX || offsetContY_draw > maxY || offsetContY_draw < minY){
						return;
					}
					mapZoom = false;

					zoomWidth = zoomWidth + (zoomLength * zoomFlag * 0.4);

					// 清除 所有 定位 图元
					that.clearAllPosition();
					svgDrawZoom();

					// 实心圆、电子围栏
					loadDrawData();

					// 加载 自定义内容
					typeof loadData == 'function' && loadData();

					if(typeof creatStaticPel == 'function'){
						//绘制静态图元
						var flag = creatStaticPel();
			        	if(flag){
			        		startMorePlay();
			        	}
					}
				}
	        	mapMove = false;

	        };
			boxGesture.gestureend = function() { //双指结束
	            //box.innerHTML = "";
	            //box.style.cssText = "background-color:red";
	        	//document.write(JSON.stringify(e));

	        	if(typeof creatStaticPel == 'function'){
					//绘制静态图元
					var flag = creatStaticPel();
		        	if(flag) {
		        		startMorePlay();
		        	}
				}

				if(mapZoom){

					// 可自动缩放
					autoZoomFlag = false;

					var clientX = _clientX;
					var clientY = _clientY;

					var maxX = mapX + svgWidth;
					var minX = mapX;
					var maxY = mapY + svgHeight;
					var minY = mapY;
					if(offsetContX_draw > maxX || offsetContX_draw < minX || offsetContY_draw > maxY || offsetContY_draw < minY){
						return;
					}
					mapZoom = false;

					zoomWidth = zoomWidth + (zoomLength * zoomFlag * 5);

					// 清除 所有 定位 图元
					that.clearAllPosition();
					svgDrawZoom();

					// 实心圆、电子围栏
					loadDrawData();

					// 加载 自定义内容
					typeof loadData == 'function' && loadData();

					if(typeof creatStaticPel == 'function'){
						//绘制静态图元
						var flag = creatStaticPel();
			        	if(flag){
			        		startMorePlay();
			        	}
					}
				}

				mapMove = true;

	        };

		// 	return false;

		// }

		if(browser == "firefox"){

			$('#'+ containerId).off("DOMMouseScroll");
			$('#'+ containerId).on("DOMMouseScroll",function(e){

				var delta = (e.originalEvent.wheelDelta && (e.originalEvent.wheelDelta > 0 ? 1 : -1)) ||
				(e.originalEvent.detail && (e.originalEvent.detail > 0 ? -1 : 1));

				e.preventDefault();
				
				offsetContX_draw = e.offsetX / pageZoom;
				offsetContY_draw = e.offsetY / pageZoom;

				if(typeof creatStaticPel == 'function'){
					//绘制静态图元
					var flag = creatStaticPel();
					if(flag){
						startMorePlay();
					}
				}

				if(mapZoom){

					// 可自动缩放
					autoZoomFlag = false;

					var clientX = e.clientX / pageZoom;
					var clientY = e.clientY / pageZoom;

					var maxX = mapX + svgWidth;
					var minX = mapX;
					var maxY = mapY + svgHeight;
					var minY = mapY;

					if(offsetContX_draw > maxX || offsetContX_draw < minX || offsetContY_draw > maxY || offsetContY_draw < minY){
						return;
					}

					mapZoom = false;

					if(delta > 0){

						/*if(zoomWidth == maxWidth - minWidth){
							mapZoom = true;
							return;
						}*/
						zoomWidth = zoomWidth + zoomLength;
						//mapX = mapX - zoomLength ;
						//mapX = mapY - zoomLength * imgHeightWidthScale;

						// 清除 所有 定位 图元
						that.clearAllPosition();
						svgDrawZoom();

						// 实心圆、电子围栏
						loadDrawData();

						// 加载 自定义内容
						typeof loadData == 'function' && loadData();

						if(typeof creatStaticPel == 'function'){
							//绘制静态图元
				        	var flag = creatStaticPel();
				        	if(flag){
				        		startMorePlay();
				        	}
						}

					} else {

						/*if(zoomWidth == 0){
							mapZoom = true;
							return;
						}*/
						zoomWidth = zoomWidth - zoomLength;
						//mapX = mapX + zoomLength ;
						//mapX = mapY + zoomLength * imgHeightWidthScale;

						// 清除 所有 定位 图元
						that.clearAllPosition();
						svgDrawZoom();

						// 实心圆、电子围栏
						loadDrawData();

						// 加载 自定义内容
						typeof loadData == 'function' && loadData();


						if(typeof creatStaticPel == 'function'){
							//绘制静态图元
							var flag = creatStaticPel();
							if(flag){
								startMorePlay();
							}
						}
					}

				}

			});

		} else {

			$('#'+ containerId).off("mousewheel");
			$('#'+ containerId).on("mousewheel",function(e){

				var delta = (e.originalEvent.wheelDelta && (e.originalEvent.wheelDelta > 0 ? 1 : -1)) ||
				(e.originalEvent.detail && (e.originalEvent.detail > 0 ? -1 : 1));
				e.preventDefault();
				
				offsetContX_draw = e.offsetX / pageZoom;
				offsetContY_draw = e.offsetY / pageZoom;

				if(typeof creatStaticPel == 'function'){
					//绘制静态图元
					var flag = creatStaticPel();
		        	if(flag) {
		        		startMorePlay();
		        	}
				}

				if(mapZoom){

					// 可自动缩放
					autoZoomFlag = false;

					var clientX = e.clientX / pageZoom;
					var clientY = e.clientY / pageZoom;

					var maxX = mapX + svgWidth;
					var minX = mapX;
					var maxY = mapY + svgHeight;
					var minY = mapY;
					if(offsetContX_draw > maxX || offsetContX_draw < minX || offsetContY_draw > maxY || offsetContY_draw < minY){
						return;
					}
					mapZoom = false;
					if(delta > 0){
						/*if(zoomWidth == maxWidth - minWidth){
							mapZoom = true;
							return;
						}*/
						zoomWidth = zoomWidth + zoomLength;
						//mapX = mapX - zoomLength ;
						//mapX = mapY - zoomLength * imgHeightWidthScale;

						// 清除 所有 定位 图元
						that.clearAllPosition();
						svgDrawZoom();

						// 实心圆、电子围栏
						loadDrawData();

						// 加载 自定义内容
						typeof loadData == 'function' && loadData();

						if(typeof creatStaticPel == 'function'){
							//绘制静态图元
							var flag = creatStaticPel();
				        	if(flag){
				        		startMorePlay();
				        	}
						}

					}else{
						/*if(zoomWidth == 0){
							mapZoom = true;
							return;
						}*/
						zoomWidth = zoomWidth - zoomLength;
						//mapX = mapX + zoomLength ;
						//mapX = mapY + zoomLength * imgHeightWidthScale;

						// 清除 所有 定位 图元
						that.clearAllPosition();
						svgDrawZoom();

						// 实心圆、电子围栏
						loadDrawData();

						// 加载 自定义内容
						typeof loadData == 'function' && loadData();

						if(typeof creatStaticPel == 'function'){
							//绘制静态图元
							var flag = creatStaticPel();
				        	if(flag){
				        		startMorePlay();
				        	}
						}

					}
				}
			});

		}

	};

	/**
	 * svg缩放
	 */
	function svgDrawZoom() {

		if(zoomWidth < 0){
			//zoomWidth = 0;
		} else if(minWidth + zoomWidth > maxWidth  && false){
			zoomWidth = maxWidth - minWidth;
		}
		if(minWidth + zoomWidth > maxWidth && false){
			svgWidth = maxWidth;
		}else if(minWidth + zoomWidth < minWidth){
			//svgWidth = minWidth;
			svgWidth = minWidth + zoomWidth;

			var _minWidth = mapWidth / 10 < 20 ? (mapWidth / 10) : 20;
			if(svgWidth < _minWidth){// svgWidth < mapWidth / 10
				if(imgHeightWidthScale > 1){
					svgWidth = minWidth;
				}else{
					svgWidth = _minWidth;//200;
				}
				zoomWidth = svgWidth - minWidth;
			}
		}else{
			svgWidth = minWidth + zoomWidth;					//svg宽度
		}
		svgHeight = svgWidth * imgHeightWidthScale;				//svg高度

		// 限制缩放、拖动范围
		if (limitFlag) {
			if (imgHeightWidthScale <= boxHeightWidthScale) {
				// 图片宽 大于等于 容器宽
				if (svgWidth <= boxWidth) {
					svgWidth = boxWidth;
					zoomWidth = svgWidth - minWidth;
					svgHeight = svgWidth * imgHeightWidthScale;
				}
			} else if (imgHeightWidthScale > boxHeightWidthScale) {
				// 图片高 大于 容器高
				if (svgHeight <= boxHeight) {
					svgHeight = boxHeight;
					svgWidth = svgHeight/imgHeightWidthScale;
					zoomWidth = svgWidth - minWidth;
				}
			}
		}

		//mapX = 0;
		//mapY = 0;
		mapX = (mapX - offsetContX_draw)  / svgImgScale;
		mapY = (mapY - offsetContY_draw)  / svgImgScale;
		svgImgScale = svgWidth/mapWidth;
		// 重置图元尺寸
		resetImgSize();
		mapX = mapX * svgImgScale + offsetContX_draw;
		mapY = mapY * svgImgScale + offsetContY_draw;

		// 限制拖拽范围
		var limitXY = limitMoveXY(mapX, mapY);
		mapX = limitXY.mapX;
		mapY = limitXY.mapY;

		paper && paper.clear();
		creatSvg();

	};

	/**
	 * TODO 缩放地图
	 * @param zoom 缩放倍数
	 */
	function zoomSvgDraw(point, _zoom) {

		// 可自动缩放
		autoZoomFlag = false;

		// 清除 所有 定位 图元
		that.clearAllPosition();

		svgWidth = mapWidth * (!isItEmpty(_zoom) ? _zoom : 1.1);									//svg宽度
		svgHeight = svgWidth * imgHeightWidthScale;					//svg高度

		zoomWidth = svgWidth - minWidth;

		offsetContX_draw = point.x * svgImgScale + mapX;
		offsetContY_draw = point.y * svgImgScale + mapY - 10;

		mapX = (mapX - offsetContX_draw)  / svgImgScale;
		mapY = (mapY - offsetContY_draw)  / svgImgScale;
		svgImgScale = svgWidth / mapWidth;
		// 重置图元尺寸
		resetImgSize();
		mapX = mapX * svgImgScale + offsetContX_draw;
		mapY = mapY * svgImgScale + offsetContY_draw;
		paper && paper.clear();
		creatSvg();

		// 实心圆、电子围栏
		loadDrawData();

		// 加载 自定义内容
		typeof loadData == 'function' && loadData();

		if(typeof creatStaticPel == 'function'){
			//绘制静态图元
			var flag = creatStaticPel();
        	if(flag){
        		startMorePlay();
        	}
		}

	}

	//创建画布
	function creatSvg(){

		// 画布不存在 种植
		if(!paper) return false;

		if(paperMap)paperMap.remove();
		paperMap = paper.image(mapUrl, mapX, mapY, svgWidth, svgHeight).attr({
			stroke:"none",
			opacity:5,
			cursor: (canDrawDisc || canDrawPoints ? 'crosshair' : 'pointer')
		}).drag(function(dx,dy){
			//move
			//console.log({dx:dx,dy:dy});
			if(mapMove){

				// 可自动缩放
				autoZoomFlag = false;

				mapMove = false;

				that.clearAllPosition();

				that.clearDrawData && that.clearDrawData();

				// 加载 所有 已缓存 电子围栏
				loadAllRails();

				this.x = this.ox + dx;//起点X
				this.y = this.oy + dy;//起点Y


				// 限制缩放、拖动范围
				if (limitFlag) {

					// 限制拖拽范围
					var limitXY = limitMoveXY(this.x, this.y);
					this.x = limitXY.mapX;
					this.y = limitXY.mapY;

				}

				this.attr({x:this.x,y:this.y});
				mapX = this.x;
				mapY = this.y;

				// 实心圆、电子围栏
				loadDrawData && loadDrawData();

				if(typeof creatStaticPel == 'function'){
					//绘制静态图元
		        	//creatStaticPel();
				}
			}
		},function(){
			//start

			this.ox = this.attr("x");
			this.oy = this.attr("y");
			this.attr({opacity:1});

			that.clearTrackAll();
			if(typeof creatStaticPel == 'function'){
				//绘制静态图元
	        	//creatStaticPel();
			}

		},function(){
			//end

			this.attr({opacity:5});

			// 加载所有人员
			loadAllPosition();

			// 实心圆、电子围栏
			loadDrawData && loadDrawData();

			if(typeof creatStaticPel == 'function'){
				//绘制静态图元
				var flag = creatStaticPel();
	        	if(flag){
	        		startMorePlay();
	        	}
			}

		}).dblclick(function(e){

			var e = e || event;
			if(canDrawPoints) {
				dblclickPaper_points && dblclickPaper_points(this, e);
			};
			if(canDrawDisc) {
				dblclickPaper_disc && dblclickPaper_disc(this, e);
			}

		}).click(function (e) {



		});

		// 加载所有人员
		loadAllPosition();
		// 创建比例图标
		creatScaleLineImg();
		
		/*if(typeof creatStaticPel == 'function'){
			//绘制静态图元
        	creatStaticPel();
        	startMorePlay();
		}*/

	};

	// 限制拖拽范围
	function limitMoveXY(_mapX, _mapY) {

		if (!limitFlag) return {mapX: _mapX, mapY: _mapY};

		var _mapX_ = !isItEmpty(_mapX) ? _mapX : mapX;
		var _mapY_ = !isItEmpty(_mapY) ? _mapY : mapY;

		var move_x = svgWidth - boxWidth;	//可移动的X
		var move_y = svgHeight - boxHeight;	//可移动的Y

		var minX,maxX, minY,maxY;

		if (move_x <= 0) {
			minX = _initX < 0 ? _initX : 0;
			if(_mapX_ < minX){
				_mapX_ = minX;
			}
			maxX = _initX + move_x > 0 ? _initX + move_x : 0;
			if(_mapX_ + move_x > maxX){
				_mapX_ = maxX - move_x;
			}
		} else {
			minX = _initX > 0 ? _initX : 0;
			if(_mapX_ > minX){
				_mapX_ = minX;
			}
			maxX = _initX + move_x < 0 ? _initX + move_x : 0;
			if(_mapX_ + move_x < maxX){
				_mapX_ = maxX - move_x;
			}
		}

		if (move_y <= 0) {
			minY = _initY < 0 ? _initY : 0;
			if(_mapY_ < minY){
				_mapY_ = minY;
			}
			maxY = _initY + move_y > 0 ? _initY + move_y : 0;
			if(_mapY_ + move_y > maxY){
				_mapY_ = maxY - move_y;
			}
		} else {
			minY = _initY > 0 ? _initY : 0;
			if(_mapY_ > minY){
				_mapY_ = minY;
			}
			maxY = _initY + move_y < 0 ? _initY + move_y : 0;
			if(_mapY_ + move_y < maxY){
				_mapY_ = maxY - move_y;
			}
		}

		return {mapX: _mapX_, mapY: _mapY_};
	};

	// 检测浏览器
	function checkBrowser(){
		var Browser=new Object();
		Browser.isMozilla=(typeof document.implementation!='undefined')
		&&(typeof document.implementation.createDocument!='undefined')
		&&(typeof HTMLDocument!='undefined');
		if(!Browser.isMozilla){
			return "un";
		}
		if(window.ActiveXObject){
			return "ie";
		}
		if(navigator.userAgent.toLowerCase().indexOf("firefox")!=-1){
			return "firefox";
		}
		if(navigator.userAgent.toLowerCase().indexOf("safari")!=-1){
			return "safari";
		}
		if(navigator.userAgent.toLowerCase().indexOf("opera")!=-1){
			return "opera";
		}
		if(navigator.userAgent.toLowerCase().indexOf("chrome")!=-1){
			return "chrome";
		}
	};

	// 双击 svg 实心圆
	function dblclickPaper_disc(oThis,oE){

		var svgLeft = $('#'+ containerId +'>svg').offset().left - $(window).scrollLeft(),
			svgTop = $('#'+ containerId +'>svg').offset().top - $(window).scrollTop();
		var clientX = oE.clientX || oE.pageX,
			clientY = oE.clientY || oE.pageY;
		var offsetX = (clientX - svgLeft) / pageZoom,
			offsetY = (clientY - svgTop) / pageZoom;

		var startX = (offsetX - mapX)/svgImgScale,
			startY = (offsetY - mapY)/svgImgScale;
		startX = Math.round(startX);
		startY = Math.round(startY);
		/*
		var offsetX = oE.offsetX,
			offsetY = oE.offsetY;
		var startX = (offsetX - mapX)/svgImgScale,
			startY = (offsetY - mapY)/svgImgScale;
		startX = Math.round(startX);
		startY = Math.round(startY);
		*/
		
		let realPoint = GlobalMap.mapPointToRealPoint(Object.assign({}, mapInfo), {xPx: startX,yPx: startY}, ratioX, ratioY);
		// real
		var realX = realPoint.x;// transToReal(startX, 'X');
		var realY = realPoint.y;// transToReal(startY, 'Y');
		
		// 回调
		callBack_drawDisc && callBack_drawDisc(startX, startY, realX, realY);

		// 画 实心圆
		var points = [startX,startY].join(','),
			discD = 5;
		that.initDrawDisc(points, discD);

	};

	/**
	 * 开始 画 实心圆
	 * 必要字段：id,startX,startY,width,height,show
	 * @param points string | discD 半径
	 * @returns
	 */
	this.initDrawDisc = function (points='', discD, pointXY='') {

		this.clearDiscImg('destroy');

		// 空值 中止
		if(isItEmpty(points) && isItEmpty(pointXY)) return false;
		
		let pointXYs = pointXY.split(';');
		let pointXY0 = pointXYs[0].split(',');
		var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: parseFloat(pointXY0[0]),y: parseFloat(pointXY0[1])}, ratioX, ratioY);
		var pixelX = pointPx.xPx;// transToMap( cameraObj.pointX , 'X');
		var pixelY = pointPx.yPx;// transToMap( cameraObj.pointY , 'Y');
		
		discImgMap.put(DISCID, {
			id: DISCID,
			points: points || [pixelX, pixelY].join(','),
			d: discD
		});
		creatPointDisc(DISCID, (points || pointXY), discD);

	};

	/**
	 * 创建实心圆
	 * 必要字段：id, points, d
	 * @param id, 坐标集合str, 直径
	 * @returns
	 */
	function creatPointDisc(id,points,d){

		// 画布不存在 种植
		if(!paper) return false;

		var point = points.split(";");
		var point0 = point[0].split(",");
		
		var disc = paper.circle(
				parseFloat(point0[0]) * svgImgScale + mapX,
				parseFloat(point0[1]) * svgImgScale + mapY,
				(d ? d : 10)
		).attr({
			fill:"red", 			// 填充色
			stroke:"blue", 			// 边缘线
			"stroke-width":2 		// 边缘线  宽度
		});

		var paperDiscSet = paper.set();
		paperDiscSet.push(
				disc
		);
		paperDiscSetMap.put(id, paperDiscSet);

	};

	//清除点击点 实心圆
	this.clearDiscImg = function (type){
		var isDesTroy = type == "destroy";
		$.each(paperDiscSetMap.keySet(),function(n,key){
			paperDiscSetMap.get(key).remove();	//移除图片
			paperDiscSetMap.remove(key);		//移除缓存
			isDesTroy ? (discImgMap.remove(key)) : void(0);
		});
	};

	/**
	 * 方法 重绘 实心圆
	 */
	function loadPointDisc() {

		that.clearDiscImg();
		var keys = discImgMap.keySet();
		$.each(discImgMap.keySet(), function(n, key) {
			var values = discImgMap.get(key);
			creatPointDisc(values.id,values.points,values.d);
		});

	};

	/**
	 * 方法 设置参数 电子围栏 是否可闭合
	 */
	this.setCanClosePoints = function (flag) {

		canClosePoints = flag && true;			// 电子围栏 是否可闭合

	}

	/**
	 * 方法 双击地图 svg 电子围栏
	 */
	function dblclickPaper_points(oThis, oE) {
		
		var svgLeft = $('#'+ containerId +'>svg').offset().left - $(window).scrollLeft(),
			svgTop = $('#'+ containerId +'>svg').offset().top - $(window).scrollTop();
		var clientX = (oE.clientX) || (oE.pageX),
			clientY = (oE.clientY) || (oE.pageY);
		var offsetX = (clientX - svgLeft) / pageZoom,
			offsetY = (clientY - svgTop) / pageZoom;

		var startX = (offsetX - mapX)/svgImgScale,
			startY = (offsetY - mapY)/svgImgScale;
		startX = Math.round(startX);
		startY = Math.round(startY);
		/*
		var offsetX = oE.offsetX,
			offsetY = oE.offsetY;
		var startX = (offsetX - mapX)/svgImgScale,
			startY = (offsetY - mapY)/svgImgScale;
		startX = Math.round(startX);
		startY = Math.round(startY);
		*/
		var startXY = [startX, startY].join(',');
		pointGroup.push(startXY);
		
		let realPoint = GlobalMap.mapPointToRealPoint(Object.assign({}, mapInfo), {xPx: startX,yPx: startY}, ratioX, ratioY);
		// real
		var realX = realPoint.x;// transToReal(startX, 'X');
		var realY = realPoint.y;// transToReal(startY, 'Y');
		realPointGroup.push([realX, realY].join(','));

		that.clearDrawData();		//清除  地图  电子围栏
		// 清除 虚线
		that.clearDottedLine('DOTTEED_Line', 'destroy');

		that.drawFence(false, true);

		var firstPoint = pointGroup[0].split(',');
		var disToFirst = calcDis({x: parseInt(firstPoint[0]), y: parseInt(firstPoint[1])}, {x: startX, y: startY}, 1, 1);
		// 回调
		callBack_drawPoints && callBack_drawPoints(startXY, pointGroup, disToFirst * svgImgScale, realPointGroup);

	};

	var lineColor,lineWidth,limitDis;
	//画电子围栏  依托于 pointGroup
	this.drawFence = function (isClose, isDraggable, option, notClear) {

		// 画布不存在 中止
		if(!paper) return false;

		!notClear && that.clearDrawData();		//清除  地图  电子围栏
		var firstXYs = [],
			lastXYs = [];
		var frenceIdStr = option && option.id ? option.id + '_' : '';
		var pointGroup_on = !isItEmpty(option) && !isItEmpty(option.pointGroup) ? option.pointGroup : pointGroup;

		var _lineColor = !isItEmpty(lineColor) ? lineColor : '#e0fb0f';
		var _lineWidth = !isItEmpty(lineWidth) ? lineWidth : 2;

		if(!isItEmpty(option) && !isItEmpty(option.color)) {

			_lineColor = option.color;
			lineColor = option.color;

		}
		if(!isItEmpty(option) && !isItEmpty(option.width)) {
			_lineWidth = option.width;
			lineWidth = option.width;
		}

		var colorStr = _lineColor;
		var widthVal = _lineWidth;
		$.each(pointGroup_on, function(index, startXY){

			var starts = startXY.split(',');
			if(index == 0){firstXYs = starts};
			var startX = parseFloat(starts[0]) * svgImgScale + mapX,
				startY = parseFloat(starts[1]) * svgImgScale + mapY;

			//画点
			if(isDraggable){
				var circle = paper.circle(startX, startY, 5).attr({
					'fill' : '#39FCFF',
					'stroke' : '#D2691E',//
					'cursor' : 'move'
				});
				circle.draggable(dragMove, 'start', dragUp);
				var circleId = 'circle_' + frenceIdStr + index;
				circle.oId = circleId;
				paperCircleMap.put(circleId, circle);
			}

			//画线
			if(index < pointGroup_on.length - 1){
				var ends = pointGroup_on[index + 1].split(',');
				if(index + 1 == pointGroup_on.length - 1){lastXYs = ends;};
				var endX = parseFloat(ends[0]) * svgImgScale + mapX,
					endY = parseFloat(ends[1]) * svgImgScale + mapY;
				var line_path = "M" + startX + "," + startY + ",L," + endX + "," + endY + " z";
		        var path = paper.path(line_path).attr({
			        "stroke" : colorStr, //"#e0fb0f"
			        "stroke-width" : widthVal //2
	        	});
		        var lineOid = 'line_' + frenceIdStr + index;
		        path.oId = lineOid;
		        paperLineMap.put(lineOid, path);
			}

		});

		if(pointGroup_on.length <= 2)return false;
		if(isClose){
			var line_path_close = "M" + (parseFloat(lastXYs[0]) * svgImgScale + mapX) + "," + (parseFloat(lastXYs[1]) * svgImgScale + mapY) + ",L,"
		+ (parseFloat(firstXYs[0]) * svgImgScale + mapX) + "," + (parseFloat(firstXYs[1]) * svgImgScale + mapY) + " z";
		    var path_close = paper.path(line_path_close).attr({
			        "stroke" : colorStr, //"#e0fb0f"
			        "stroke-width" : widthVal //2
			});
		    var lineOid_close = 'line_' + frenceIdStr + (pointGroup_on.length - 1);
		    paperLineMap.put(lineOid_close, path_close);
		}


	};

	/**
	 * 方法 清除选取点
	 */
	this.clearDrawData = function (railId) {

		//清除 点
		var circleKeys = paperCircleMap.keySet();
		$.each(circleKeys, function(i, key){

			if(!isItEmpty(railId) && key.indexof(railId) == -1) return true;

			var value = paperCircleMap.get(key);
			value.remove();
			paperCircleMap.remove(key);

		});

		//清除 线
		var lineKeys = paperLineMap.keySet();
		$.each(lineKeys, function(i, key){

			if(!isItEmpty(railId) && key.indexOf(railId) == -1) return true;

			var value = paperLineMap.get(key);
			value.remove();
			paperLineMap.remove(key);

		});

	};

	/**
	 * 方法 加载选取坐标点
	 */
	function loadDrawData() {
		// 实心圆
		loadPointDisc();

		// 电子围栏
		that.clearDrawData();													//清除  地图  电子围栏
		// canDrawPoints 可点击取点 不闭合 可移动
		that.drawFence(!canDrawPoints && canClosePoints, canDrawPoints);		//画电子围栏  不封口  可拖动

		// 未处于 自定义获取区域 状态
		if(!inFingerDraw) {
			mapZoom = true;						//设置svg 状态  可缩放
			mapMove = true;						//设置svg 状态  可拖动
		}
		/*
		mapZoom = true;						//设置svg 状态  可缩放
		mapMove = true;						//设置svg 状态  可拖动
		*/
	};

	//重新  显示  围栏数据
	function reDrawFrence(oThis) {

		var oId = oThis.oId,
			iOption = oId.split('_'),
			oindex = iOption[iOption.length - 1];

		var oldXY = pointGroup[oindex],
			oldXYs = oldXY.split(','),
			oldX = parseFloat(oldXYs[0]),
			oldY = parseFloat(oldXYs[1]);
		//console.log(oldXY);

		var newX = Math.round(oldX + displaceX),
			newY = Math.round(oldY + displaceY);

		var newXY = [newX, newY].join(',');
		pointGroup[oindex] = newXY;
		
		let realPoint = GlobalMap.mapPointToRealPoint(Object.assign({}, mapInfo), {xPx: newX,yPx: newY}, ratioX, ratioY);
		// real
		var realX = realPoint.x;// transToReal(newX, 'X');
		var realY = realPoint.y;// transToReal(newY, 'Y');
		realPointGroup[oindex] = ([realX, realY].join(','));
		
		paperCircleMap.put(oId, oThis);

		var dis;// 首尾距离
		if (oindex == 0 || oindex == pointGroup.length -1) {
			// 移动首尾点
			var firstPoint = pointGroup[0].split(',');
			var lastPoint = pointGroup[pointGroup.length - 1].split(',');
			// 首尾距离
			dis = calcDis({x: firstPoint[0], y: firstPoint[1]}, {x: lastPoint[0], y: lastPoint[1]}, 1, 1);
		}

		that.clearDrawData();		//清除  地图  电子围栏
		that.drawFence(false, true);		//画点 线

		// 回调
		callBack_drawPoints && callBack_drawPoints(newXY, pointGroup, dis);
	};

	//记录 位移
	function assign(dx, dy, oThis){
		displaceX = parseFloat(dx) / svgImgScale;
		displaceY = parseFloat(dy) / svgImgScale;
	};

	// 拖拽 鼠标弹起
	function dragMove(dx, dy, oThat) {
		assign(dx, dy, oThat)
	};

	// 拖拽 鼠标弹起
	function dragUp(oThat) {
		reDrawFrence(oThat);
	};

	(function(R) {
		R.el.draggable = function(move, start, up) {
			this._ui = this._ui || {};

			var that = this;

			this._ui.onMove = R.is(move, 'function') ?
			move : function(distanceX, distanceY, x, y, deltaX, deltaY) {
				move(distanceX, distanceY,that);
				that.translate(deltaX, deltaY);
				//that.data('gao').translate(deltaX, deltaY);
			};

			this._ui.onStart = R.is(start, 'function') ? start : function(x, y) {
			};

			// R.is(up, 'function') ? up :
			this._ui.onUp = function(x, y) {
				up(that);
			};

			function onMove(distanceX, distanceY, x, y) {
				var deltaX = x - that._ui.lastX;
				var deltaY = y - that._ui.lastY;
				that._ui.lastX = x;
				that._ui.lastY = y;
				that._ui.onMove(distanceX, distanceY, x, y, deltaX, deltaY);
				that.paper.safari && that.paper.safari();
			};

			function onStart(x, y) {
				that._ui.lastX = x;
				that._ui.lastY = y;
				that._ui.onStart(x, y);
			};

			function onUp(x, y) {
				that._ui.lastX = x;
				that._ui.lastY = y;
				that._ui.onUp(x, y);
			};

			return this.drag(onMove, onStart, onUp);
		};
	})(Raphael);

	// 加载所有人员
	function loadAllPosition(){

		// 加载 所有 已缓存 追踪
		loadAllTracks();

		// 加载 所有 已缓存 自定义区域
		loadAllFingerRails();

		// 加载 所有 已缓存 虚线
		loadAllDottedLine();

		// 加载 所有 已缓存 电子围栏
		loadAllRails();

		// 加载 所有 已缓存 圆点
		loadAllDots();
		
		// 加载 所有 实时轨迹
		loadAllIntimeSegs();

		// 加载 所有 已缓存 基站
		loadAllStations();

		// 加载 所有 已缓存 摄像头
		loadAllCameras();

		// 加载 所有 已缓存 旗帜
		loadAllFlagimgs();

		// 加载 所有 已缓存 工具柜
		loadAllTks();

		// 加载 所有 已缓存 刻度尺
		loadAllRuleLines();

		// 加载 所有 已缓存 人员
		loadAllPeoples();

		// 加载 自定义内容
		typeof loadData == 'function' && loadData();

		// 加载 当前 人员位置 轨迹
		if(movePointFlag){
			loadMovePoint();
		}

		// 未处于 自定义获取区域 状态
		if(!inFingerDraw) {
			mapZoom = true;
			mapMove = true;
		}
		/*mapZoom = true;
		mapMove = true;*/

	};

	// 清除 所有 定位 图元
	this.clearAllPosition = function (){

		// 清除图元 人员
		this.clearAllPeoples();

		// 清除图元 txt
		this.clearAllTxts();

		// 清除图元 追踪
		this.clearAllTracks();

		// 清除图元 自定义区域
		this.clearFingerAllRails();

		// 清除图元 虚线
		this.clearAllDottedLine();

		// 清除图元 电子围栏
		this.clearAllRails();

		// 清除图元 圆点
		this.clearAllDots();

		// 清除图元 基站
		this.clearAllStations();

		// 清除图元 摄像头
		this.clearAllCameras();

		// 清除图元 旗帜
		this.clearAllFlagimgs();

		// 清除图元 工具柜
		this.clearAllTks();

		// 清除图元 刻度尺
		this.clearAllRuleLines();
		
		// 清除图标 线段 所有
		this.clearAllIntimeSegs();

		$.each(paperPointSetMap.keySet(),function(n,key){
			paperPointSetMap.get(key).remove();	//移除图片
			paperPointSetMap.remove(key); 			//移除缓存
		});
		$.each(paperLineSetMap.keySet(),function(n,key){
			paperLineSetMap.get(key).remove();	//移除图片
			paperLineSetMap.remove(key); 			//移除缓存
		});
		//clearCircularImg();
		//clearTrackImg();
	};

	/**
	 * uwb 定位/报警数 初始化
	 * @param posiNum 定位人数 alarmNum 报警人数
	 * @returns
	 */
	this.initPeoleNum = function (posiNum, alarmNum) {

		peoplePosiNum = !isItEmpty(posiNum) ? parseInt(posiNum) : 0;
		peopleAlarmNum = !isItEmpty(alarmNum) ? parseInt(alarmNum) : 0;

	};

	/**
	 * uwb 定位加载人员
	 * @param position
	 * @returns
	 */
	// posi 字段：id userNo name userType pixelX pixelY pointZ isAlarmed alarmType alarmNames alarmIds
	this.loadUwbPeoplePosition = function (Dposi) {
		var posi = $.extend({}, Dposi);
		// 检索 天车
		if (posi.bindingType == 3) {
			posi.userType = 100;
		}
		
		/*console.log('svg_draw_map.js posi 字段', {
			id: posi.id,
			userNo: posi.userNo,
			name: posi.name,
			userType: posi.userType,
			pixelX: posi.pixelX,
			pixelY: posi.pixelY,
			pointZ: posi.pointZ,
			isAlarmed: posi.isAlarmed,
			alarmType: posi.alarmType,
			alarmNames: posi.alarmNames,
			alarmIds: posi.alarmIds
		});*/
		
		// 坐标值 转换
		//var currPixelX = ( parseFloat( posi.pixelX ) - pOffsetX ) * scaleToPmapW  + mapStartX;
		//var currPixelY = ( parseFloat( posi.pixelY ) - pOffsetY ) * scaleToPmapH + mapStartY;
		
		//判断是否是同一点
		var people = Object.assign({}, showPeopleMap.get(posi.id));
		
		var tunnelPointXExit = true;
		let posiY = posi.pointY;
		var _ratioY = ratioY;
		if (posi.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || posi.appId == '624b863a82a1e7bed3e066baaddf8a3e6') {
			// X 位移小于1m
			if (!isItEmpty(people)) {
				if (Math.abs(people.pointX - posi.pointX) <= 1) {
					tunnelPointXExit = false;
				}
			}
			
			//let scaleYs = scaleY.split('/');
			//posiY = -1*(parseFloat(scaleYs[1])/2) + ([-1, 1][Math.round(100*Math.random())%2]) * 2 * Math.random();
			
			//_ratioY = 0.5 + ([-1, 1][Math.round(100*Math.random())%2]) * 0.1 * Math.random();
		}
		
		// 偏移量
		let _ratioX = people.ratioX ? people.ratioX : ratioX;
		// 定制隧道
		if (!people.ratioX && posi.appId == '624b863a82a1e7bed3e066baaddf8a3e11') {
			_ratioX = posi.bindingType == 3 ? 0.5+0.5*Math.random() : 0.5*Math.random();
		}
		
		var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: posi.pointX,y: posiY}, _ratioX, _ratioY);
		
		// 坐标值 转换
		var currPixelX = pointPx.xPx;// transToMap(posi.pointX, 'X');
		var currPixelY = pointPx.yPx;// transToMap(posi.pointY, 'Y');
		if (posi.appId == '624b863a82a1e7bed3e066baaddf8a3e4') {
			currPixelY = 1450;
		}
		
		// 报警状态
		var alarmNames_posi = !isItEmpty(posi.alarmNames) ? posi.alarmNames.join(' ') : '';
		// 人员编号
		var userNo_posi = !isItEmpty(posi.userNo) ? posi.userNo : '';
		
		//人员位置状态如果是在线，更新图元
		if(showPeopleMap.containsKey(posi.id)){
			//有人员
			
			// 坐标值 转换
			var oldPixelX = parseFloat( people.pixelX );//( parseFloat( people.pixelX ) - pOffsetX ) * scaleToPmapW  + mapStartX;
			var oldPixelY = parseFloat( people.pixelY );//( parseFloat( people.pixelY ) - pOffsetY ) * scaleToPmapH + mapStartY;
			// 报警状态
			var alarmNames_people = !isItEmpty(people.alarmNames) ? people.alarmNames.join(' ') : '';
			// 人员编号
			var userNo_people = !isItEmpty(people.userNo) ? people.userNo : '';
			var userNo_posi = !isItEmpty(posi.userNo) ? posi.userNo : '';
			var isUserNoChange = userNo_people != userNo_posi;

			// 人员姓名
			var name_people = !isItEmpty(people.name) ? people.name : '';
			var name_posi = !isItEmpty(posi.name) ? posi.name : '';
			var isNameChange = name_people != name_posi;
			
			// 判断是否报警状态改变
			//var isATypeChange = people.alarmType != posi.alarmType;
			var isAlarmChange = JSON.stringify(people.alarmIds) != JSON.stringify(posi.alarmIds);
			// 判断视频列表是否相同
			var isVideoChange = false;//JSON.stringify(people.videoList) != JSON.stringify(posi.videoList);

			// 判断高度是否改变
			var isPointZChange = false;//people.pointZ != posi.pointZ;
			
			// 放大地图
			if (false && autoZoomFlag && showTrackImgMap.size() == 1 && showTrackImgMap.containsKey(posi.id)) {

				// 解析 刻度尺 数据
				var ruleLineObj = map_cord_ruleLine.get(posi.mapId);
				ruleLineObj = !isItEmpty(ruleLineObj) ? ruleLineObj : {};

				var finishPoint = ruleLineObj.finishPoint;
				var workPoint = ruleLineObj.workPoint;

				var finishPixel = finishPoint[0];
				var workPixel = workPoint[0];

				var oldIn = (oldPixelX - finishPixel) * (oldPixelX - workPixel) < 0;
				var currIn = (currPixelX - finishPixel) * (currPixelX - workPixel) < 0;

				if (finishPixel != workPixel && currIn) {
					// 缩放地图
					zoomSvgDraw({x: currPixelX,y: currPixelY});
				}

			}
			
			// 隧道 x改变较小
			if (!tunnelPointXExit) {
				if (!(isUserNoChange || isNameChange || isAlarmChange || isVideoChange || isPointZChange)) {
					return false;
				}
			}
			
			//console.log(Math.abs(oldPixelX - currPixelX), Math.abs(oldPixelY - currPixelY));
			if(Math.abs(oldPixelX - currPixelX) > 1 * scaleToPmapW || Math.abs(oldPixelY - currPixelY) > 1 * scaleToPmapH || isUserNoChange || isNameChange || isAlarmChange || isVideoChange || isPointZChange){
				
				// 绘制实时轨迹
				if (flag_intime_line) {
					var pointObj = {};
					pointObj['id'] = posi.id;
					pointObj['ratioX'] = _ratioX;
					
					pointObj['pixelX'] = currPixelX;
					pointObj['pixelY'] = currPixelY;
					
					pointObj['pointX'] = posi.pointX;
					pointObj['pointY'] = posi.pointY;
					pointObj['pointZ'] = posi.pointZ;
					
					// 绘制 线段 实时轨迹
					this.loadIntimeSegment(pointObj);
				}
				
				creatPeopleImg(posi.id, currPixelX, currPixelY, posi.isAlarmed, posi.name, userNo_posi, alarmNames_posi, posi.userType, posi.alarmType, posi.pointZ);
				showPeopleMap.put(posi.id, $.extend({}, posi, {pixelX: currPixelX, pixelY: currPixelY,pointZ: posi.pointZ, ratioX: _ratioX}));

				if(posi.isAlarmed == 0){
					//当前是定位，原来是报警
					if(people.isAlarmed != posi.isAlarmed){
						peoplePosiNum ++;
						peopleAlarmNum --;
					}
				}else{
					if(people.isAlarmed == 0){
						//当前是报警，原来是定位
						peoplePosiNum --;
						peopleAlarmNum ++;
					}
				}

				posi.add = 1;
				//changePeopleTable && changePeopleTable(posi, peopleAlarmNum, peoplePosiNum);

			}else{
				/*
				if(posi.name != undefined && showTxtMap.containsKey(posi.id) && alarmNames_posi != alarmNames_people){

					// 创建图元 txt
					creatTxtImg(id, oldPixelX, oldPixelY, people.name, userNo_people, alarmNames_posi);
					// 缓存 数据
					var txtObj = {id: id,pixelX: oldPixelX, pixelY: oldPixelY, name: people.name, userNo: userNo_people, alarmNames: alarmNames_posi};
					showTxtMap.put(id, txtObj);

				}
				*/
			}


		}else{
			if(posi.isAlarmed == 0){
				//当前是报警
				peoplePosiNum ++;
			}else{
				//当前是定位
				peopleAlarmNum ++;
			}
			
			// 绘制实时轨迹
			if (flag_intime_line) {
				var pointObj = {};
				pointObj['id'] = posi.id;
				pointObj['ratioX'] = _ratioX;
				
				pointObj['pixelX'] = currPixelX;
				pointObj['pixelY'] = currPixelY;
				
				pointObj['pointX'] = posi.pointX;
				pointObj['pointY'] = posi.pointY;
				pointObj['pointZ'] = posi.pointZ;
				
				// 绘制 线段 实时轨迹
				this.loadIntimeSegment(pointObj);
			}
			
			creatPeopleImg(posi.id, currPixelX, currPixelY, posi.isAlarmed, posi.name, userNo_posi, alarmNames_posi, posi.userType, posi.alarmType, posi.pointZ);
			showPeopleMap.put(posi.id, $.extend({}, posi, {pixelX: currPixelX, pixelY: currPixelY, pointZ: posi.pointZ, ratioX: _ratioX}));

			posi.add = 1;
			//changePeopleTable && changePeopleTable(posi, peopleAlarmNum, peoplePosiNum);
		}
		
	};

	/**
	 * 选择图元
	 * @params userType,	alarmType
	 * @values 人员类型,		报警类型
	 */
	this.getPeopleImg = function (userType, alarmType, alarmState) {

		var people_img = '';

		var alarmState = !isItEmpty(alarmState) ? alarmState : (alarmType == 0 ? 0 : 1);

		// 加载从后台获取的图元
		if(!isItEmpty(posiIconsObj[userType]) && !isItEmpty(posiIconsObj[userType][alarmState])) {

			var _icon = posiIconsObj[userType][alarmState];

			if(alarmState == 0) {
				// 定位
				people_img = _icon;
			} else {
				// 报警
				people_img = !isItEmpty(_icon[alarmType]) ? _icon[alarmType] : _icon['default'];
			}

		}

		// 加载 默认 区分图元
		if(!isItEmpty(people_imgs_default[userType]) && !isItEmpty(people_imgs_default[userType][alarmState]) && isItEmpty(people_img)) {

			var _img = people_imgs_default[userType][(alarmState)];

			if(alarmState == 0) {
				// 定位
				people_img = _img;
			} else {
				// 报警
				people_img = !isItEmpty(_img[alarmType]) ? _img[alarmType] : _img['default'];
			}

		}

		// people_img 未找到相应图片时，设置默认图片
		if( !people_img ) {

			if(alarmState != 0){
				people_img = people_alarm_img;
			}else{
				people_img = people_posi_img;
			}

		}

		return people_img;
	};

	/**
	 * 创建人员图标：id,pixelX,pixelY,alarmType,name
	 * @param values
	 * @returns
	 */
	function creatPeopleImg(id, pixelX, pixelY, alarmState, name, userNo, alarmNamesStr, userType, alarmType, pointZ){
		
		// 已存在 先清除
		if(paperPeopleSetMap.containsKey(id)){

			paperPeopleSetMap.get(id).remove();		//移除图片
			paperPeopleSetMap.remove(id); 			//移除缓存

		}

		// 空值，不画图元
		if(isItEmpty(pixelX) || isItEmpty(pixelY)) return false;

		// 选择图元
		var people_img = that.getPeopleImg(userType, alarmType, alarmState);
		/*
		// 加载从后台获取的图元
		if(!isItEmpty(posiIconsObj[userType]) && !isItEmpty(posiIconsObj[userType][alarmState])) {

			var _icon = posiIconsObj[userType][alarmState];

			if(alarmState == 0) {
				// 定位
				people_img = _icon;
			} else {
				// 报警
				people_img = !isItEmpty(_icon[alarmType]) ? _icon[alarmType] : _icon['default'];
			}

		}

		// 加载 默认 区分图元
		if(!isItEmpty(people_imgs_default[userType]) && !isItEmpty(people_imgs_default[userType][alarmState]) && isItEmpty(people_img)) {

			var _img = people_imgs_default[userType][alarmState];

			if(alarmState == 0) {
				// 定位
				people_img = _img;
			} else {
				// 报警
				people_img = !isItEmpty(_img[alarmType]) ? _img[alarmType] : _img['default'];
			}

		}

		// people_img 未找到相应图片时，设置默认图片
		if( !people_img ) {

			if(alarmState != 0){
				people_img = people_alarm_img;
			}else{
				people_img = people_posi_img;
			}

		}
		*/
		// txt 数据
		var txtObj = {id: id,pixelX: pixelX, pixelY: pixelY, name: name, userNo: userNo, alarmNames: alarmNamesStr, pointZ: pointZ};

		var _img_w_h = people_width < people_height ? people_width : people_height;
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var pp_img = paper.image(people_img,
			(pixelX - _img_w_h/2) * svgImgScale + mapX,
			(pixelY - (_img_w_h)) * svgImgScale + mapY,
			_img_w_h * svgImgScale,
			_img_w_h * svgImgScale
		).dblclick(function(){
			if(name != undefined){

				// 创建图元 txt
				creatTxtImg(id, pixelX, pixelY, name, userNo, alarmNamesStr, pointZ);
				// 缓存 数据
				showTxtMap.put(id, txtObj);

				// 移除黑名单
				cnaShowTxt && showTxtMap_black.containsKey(id) && showTxtMap_black.remove(id);

			}
			//clikPeopleImg && clikPeopleImg(id);
		}).click(function(){

			// txt图元 销毁
			that.clearTxtImg(id, 'destroy');

			// 加入黑名单
			cnaShowTxt && showTxtMap_black.put(id, txtObj);

		});
		var paperPeopleSet = paper.set();
		paperPeopleSet.push(
			pp_img
		);
		paperPeopleSetMap.put(id,paperPeopleSet);

		// 回显 追踪图标
		if(showTrackImgMap.containsKey(id)){

			// 画 追踪图元
			creatTrackImg(id, pixelX, pixelY);

		}

		if( name != undefined && (showTxtMap.containsKey(id) || ( cnaShowTxt && !showTxtMap_black.containsKey(id) ) ) ){

			// 创建图元 txt
			creatTxtImg(id, pixelX, pixelY, name, userNo, alarmNamesStr, pointZ);
			// 缓存 数据
			showTxtMap.put(id, txtObj);

		}

	};

	/**
	 * 清除定位图元
	 *
	 * @params id
	 *
	 */
	this.clearPeoplePosition = function (id) {

		// 移除图元
		if(paperPeopleSetMap.containsKey(id)){

			paperPeopleSetMap.get(id).remove();		//移除图片
			paperPeopleSetMap.remove(id); 			//移除缓存

		}

		// 移除 追踪图元
		this.clearTrack(id, 'destroy');

		// 移除 text
		this.clearTxtImg(id, 'destroy');

		// 清除数据缓存
		if(showPeopleMap.containsKey(id)) {

			// 提取缓存值
			var posObj = showPeopleMap.get(id);

			if(posObj.isAlarmed == 0){
				//原来是定位
				peoplePosiNum--;

			}else{
				//原来是报警

				peopleAlarmNum--;

			}

			posObj.add = -1;
			//changePeopleTable && changePeopleTable(posObj, peopleAlarmNum, peoplePosiNum);

			showPeopleMap.remove(id);

		};

	};

	/**
	 * 创建移动人员图标：id,pixelX,pixelY,alarmType,name
	 * @param values
	 * @returns
	 */
	function creatMovePeopleImg(id, pixelX, pixelY, alarmState, name, userNo, alarmNamesStr, userType, alarmType, oldIndex, moveIndex , moveTime){

		if(oldIndex == moveIndex){
			return;
		}

		// 已存在 先清除
		if(paperMovePeopleSetMap.containsKey(id)){

			paperMovePeopleSetMap.get(id).remove();		//移除图片
			paperMovePeopleSetMap.remove(id); 			//移除缓存

		}


		var track = showPeopleTrackMap.get(oldIndex + 1);
		//var x1 = ( parseFloat( track.x ) - pOffsetX ) * scaleToPmapW  + mapStartX;
		//var y1 = ( parseFloat( track.y ) - pOffsetY ) * scaleToPmapH + mapStartY;
		
		//var x1 = ( parseFloat( track.x ) - pOffsetX ) * scaleToPmapW  + mapStartX;
		//var y1 = ( parseFloat( track.y ) - pOffsetY ) * scaleToPmapH + mapStartY;
		
		// 偏移量
		let _ratioX = ratioX;
		// 定制隧道
		if (mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e11') {
			_ratioX = 0.5;
		}
		
		var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: parseFloat( track.x ),y: parseFloat( track.y )}, _ratioX, ratioY);
		var x1 = pointPx.xPx;// transToMap( parseFloat( track.x ) , 'X');
		var y1 = pointPx.yPx;// transToMap( parseFloat( track.y ) , 'Y');
		var x = (x1 - people_width/2) * svgImgScale + mapX;
		var y = (y1 - people_height) * svgImgScale + mapY;

		// 选择图元
		var people_img = that.getPeopleImg(userType, alarmType, alarmState);
		/*
		// 加载从后台获取的图元
		if(!isItEmpty(posiIconsObj[userType]) && !isItEmpty(posiIconsObj[userType][alarmState])) {

			var _icon = posiIconsObj[userType][alarmState];

			if(alarmState == 0) {
				// 定位
				people_img = _icon;
			} else {
				// 报警
				people_img = !isItEmpty(_icon[alarmType]) ? _icon[alarmType] : _icon['default'];
			}

		}

		// 加载 默认 区分图元
		if(!isItEmpty(people_imgs_default[userType]) && !isItEmpty(people_imgs_default[userType][alarmState]) && isItEmpty(people_img)) {

			var _img = people_imgs_default[userType][alarmState];

			if(alarmState == 0) {
				// 定位
				people_img = _img;
			} else {
				// 报警
				people_img = !isItEmpty(_img[alarmType]) ? _img[alarmType] : _img['default'];
			}

		}

		// people_img 未找到相应图片时，设置默认图片
		if( !people_img ) {

			if(alarmState != 0){
				people_img = people_alarm_img;
			}else{
				people_img = people_posi_img;
			}

		}
		*/
		// txt 数据
		var txtObj = {id: id,pixelX: pixelX, pixelY: pixelY, name: name, userNo: userNo, alarmNames: alarmNamesStr};

		var _img_w_h = people_width < people_height ? people_width : people_height;
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var pp_img = paper.image(people_img,
				(pixelX - _img_w_h/2) * svgImgScale + mapX,
				(pixelY - (_img_w_h)) * svgImgScale + mapY,
				_img_w_h * svgImgScale,
				_img_w_h * svgImgScale
		).animate({
			x: x,
			y: y
		}, moveTime ,function(){
			creatMovePeopleImg(id, x1, y1, alarmState, name, userNo, alarmNamesStr, userType, alarmType, oldIndex+1, moveIndex , moveTime)
		});
		var paperPeopleSet = paper.set();
		paperPeopleSet.push(
				pp_img
		);
		paperMovePeopleSetMap.put(id,paperPeopleSet);


	};

	// 加载 所有 已缓存 人员
	function loadAllPeoples() {

		// 遍历缓存 人员
		$.each(showPeopleMap.keySet(), function(n, key) {

			var values = showPeopleMap.get(key);
			var alarmNames = !isItEmpty(values.alarmNames) ? values.alarmNames.join(' ') : '';
			var userNo = !isItEmpty(values.userNo) ? values.userNo : '';
			creatPeopleImg(values.id, values.pixelX, values.pixelY, values.isAlarmed, values.name, userNo, alarmNames, values.userType, values.alarmType, values.pointZ);

		});

	};

	/**
	 * 清除图标 人员
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearAllPeoples = function (type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 遍历 图元 map 人员
		$.each(paperPeopleSetMap.keySet(), function(n, key) {

			paperPeopleSetMap.get(key).remove();//移除图片
			paperPeopleSetMap.remove(key); 		//移除缓存

		});

		// 销毁 缓存数据 人员
		isDesTroy && showPeopleMap.clear();

	};

	/**
	 * 创建text图标：id,pixelX,pixelY,alarmNamesStr,name
	 * @param values
	 * @returns
	 */
	function creatTxtImg(id, pixelX, pixelY, name, userNo, alarmNamesStr, pointZ){

		// 已存在 先清除
		if(paperTxtSetMap.containsKey(id)){

			paperTxtSetMap.get(id).remove();		//移除图片
			paperTxtSetMap.remove(id); 			//移除缓存

		}

		var _img_w_h = people_width < people_height ? people_width : people_height;
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var paperTxtSet = paper.set();
		//var textArr = [(name + ' ' + userNo)];
		var textArr = [(name)];
		!isItEmpty(alarmNamesStr) && textArr.push(alarmNamesStr);
		var zStr = '高度：' + (pointZ/1000).toFixed(3) + ' 米';
		//!isItEmpty(pointZ) && textArr.push(zStr);
		paperTxtSet.push(
			paper.text(
					pixelX * svgImgScale + mapX ,
					(pixelY - _img_w_h) * svgImgScale + mapY - (8 * textArr.length),
					textArr.join('\n') ).attr({
							"fill":'#39FCFF',//"black",//"dodgerblue",
							"stroke-width": "5",
			                "font-size":"14px"
			            })
		);
		// name + ' ' + userNo + '\n' + alarmNamesStr
		// "姓名："   + name + "\n佩戴高度：" + (pointZ/1000).toFixed(3) + " 米"
		// (pixelY - people_height - txt_oheight) * svgImgScale + mapY
		paperTxtSetMap.put(id,paperTxtSet);

	};

	// 加载 所有 已缓存 text
	function loadAllTxts() {

		// 遍历缓存 人员
		$.each(showTxtMap.keySet(), function(n, key) {

			var values = showTxtMap.get(key);
			var alarmNames = !isItEmpty(values.alarmNames) ? values.alarmNames : '';
			var userNo = !isItEmpty(values.userNo) ? values.userNo : '';
			creatTxtImg(values.id, values.pixelX, values.pixelY, values.name, userNo, alarmNames, values.pointZ);

		});

	};

	// 加载 所有 已缓存 人员 text
	var cnaShowTxt = false;// 是否可展示 text
	this.loadAllPeoTxts = function () {

		// 是否可展示 text
		cnaShowTxt = true;

		// 人员数据 缓存
		var peoLists = showPeopleMap.values();
		// 遍历缓存 人员
		$.each(peoLists, function(n, value) {

			// 空值 中止
			if(isItEmpty(value)) return true;
			// 黑名单中
			if(showTxtMap_black.containsKey(value.id)) return true;

			var alarmNames = !isItEmpty(value.alarmNames) ? value.alarmNames : '';
			var userNo = !isItEmpty(value.userNo) ? value.userNo : '';

			// 创建图元 txt
			creatTxtImg(value.id, value.pixelX, value.pixelY, value.name, userNo, alarmNames, value.pointZ);

			// txt 数据
			var txtObj = {id: value.id,pixelX: value.pixelX, pixelY: value.pixelY, name: value.name, userNo: userNo, alarmNames: alarmNames, pointZ: value.pointZ};
			// 缓存 数据
			showTxtMap.put(value.id, txtObj);

		});

	};

	/**
	 * 清除图标 text 人员信息
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearTxtImg = function (key, type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		if(paperTxtSetMap.containsKey(key)) {

			// 遍历 图元 map 人员信息
			paperTxtSetMap.get(key).remove();//移除图片
			paperTxtSetMap.remove(key); 		//移除缓存

		}

		// 销毁 缓存数据 人员
		isDesTroy && showTxtMap.containsKey(key) && showTxtMap.remove(key);

	};

	/**
	 * 清除图标 text 人员信息
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearAllTxts = function (type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 遍历 图元 map 人员
		$.each(paperTxtSetMap.keySet(), function(n, key) {

			paperTxtSetMap.get(key).remove();//移除图片
			paperTxtSetMap.remove(key); 		//移除缓存

		});

		// 销毁 缓存数据 人员
		isDesTroy && showTxtMap.clear();

		// 是否可展示 text
		isDesTroy && (cnaShowTxt = false);

	};

	// 清除黑名单
	this.clearBlackTxtMap = function () {

		// 清除缓存
		showTxtMap_black.clear();

	};

	/**
	 * 画 追踪图元 可外部调用
	 * 必要字段：id
	 * @param id 人员id
	 * @returns
	 */
	this.trackPeople = function (id) {

		// 获取位置信息
		var posiObj = showPeopleMap.get(id);
		
		// 空值 中止
		if (isItEmpty(posiObj)) return false;

		// 坐标值 转换
		//var currPixelX = ( parseFloat( stationObj.pixelX ) - pOffsetX ) * scaleToPmapW  + mapStartX;
		//var currPixelY = ( parseFloat( stationObj.pixelY ) - pOffsetY ) * scaleToPmapH + mapStartY;
		//var currPixelX = parseFloat( posiObj.pixelX );
		//var currPixelY = parseFloat( posiObj.pixelY );
		
		// 偏移量
		let _ratioX = posiObj.ratioX ? posiObj.ratioX : ratioX;
		// 定制隧道
		if (!posiObj.ratioX && posiObj.appId == '624b863a82a1e7bed3e066baaddf8a3e11') {
			_ratioX = posiObj.bindingType == 3 ? 0.5+0.5*Math.random() : 0.5*Math.random();
		}
		
		var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: posiObj.pointX,y: posiObj.pointY}, _ratioX, ratioY);
		var currPixelX = pointPx.xPx;// transToMap(posiObj.pointX, 'X');
		var currPixelY = pointPx.yPx;// transToMap(posiObj.pointY, 'Y');
		if (Store.state.tunnelAppIds.indexOf(posiObj.appId) > -1) {
			currPixelX = posiObj.pixelX;
			currPixelY = posiObj.pixelY;
		}
		
		let _trackObj = Object.assign({}, showTrackImgMap.get(id));
		// 已绘制 未改变 中止
		if (_trackObj.pixelX == currPixelX && _trackObj.pixelY == currPixelY) {
			if (paperTrackImgSetMap.containsKey(id)) return false;
		}
		
		// 画 追踪图元
		creatTrackImg(id, currPixelX, currPixelY);

	};

	/**
	 * 创建追踪图标
	 * 必要字段：id,pixelX,pixelY
	 * @param values
	 * @returns
	 */
	function creatTrackImg(id,pixelX,pixelY){
		// 已存在 先清除
		if(paperTrackImgSetMap.containsKey(id)){

			paperTrackImgSetMap.get(id).remove();		//移除图片
			paperTrackImgSetMap.remove(id); 			//移除缓存

		}

		var _img_w_h = people_width < people_height ? people_width : people_height;
		var _trackimg_w_h = track_width < track_height ? track_width : track_height;
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var paper_track_img = paper.image(track_img,
				(pixelX - _trackimg_w_h/2) * svgImgScale + mapX,
				(pixelY - _trackimg_w_h - (_img_w_h))  * svgImgScale + mapY,
				_trackimg_w_h * svgImgScale,
				_trackimg_w_h  * svgImgScale
		);
		var paperTrackSet = paper.set();
		paperTrackSet.push(
				paper_track_img
		);
		paperTrackImgSetMap.put(id, paperTrackSet);

		var trackObj = {id:id, pixelX: pixelX, pixelY: pixelY};

		// 缓存 追踪数据
		showTrackImgMap.put(id, trackObj);
	};

	// 加载 所有 已缓存 追踪
	function loadAllTracks() {

		// 遍历缓存 基站
		$.each(showTrackImgMap.keySet(), function(n, key) {

			var values = showTrackImgMap.get(key);
			creatTrackImg(values.id, values.pixelX, values.pixelY);

		});

	};

	/**
	 * 清除图标 追踪 单个
	 * 字段：trackId type
	 * @param trackId: id  type: "destroy" 销毁缓存
	 * @returns
	 */
	this.clearTrack = function (trackId, type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		if(paperTrackImgSetMap.containsKey(trackId)) {

			paperTrackImgSetMap.get(trackId).remove();	//移除图片
			paperTrackImgSetMap.remove(trackId); 		//移除缓存

		}

		// 销毁 缓存数据 基站
		isDesTroy && showTrackImgMap.containsKey(trackId) && showTrackImgMap.remove(trackId);

	};

	/**
	 * 清除图标 追踪
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearAllTracks = function (type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 遍历 图元 map 基站
		$.each(paperTrackImgSetMap.keySet(),function(n,key){

			paperTrackImgSetMap.get(key).remove();	//移除图片
			paperTrackImgSetMap.remove(key); 		//移除缓存

		});

		// 销毁 缓存数据 基站
		isDesTroy && showTrackImgMap.clear();

	};

	/**
	 * 地图 参数 必要
	 *
	 * @pram option obj {}
	 * @param option key
	 */
	this.setMoveZoomParams = function (option) {

		// 空值 中止
		if(isItEmpty(option)) return false;

		if(option.mapMove !== undefined) {
			mapMove = option.mapMove;
		}

		if(option.mapZoom !== undefined) {
			mapZoom = option.mapZoom;
		}

	};

	//============================================= 自定义 矩形 围栏 start =============================================\\
	/**
	 * svg
	 * 方法 滑动获取区域
	 */
	this.setFingerArea = function (callBack) {

		// 缩放、滑动 开关
		mapMove = false;
		mapZoom = false;
		// 正在自定义获取区域
		inFingerDraw = true;

		var svgLeft = 0,
			svgTop = 0;

		var startX, startY;

		var startPointX, startPointY;
		var endPointX, endPointY;
		//手指移动，记录光标相对 #'+ containerId +' 位置
		$('#'+ containerId).on('touchstart', function(e){
			svgLeft = $('#'+ containerId +'>svg').offset().left - $(window).scrollLeft();
			svgTop = $('#'+ containerId +'>svg').offset().top - $(window).scrollTop();
			
			var $this = $(this);

			var _touch = e.originalEvent.targetTouches[0];

			startX = _touch.pageX || _touch.clientX;
			startY = _touch.pageY || _touch.clientY;

			var offsetX = (startX - svgLeft) / pageZoom,
				offsetY = (startY - svgTop) / pageZoom;

			startPointX = (offsetX - mapX)/svgImgScale;
			startPointY = (offsetY - mapY)/svgImgScale;

			startPointX = Math.round(startPointX);
			startPointY = Math.round(startPointY);

		}).on('touchmove', function(e){

			var _touchMove = e.originalEvent.targetTouches[0];

			var moveX = _touchMove.pageX || _touchMove.clientX;
			var moveY = _touchMove.pageY || _touchMove.clientY;

			var moveOffsetX = (moveX - svgLeft)  / pageZoom,
				moveOffsetY = (moveY - svgTop) / pageZoom;

			var movePointX = (moveOffsetX - mapX)/svgImgScale,
				movePointY = (moveOffsetY - mapY)/svgImgScale;
			movePointX = Math.round(movePointX);
			movePointY = Math.round(movePointY);

			endPointX = movePointX;
			endPointY = movePointY;

			var point_1 = [startPointX, startPointY].join(',');
			var point_2 = [endPointX, startPointY].join(',');
			var point_3 = [endPointX, endPointY].join(',');
			var point_4 = [startPointX, endPointY].join(',');

			var points = [point_1, point_2, point_3, point_4, point_1];

			var _row = {
					id: 'fingerRail',
					points: [].concat(points),
					lineObj: {color: 'blue', width: 3}
			}
			// 绘制电子围栏
			that.loadFingerRail(_row);

		}).on('touchend', function (e) {

			var _touchChanged = e.originalEvent.changedTouches[0];

			var changedX = _touchChanged.pageX || _touchChanged.clientX;
			var changedY = _touchChanged.pageY || _touchChanged.clientY;

			if(!isItEmpty(changedX) && !isItEmpty(changedY)) {

				var	endX = startX + changedX;
				var	endY = startY + changedY;

				var endOffsetX = (changedX - svgLeft) / pageZoom,
					endOffsetY = (changedY - svgTop) / pageZoom;

				var _endPointX = (endOffsetX - mapX)/svgImgScale,
					_endPointY = (endOffsetY - mapY)/svgImgScale;
				_endPointX = Math.round(_endPointX);
				_endPointY = Math.round(_endPointY);

				endPointX = _endPointX;
				endPointY = _endPointY;

			}

			var point_1 = [startPointX, startPointY].join(',');
			var point_2 = [endPointX, startPointY].join(',');
			var point_3 = [endPointX, endPointY].join(',');
			var point_4 = [startPointX, endPointY].join(',');

			var points = [point_1, point_2, point_3, point_4, point_1];
			var pointStr = [].concat(points).join(';');

			if(startPointX == endPointX && startPointY == endPointY) {
				return false;
			}

			var _row = {
					id: 'fingerRail',
					points: [].concat(points),
					lineObj: {color: 'blue', width: 3}
			}
			// 绘制电子围栏
			that.loadFingerRail(_row);

			// 转换成父级坐标
			var pStartPointX = getPmapPXY(startPointX, 'X');
			var pStartPointY = getPmapPXY(startPointY, 'Y');
			var pEndPointX = getPmapPXY(endPointX, 'X');
			var pEndPointY = getPmapPXY(endPointY, 'Y');

			var pPoint_1 = [pStartPointX, pStartPointY].join(',');
			var pPoint_2 = [pEndPointX, pStartPointY].join(',');
			var pPoint_3 = [pEndPointX, pEndPointY].join(',');
			var pPoint_4 = [pStartPointX, pEndPointY].join(',');

			var pPoints = [pPoint_1, pPoint_2, pPoint_3, pPoint_4, pPoint_1];
			var pPointStr = [].concat(pPoints).join(';');
			
			var ptOpt = {
				startPointX: startPointX,
				startPointY: startPointY,
				endPointX: endPointX,
				endPointY: endPointY
			};// 起止点参数
			
			// 回调
			typeof callBack == 'function' && callBack(pPointStr, ptOpt);

		});

		//鼠标移动，记录光标相对 #'+ containerId +' 位置
		$('#'+ containerId).on('mousedown', function(e){
			svgLeft = $('#'+ containerId +'>svg').offset().left - $(window).scrollLeft();
			svgTop = $('#'+ containerId +'>svg').offset().top - $(window).scrollTop();
			
			var e = e || event;
			var $this = $(this);

			// 按下左键
			if(e.button <= 0) {

				startX = e.clientX || e.pageX;
				startY = e.clientY || e.pageY;

				var offsetX = (startX - svgLeft) / pageZoom,
					offsetY = (startY - svgTop) / pageZoom;

				startPointX = (offsetX - mapX)/svgImgScale;
				startPointY = (offsetY - mapY)/svgImgScale;

				startPointX = Math.round(startPointX);
				startPointY = Math.round(startPointY);

				$this.on('mousemove', function(e){

					var moveE = e || event;

					// 按下左键
					if(moveE.button <= 0 && moveE.buttons == 1){
						
						var moveX = moveE.clientX || moveE.pageX;
						var moveY = moveE.clientY || moveE.pageY;

						var moveOffsetX = (moveX - svgLeft) / pageZoom,
							moveOffsetY = (moveY - svgTop) / pageZoom;

						var movePointX = (moveOffsetX - mapX)/svgImgScale,
							movePointY = (moveOffsetY - mapY)/svgImgScale;
						movePointX = Math.round(movePointX);
						movePointY = Math.round(movePointY);

						endPointX = movePointX;
						endPointY = movePointY;

						var point_1 = [startPointX, startPointY].join(',');
						var point_2 = [endPointX, startPointY].join(',');
						var point_3 = [endPointX, endPointY].join(',');
						var point_4 = [startPointX, endPointY].join(',');

						var points = [point_1, point_2, point_3, point_4, point_1];

						var _row = {
								id: 'fingerRail',
								points: [].concat(points),
								lineObj: {color: 'blue', width: 3}
						}

						// 绘制电子围栏
						that.loadFingerRail(_row);
					} else {

						// 清除图标 自定义区域
						that.clearFingerRail('fingerRail', 'destroy');
						// 注销事件
						$this.off('mousemove');

					}
				});

			} else {
				// 清除图标 自定义区域
				that.clearFingerRail('fingerRail', 'destroy');
				// 注销事件
				$this.off('mousemove');
			}

		}).on('mouseup', function (e) {

			var endE = e || event;

			// 注销事件
			var $this = $(this);
			$this.off('mousemove');

			if(endE.button <= 0) {

				var endX = endE.clientX || endE.pageX;
				var endY = endE.clientY || endE.pageY;

				var endOffsetX = (endX - svgLeft) / pageZoom,
					endOffsetY = (endY - svgTop) / pageZoom;

				var _endPointX = (endOffsetX - mapX)/svgImgScale,
					_endPointY = (endOffsetY - mapY)/svgImgScale;
				_endPointX = Math.round(_endPointX);
				_endPointY = Math.round(_endPointY);

				endPointX = _endPointX;
				endPointY = _endPointY;

				var point_1 = [startPointX, startPointY].join(',');
				var point_2 = [endPointX, startPointY].join(',');
				var point_3 = [endPointX, endPointY].join(',');
				var point_4 = [startPointX, endPointY].join(',');

				var points = [point_1, point_2, point_3, point_4, point_1];
				var pointStr = [].concat(points).join(';');

				if(startPointX == endPointX && startPointY == endPointY) {
					return false;
				}

				var _row = {
						id: 'fingerRail',
						points: [].concat(points),
						lineObj: {color: 'blue', width: 3}
				}
				// 绘制电子围栏
				that.loadFingerRail(_row);

				// 转换成父级坐标
				var pStartPointX = getPmapPXY(startPointX, 'X');
				var pStartPointY = getPmapPXY(startPointY, 'Y');
				var pEndPointX = getPmapPXY(endPointX, 'X');
				var pEndPointY = getPmapPXY(endPointY, 'Y');

				var pPoint_1 = [pStartPointX, pStartPointY].join(',');
				var pPoint_2 = [pEndPointX, pStartPointY].join(',');
				var pPoint_3 = [pEndPointX, pEndPointY].join(',');
				var pPoint_4 = [pStartPointX, pEndPointY].join(',');

				var pPoints = [pPoint_1, pPoint_2, pPoint_3, pPoint_4, pPoint_1];
				var pPointStr = [].concat(pPoints).join(';');
				
				var ptOpt = {
					startPointX: startPointX,
					startPointY: startPointY,
					endPointX: endPointX,
					endPointY: endPointY
				};// 起止点参数
				
				// 回调
				typeof callBack == 'function' && callBack(pPointStr, ptOpt);

			}

		});

	};

	/**
	 * svg
	 * 方法 禁止滑动获取区域
	 */
	this.stopFingerArea = function (callBack, keepFlag=false) {

		// 缩放、滑动 开关
		mapMove = true;
		mapZoom = true;
		// 正在自定义获取区域
		inFingerDraw = false;

		// 注销事件
		$('#'+ containerId).off('touchstart').off('touchmove').off('touchend');
		$('#'+ containerId).off('mousedown').off('mousemove').off('mouseup');

		// 移除电子围栏
		!keepFlag && that.clearFingerRail('fingerRail', 'destroy');

		// 回调
		typeof callBack == 'function' && callBack();

		// 点击地图 输出日志
		//canShowClickLog && clickPaper_log();

	};

	/**
	 * svg point
	 * 坐标转换
	 */
	function getPmapPXY(_pixel, _type) {

		var currPixel;
		if(_type == 'Y') {

			currPixel = (parseInt(_pixel) - mapStartY) / scaleToPmapH + pOffsetY;

		} else {

			currPixel = (parseInt(_pixel) - mapStartX) / scaleToPmapW + pOffsetX;

		}

		return Math.round(currPixel);

	}
	//============================================= 自定义 矩形 围栏 end =============================================\\

	//============================================= 移动绘制 矩形 start =============================================\\
	/**
	 * 画 自定义区域 可外部调用
	 * 必要字段：railObj
	 * @param railObj Rail数据json {}
	 * @returns
	 */
	this.loadFingerRail = function (railObj) {
		//console.log(railObj);

		showFingerRailMap.put(railObj.id, railObj);

		var lineObj = railObj.lineObj;
		// 画 Rail
		creatFingerRail(railObj.id, railObj.points, lineObj);

	};

	/**
	 * 创建自定义区域
	 * 必要字段：id,pixelX,pixelY
	 * @param values
	 * @returns
	 */
	function creatFingerRail(id, points, lineObj){

		// 已存在 先清除
		if(paperFingerRailSetMap.containsKey(id)){

			paperFingerRailSetMap.get(id).remove();		//移除图片
			paperFingerRailSetMap.remove(id); 			//移除缓存

		}

		var colorStr = !isItEmpty(lineObj) && !isItEmpty(lineObj.color) ? lineObj.color : '#e0fb0f';// "#e0fb0f"
		var widthVal = !isItEmpty(lineObj) && !isItEmpty(lineObj.width) ? lineObj.width : 2;// 2

		var line_path = "";
		$.each(points, function (index, value) {
			var _x_y = value.split(',');

			// 坐标值 转换
			var _x = parseFloat( _x_y[0] );
			var _y = parseFloat( _x_y[1] );
			//var _x = transToMap( _x_y[0] , 'X');
			//var _y = transToMap( _x_y[1] , 'Y');
			var x = _x * svgImgScale + mapX;
			var y = _y * svgImgScale + mapY;

			if(index == 0) {

				line_path += "M" + x + "," + y;

			} else {

				line_path += ",L," + x + "," + y;

			}

		});
		line_path + " z";
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var lineT = paper.path(line_path).attr({
			"stroke": colorStr,
			"stroke-width": widthVal
		});
		var paperRailSet = paper.set();
		paperRailSet.push(
				lineT
		);
		paperFingerRailSetMap.put(id,paperRailSet);

	};

	// 加载 所有 已缓存 自定义区域
	function loadAllFingerRails() {

		// 遍历缓存 基站
		$.each(showFingerRailMap.keySet(), function(n, key) {

			var values = showFingerRailMap.get(key);
			var lineObj = values.lineObj;
			creatFingerRail(values.id, values.points, lineObj);

		});

	};

	/**
	 * 清除图标 自定义区域
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearFingerRail = function (railId, type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		if(paperFingerRailSetMap.containsKey(railId)) {

			paperFingerRailSetMap.get(railId).remove();	//移除图片
			paperFingerRailSetMap.remove(railId); 		//移除缓存

		}

		// 销毁 缓存数据 基站
		isDesTroy && showFingerRailMap.containsKey(railId) && showFingerRailMap.remove(railId);

	};

	/**
	 * 清除图标 自定义区域
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearFingerAllRails = function (type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 遍历 图元 map 基站
		$.each(paperFingerRailSetMap.keySet(),function(n,key){

			paperFingerRailSetMap.get(key).remove();	//移除图片
			paperFingerRailSetMap.remove(key); 		//移除缓存

		});

		// 销毁 缓存数据 基站
		isDesTroy && showFingerRailMap.clear();

	};
	//============================================= 移动绘制 矩形 end =============================================\\

	/**
	 * 画 电子围栏 可外部调用
	 * 必要字段：railObj
	 * @param railObj Rail数据json {}
	 * @returns
	 */
	this.loadRail = function (railObj) {
		//console.log(railObj);

		showRailMap.put(railObj.id, railObj);

		var lineObj = railObj.lineObj;
		// 画 Rail
		creatRail(railObj.id, railObj.points, lineObj);

	};

	/**
	 * 创建电子围栏
	 * 必要字段：id,pixelX,pixelY
	 * @param values
	 * @returns
	 */
	function creatRail(id, points, lineObj){

		// 已存在 先清除
		if(paperRailSetMap.containsKey(id)){

			paperRailSetMap.get(id).remove();		//移除图片
			paperRailSetMap.remove(id); 			//移除缓存

		}

		var colorStr = !isItEmpty(lineObj) && !isItEmpty(lineObj.color) ? lineObj.color : '#e0fb0f';// "#e0fb0f"
		var widthVal = !isItEmpty(lineObj) && !isItEmpty(lineObj.width) ? lineObj.width : 2;// 2
		
		let _ratioX = lineObj.ratioX ? lineObj.ratioX : ratioX;
		
		var line_path = "";
		$.each(points, function (index, value) {
			var _x_y = value.split(',');

			// 坐标值 转换
			//var _x = parseFloat( _x_y[0] );
			//var _y = parseFloat( _x_y[1] );
			
			var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: _x_y[0],y: _x_y[1]}, _ratioX, ratioY);
			var _x = pointPx.xPx;// transToMap( _x_y[0] , 'X');
			var _y = pointPx.yPx;// transToMap( _x_y[1] , 'Y');
			var x = _x * svgImgScale + mapX;
			var y = _y * svgImgScale + mapY;

			if(index == 0) {

				line_path += "M" + x + "," + y;

			} else {

				line_path += ",L," + x + "," + y;

			}

		});
		line_path + " z";
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var lineT = paper.path(line_path).attr({
			"stroke": colorStr,
			"stroke-width": widthVal
		});
		var paperRailSet = paper.set();
		paperRailSet.push(
				lineT
		);
		paperRailSetMap.put(id,paperRailSet);

	};

	// 加载 所有 已缓存 电子围栏
	function loadAllRails() {

		// 遍历缓存 基站
		$.each(showRailMap.keySet(), function(n, key) {

			var values = showRailMap.get(key);
			var lineObj = values.lineObj;
			creatRail(values.id, values.points, lineObj);

		});

	};

	/**
	 * 清除图标 电子围栏
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearRail = function (railId, type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		if(paperRailSetMap.containsKey(railId)) {

			paperRailSetMap.get(railId).remove();	//移除图片
			paperRailSetMap.remove(railId); 		//移除缓存

		}

		// 销毁 缓存数据 基站
		isDesTroy && showRailMap.containsKey(railId) && showRailMap.remove(railId);

	};

	/**
	 * 清除图标 电子围栏
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearAllRails = function (type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 遍历 图元 map 基站
		$.each(paperRailSetMap.keySet(),function(n,key){

			paperRailSetMap.get(key).remove();	//移除图片
			paperRailSetMap.remove(key); 		//移除缓存

		});

		// 销毁 缓存数据 基站
		isDesTroy && showRailMap.clear();

	};

	//======================================== 虚线 start ========================================\\
	/**
	 * TODO 鼠标移动 绘制虚线
	 */
	function moveToDotted(ev) {
		var oE = ev || event;

		// 可绘制电子围栏
		if (!canDrawPoints) return false;

		// 基准点
		var basePointXY = pointGroup[pointGroup.length - 1];
		// 空值 中止
		if (isItEmpty(basePointXY)) return false;

		var firstPoint = pointGroup[0].split(',');
		var basePointXYs = basePointXY.split(',');

		// 首尾距离
		var dis = calcDis({x: firstPoint[0], y: firstPoint[1]}, {x: basePointXYs[0], y: basePointXYs[1]}, 1, 1);
		if (pointGroup.length > 3 && dis * svgImgScale <= limitDis) {
			// 清除 虚线
			that.clearDottedLine('DOTTEED_Line', 'destroy');
			return false;
		}

		var svgLeft = $('#'+ containerId +'>svg').offset().left - $(window).scrollLeft(),
			svgTop = $('#'+ containerId +'>svg').offset().top - $(window).scrollTop();
		var clientX = oE.clientX || oE.pageX,
			clientY = oE.clientY || oE.pageY;
		var offsetX = (clientX - svgLeft) / pageZoom,
			offsetY = (clientY - svgTop) / pageZoom;

		var pointX = (offsetX - mapX)/svgImgScale,
			pointY = (offsetY - mapY)/svgImgScale;
		pointX = Math.round(pointX) + (1 * (basePointXYs[0] < pointX ? -1 : 1) / svgImgScale);
		pointY = Math.round(pointY) + (1 * (basePointXYs[1] < pointY ? -1 : 1) / svgImgScale);

		var pointXY = [pointX, pointY].join(',');
		var dottedObj = {id: 'DOTTEED_Line', points: [basePointXY, pointXY]};

		// 画 虚线 图元
		that.loadDottedLine(dottedObj);

	};

	/**
	 * 画 虚线 图元 可外部调用
	 * 必要字段：dottedObj
	 * @param dottedObj dot数据json {}
	 * @returns
	 */
	this.loadDottedLine = function (dottedObj) {

		// 画 dotted
		creatDottedLine(dottedObj.id, dottedObj.points, dottedObj.dottedOpt, dottedObj.textFlag);

		// 缓存  虚线数据
		showDottedLineMap.put(dottedObj.id, dottedObj);
	};

	/**
	 * 创建 虚线图标
	 * 必要字段：id,pixelX,pixelY
	 * @param values
	 * @returns
	 */
	function creatDottedLine(id, points, dottedOpt, textFlag){

		// 已存在 先清除
		if(paperDottedLineMap.containsKey(id)){

			paperDottedLineMap.get(id).remove();				//移除图片
			paperDottedLineMap.remove(id); 					//移除缓存

		}

		// 画布不存在 种植
		if(!paper) return false;

		var points = !isItEmpty(points) ? points : [];
		var dottedOpt = !isItEmpty(dottedOpt) ? dottedOpt : {};

		var colorStr = !isItEmpty(dottedOpt) && !isItEmpty(dottedOpt.color) ? dottedOpt.color : '#060606';// "#e0fb0f"
		var widthVal = !isItEmpty(dottedOpt) && !isItEmpty(dottedOpt.width) ? dottedOpt.width : 2;// 2

		var line_path = "";
		$.each(points, function (index, value) {
			var _x_y = value.split(',');

			// 坐标值 转换
			var _x = parseFloat( _x_y[0] );
			var _y = parseFloat( _x_y[1] );
			var x = _x * svgImgScale + mapX;
			var y = _y * svgImgScale + mapY;

			if(index == 0) {

				line_path += "M" + x + "," + y;

			} else {

				line_path += ",L," + x + "," + y;

			}

		});
		line_path + " z";
		var dottedLine = paper.path(line_path).attr({
			"stroke": colorStr,
			"stroke-width": widthVal,
			"stroke-dasharray": "-"
		});
		var paperDottedLine = paper.set();
		paperDottedLine.push(
				dottedLine
		);
		paperDottedLineMap.put(id,paperDottedLine);

		// 创建 虚线 TXT
		creatDottedTxt(id,points[0],points[points.length - 1],textFlag);

	};

	// 创建 虚线 TXT
	function creatDottedTxt(id,p1,p2,textFlag) {

		// 已存在 先清除  虚线编号
		if(paperDottedTxtMap.containsKey(id)){

			paperDottedTxtMap.get(id).remove();			//移除图片
			paperDottedTxtMap.remove(id); 				//移除缓存

		}
		// 不显示Txt 中止
		if (!textFlag) return false;

		var dotObj = showDottedLineMap.get(id);
		// 空值 中止
		if(isItEmpty(dotObj)) return false;

		var _p1 = p1.split(',');
		var _p1_x = parseFloat(_p1[0]);
		var _p1_y = parseFloat(_p1[1]);

		var _p2 = p2.split(',');
		var _p2_x = parseFloat(_p2[0]);
		var _p2_y = parseFloat(_p2[1]);

		var scaleXs = mapWidthScale.split('/'),
			scaleX = parseFloat( scaleXs[0] ) / parseFloat( scaleXs[1] );
		var scaleYs = mapHeightScale.split('/'),
			scaleY = parseFloat( scaleYs[0] ) / parseFloat( scaleYs[1] );

		var dis = calcDis({x: _p1_x, y: _p1_y}, {x: _p2_x, y: _p2_y}, scaleX, scaleY);
		dis = parseFloat(parseFloat(dis).toFixed(3));

		var dottedOpt = !isItEmpty(dotObj.dottedOpt) ? dotObj.dottedOpt : {};
		var textOpt = !isItEmpty(dotObj.textOpt) ? dotObj.textOpt : {};

		var pixelX = (_p1_x + _p2_x) / 2;
		var pixelY = (_p1_y + _p2_) / 2;
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var paperTxtSet = paper.set();
		var textArr = [(dis + '米')];
		paperTxtSet.push(
			paper.text(
					pixelX * svgImgScale + mapX ,
					(pixelY) * svgImgScale + mapY - (8 * textArr.length),
					textArr.join('\n') ).attr({
							"fill":(textOpt.fill ? textOpt.fill : "dodgerblue"),
							"stroke-width": (textOpt.width ? textOpt.width : 5),
			                "font-size": (textOpt.fontSize ? textOpt.fontSize : "14px")
			            })
		);
		paperDottedTxtMap.put(id,paperTxtSet);

	};


	// 加载 所有 已缓存  虚线
	function loadAllDottedLine() {

		// 遍历缓存  虚线
		$.each(showDottedLineMap.keySet(), function(n, key) {

			var values = showDottedLineMap.get(key);
			creatDottedLine(values.id, values.points, values.dottedOpt, values.textFlag);

		});

	};

	/**
	 * 清除  虚线
	 * 字段：id,type
	 * @param "id" 			 虚线id
	 * @param "destroy" 	销毁缓存
	 * @returns
	 */
	this.clearDottedLine = function (id, type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 移除 img  虚线
		if(paperDottedLineMap.containsKey(id)){

			paperDottedLineMap.get(id).remove();			//移除图片
			paperDottedLineMap.remove(id); 					//移除缓存

		}

		// 移除 text  虚线
		if(paperDottedTxtMap.containsKey(id)){

			paperDottedTxtMap.get(id).remove();			//移除图片
			paperDottedTxtMap.remove(id); 				//移除缓存

		}

		// 销毁 缓存数据  虚线
		isDesTroy && showDottedLineMap.containsKey(id) && showDottedLineMap.remove(id);

	};

	/**
	 * 清除图标  虚线
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearAllDottedLine = function (type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 遍历 图元 map  虚线
		$.each(paperDottedLineMap.keySet(),function(n,key){

			paperDottedLineMap.get(key).remove();			//移除图片
			paperDottedLineMap.remove(key); 				//移除缓存

		});

		// 遍历 图元 map  虚线TXT
		$.each(paperDottedTxtMap.keySet(),function(n,key){

			paperDottedTxtMap.get(key).remove();		//移除图片
			paperDottedTxtMap.remove(key); 				//移除缓存

		});

		// 销毁 缓存数据  虚线
		isDesTroy && showDottedLineMap.clear();

	};
	//======================================== 虚线 end ========================================\\

	//======================================== 圆点 start ========================================\\
	/**
	 * 画 圆点图元 可外部调用
	 * 必要字段：dotObj
	 * @param dotObj dot数据json {}
	 * @returns
	 */
	this.loadDotPosition = function (dotObj) {

		// 坐标值 转换
		//var currPixelX = ( parseFloat( dotObj.pixelX ) - pOffsetX ) * scaleToPmapW  + mapStartX;
		//var currPixelY = ( parseFloat( dotObj.pixelY ) - pOffsetY ) * scaleToPmapH + mapStartY;
		var currPixelX = parseFloat( dotObj.point[0] );
		var currPixelY = parseFloat( dotObj.point[1] );

		var _dotObj = $.extend(true, {}, dotObj, {point: [currPixelX, currPixelY]});

		// 缓存 圆点数据
		showDotsMap.put(dotObj.id, _dotObj);
		//showDotsMap.put(dotObj.id, dotObj);

		// 画 dot
		creatDotImg(dotObj.id, _dotObj.point, dotObj.dotOpt, dotObj.textFlag);

	};

	/**
	 * 创建圆点图标
	 * 必要字段：id,pixelX,pixelY
	 * @param values
	 * @returns
	 */
	function creatDotImg(id, point, dotOpt, textFlag){

		// 已存在 先清除
		if(paperDotsSetMap.containsKey(id)){

			paperDotsSetMap.get(id).remove();				//移除图片
			paperDotsSetMap.remove(id); 					//移除缓存

		}

		// 画布不存在 种植
		if(!paper) return false;

		var point = !isItEmpty(point) ? point : [];
		var dotOpt = !isItEmpty(dotOpt) ? dotOpt : {};

		var dot_img = paper.circle(
				parseFloat(point[0]) * svgImgScale + mapX,
				parseFloat(point[1]) * svgImgScale + mapY,
				(dotOpt.d ? dotOpt.d : 5)
		).attr({
			fill: (dotOpt.fill ? dotOpt.fill : "gold"), 					// 填充色
			stroke: (dotOpt.stroke ? dotOpt.stroke : "crimson"), 			// 边缘线
			"stroke-width":(dotOpt.width ? dotOpt.width : 2) 			// 边缘线  宽度
		});
		var paperDotSet = paper.set();
		paperDotSet.push(
				dot_img
		);
		paperDotsSetMap.put(id,paperDotSet);

		// 创建圆点 TXT
		creatDotTxt(id,point[0],point[1],textFlag);

	};

	// 创建圆点 TXT
	function creatDotTxt(id,pixelX,pixelY,textFlag) {

		// 已存在 先清除 圆点编号
		if(paperDotTxtSetMap.containsKey(id)){

			paperDotTxtSetMap.get(id).remove();			//移除图片
			paperDotTxtSetMap.remove(id); 				//移除缓存

		}
		// 不显示Txt 中止
		if (!textFlag) return false;

		var dotObj = showDotsMap.get(id);
		// 空值 中止
		if(isItEmpty(dotObj)) return false;

		var dotOpt = !isItEmpty(dotObj.dotOpt) ? dotObj.dotOpt : {};
		var textOpt = !isItEmpty(dotObj.textOpt) ? dotObj.textOpt : {};
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var paperTxtSet = paper.set();
		var textArr = [(dotObj.dotText)];
		paperTxtSet.push(
			paper.text(
					pixelX * svgImgScale + mapX ,
					(pixelY) * svgImgScale - (dotOpt.d ? dotOpt.d/2 : 5) + mapY - (8 * textArr.length),
					textArr.join('\n') ).attr({
							"fill":(textOpt.fill ? textOpt.fill : "dodgerblue"),
							"stroke-width": (textOpt.width ? textOpt.width : 5),
			                "font-size": (textOpt.fontSize ? textOpt.fontSize : "14px")
			            })
		);
		paperDotTxtSetMap.put(id,paperTxtSet);

	};


	// 加载 所有 已缓存 圆点
	function loadAllDots() {

		// 遍历缓存 圆点
		$.each(showDotsMap.keySet(), function(n, key) {

			var values = showDotsMap.get(key);
			creatDotImg(values.id, values.point, values.dotOpt, values.textFlag);

		});

	};

	/**
	 * 清除图标 圆点
	 * 字段：id,type
	 * @param "id" 			圆点id
	 * @param "destroy" 	销毁缓存
	 * @returns
	 */
	this.clearDot = function (id, type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 移除 img 圆点
		if(paperDotsSetMap.containsKey(id)){

			paperDotsSetMap.get(id).remove();			//移除图片
			paperDotsSetMap.remove(id); 					//移除缓存

		}

		// 移除 text 圆点
		if(paperDotTxtSetMap.containsKey(id)){

			paperDotTxtSetMap.get(id).remove();			//移除图片
			paperDotTxtSetMap.remove(id); 				//移除缓存

		}

		// 销毁 缓存数据 圆点
		isDesTroy && showDotsMap.containsKey(id) && showDotsMap.remove(id);

	};

	/**
	 * 清除图标 圆点
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearAllDots = function (type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 遍历 图元 map 圆点
		$.each(paperDotsSetMap.keySet(),function(n,key){

			paperDotsSetMap.get(key).remove();			//移除图片
			paperDotsSetMap.remove(key); 				//移除缓存

		});

		// 遍历 图元 map 圆点TXT
		$.each(paperDotTxtSetMap.keySet(),function(n,key){

			paperDotTxtSetMap.get(key).remove();		//移除图片
			paperDotTxtSetMap.remove(key); 				//移除缓存

		});

		// 销毁 缓存数据 圆点
		isDesTroy && showDotsMap.clear();

	};
	//======================================== 圆点 end ========================================\\

	// ============================================= 实时轨迹 start ========================================= \\

	/**
	 * 设置 开关 实时轨迹
	 * @params true/false
	 *
	 */
	this.setIntimeLineFlag = function (_flag) {
		// 开关 展示 实时轨迹
		flag_intime_line = _flag;
	};
	
	// 绘制 线段 实时轨迹 list
	this.loadIntimeSegments = function (posiList) {
		// 空值 中止
		if (isItEmpty(posiList)) return false;
		// 不允许绘制实时轨迹 中止
		if (!flag_intime_line) return false;
		
		// 遍历
		$.each(posiList, function (index, row) {
			
			// 坐标值 转换
			//var currPixelX = ( parseFloat( row.pixelX ) - pOffsetX ) * scaleToPmapW  + mapStartX;
			//var currPixelY = ( parseFloat( row.pixelY ) - pOffsetY ) * scaleToPmapH + mapStartY;
			
			// 偏移量
			let _ratioX = ratioX;
			// 定制隧道
			if (mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e11') {
				_ratioX = 0.5;
			}
			
			var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: row.pointX,y: row.pointY}, _ratioX, ratioY);
			var currPixelX = pointPx.xPx;// transToMap(row.pointX, 'X');
			var currPixelY = pointPx.yPx;// transToMap(row.pointY, 'Y');
			
			var pointObj = {};
			pointObj['id'] = row.id;
			pointObj['ratioX'] = _ratioX;
			
			pointObj['pixelX'] = currPixelX;
			pointObj['pixelY'] = currPixelY;
			
			pointObj['pointX'] = row.pointX;
			pointObj['pointY'] = row.pointY;
			pointObj['pointZ'] = row.pointZ;
			
			// 绘制 线段 实时轨迹
			that.loadIntimeSegment(pointObj);
			
		});
	};
	
	/**
	 * 画 线段 实时轨迹
	 * @params _point
	 *
	 */
	this.loadIntimeSegment = function (pointObj) {

		// 轨迹线 缓存
		var lineObj = showIntimeLineMap.get(pointObj.id);
		// 最近一次 坐标
		var lastPint = '', realLastPoint = '';
		// 最近一次 坐标下标
		var lastIndex = 0;

		// 点坐标
		var point = [pointObj.pixelX, pointObj.pixelY],
			pointStr = point.join(',');
		var realPoint = [pointObj.pointX, pointObj.pointY],
			realPointStr = realPoint.join(',');

		if(isItEmpty(lineObj)) {
			// 首次存储

			lineObj = {};

			lineObj.points = [ pointStr ];
			lineObj.lastPint = pointStr;
			lineObj.realPoints = [ realPointStr ];
			lineObj.lastRealPoints = realPoints;
			lineObj.index = 0;

		} else {
			// 非首次存储

			var points = lineObj.points,
				realPoints = lineObj.realPoints,
				index = lineObj.index;

			lastPint = lineObj.lastPint;
			
			lastIndex = index;

			points.push(pointStr);
			realPoints.push(realPointStr);
			index += 1;

			lineObj.points = points;
			lineObj.lastPint = pointStr;
			lineObj.realPoints = realPoints;
			lineObj.lastRealPint = realPoints;
			lineObj.index = index;

		}

		var segPoints = [lastPint, pointStr];
		// 创建 线段 实时轨迹
		creatIntimeSegment(pointObj.id, segPoints, index, lineObj);

		// 轨迹线 缓存
		showIntimeLineMap.put(pointObj.id, lineObj);

	};

	/**
	 * 创建 线段 实时轨迹
	 * @params _point
	 *
	 */
	function creatIntimeSegment(id, _points, index, option) {

		var lineOid = intimeLineKey + id + index;

		// 已存在 先清除
		if(paperIntimeLineSetMap.containsKey(lineOid)){

			paperIntimeLineSetMap.get(lineOid).remove();		//移除图片
			paperIntimeLineSetMap.remove(lineOid); 			//移除缓存

		}
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var points = !isItEmpty(_points) ? _points : [];
		// 空值 中止
		if(isItEmpty(points) || isItEmpty(points[0])) return false;

		var startXY = points[0].split(','),
			endXY = points[1].split(',');

		var startX = parseInt(startXY[0]) * svgImgScale + mapX,
			startY = parseInt(startXY[1]) * svgImgScale + mapY;
		var endX = parseInt(endXY[0]) * svgImgScale + mapX,
			endY = parseInt(endXY[1]) * svgImgScale + mapY;


		var _lineColor = '#1b66ed';
		var _lineWidth = 2;

		if(!isItEmpty(option) && !isItEmpty(option.color)) {

			_lineColor = option.color;

		}
		if(!isItEmpty(option) && !isItEmpty(option.width)) {
			_lineWidth = option.width;
		}

		var colorStr = _lineColor;
		var widthVal = _lineWidth;

		var line_path = "M" + startX + "," + startY + ",L," + endX + "," + endY + " z";
        var path = paper.path(line_path).attr({
	        "stroke" : colorStr, //"#e0fb0f"
	        "stroke-width" : widthVal //2
    	});

        path.oId = lineOid;
        paperIntimeLineSetMap.put(lineOid, path);

	};

	/**
	 * 加载 所有实时轨迹
	 * @returns
	 */
	function loadAllIntimeSegs() {
		//
		if(!flag_intime_line) return false;
		
		// 偏移量
		let _ratioX = ratioX;
		// 定制隧道
		if (mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e11') {
			_ratioX = 0.5;
		}
		
		// 遍历缓存 实时轨迹
		$.each(showIntimeLineMap.keySet(), function (n, key) {

			var keyOrigin = intimeLineKey + key;

			var segObj = showIntimeLineMap.get(key);
			// 空值 跳过
			if(isItEmpty(segObj) || isItEmpty(segObj.realPoints)) {
				return true;
			}
			
			var railObj = {
					id: keyOrigin,
					points: segObj.realPoints,
					lineObj: {
						color: '#1b66ed',
						ratioX: _ratioX,
						width: 2
					},
			};

			// 画 电子围栏 可外部调用
			that.loadRail(railObj);

		});

	};

	/**
	 * 清除图标 线段
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearIntimeSeg = function (id, type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		var keyOrigin = intimeLineKey + id;

		// 遍历 图元 map 基站
		$.each(paperIntimeLineSetMap.keySet(),function(n,key){

			if(key.indexOf(keyOrigin) > -1) {
				paperIntimeLineSetMap.get(key).remove();	//移除图片
				paperIntimeLineSetMap.remove(key); 		//移除缓存
			}

		});

		// 清除图标 电子围栏
		this.clearRail(keyOrigin, type);

		isDesTroy && showIntimeLineMap.remove(id);

	};

	/**
	 * 清除图标 线段 所有
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearAllIntimeSegs = function (type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 遍历 图元 map 实时轨迹
		$.each(paperIntimeLineSetMap.keySet(),function(n,key){

			paperIntimeLineSetMap.get(key).remove();	//移除图片
			paperIntimeLineSetMap.remove(key); 		//移除缓存

		});

		$.each(showIntimeLineMap.keySet(), function (n, key) {

			var keyOrigin = intimeLineKey + key;
			// 清除图标 电子围栏
			that.clearRail(keyOrigin, type);

		});

		isDesTroy && showIntimeLineMap.clear();

	};

	// ============================================ 实时轨迹 end ============================================ \\


    /*
     * 设置参数 可外部调用
     * 必要字段：option
     * @param option json {}
     * @returns
     */
    this.setBsOpt = function (option) {
        if (!isItEmpty(option.clickBsImg)) {
            clickBsImg = option.clickBsImg;
        }
    };

	/**
	 * 画 基站图元 可外部调用
	 * 必要字段：stationObj
	 * @param stationObj station数据json {}
	 * @returns
	 */
	this.loadStationPosition = function (stationObj) {

		// 坐标值 转换
		//var currPixelX = ( parseFloat( stationObj.pixelX ) - pOffsetX ) * scaleToPmapW  + mapStartX;
		//var currPixelY = ( parseFloat( stationObj.pixelY ) - pOffsetY ) * scaleToPmapH + mapStartY;
		//var currPixelX = parseFloat( stationObj.pointXPx );
		//var currPixelY = parseFloat( stationObj.pointYPx );
		
		var _ratioY = ratioY;
		let stationY = stationObj.pointY;
		if (stationObj.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || stationObj.appId == '624b863a82a1e7bed3e066baaddf8a3e6') {
			//stationY = stationObj.pointY + 10;
			_ratioY = -0.5;
		}
		
		var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: stationObj.pointX,y: stationY}, ratioX, _ratioY);
		var currPixelX = pointPx.xPx;// transToMap( stationObj.pointX , 'X');
		var currPixelY = pointPx.yPx;// transToMap( stationObj.pointY , 'Y');
		
		// 更换主键
		stationObj.id = stationObj.bsId;
		// 缓存 基站数据
		//showStationMap.put(stationObj.id, $.extend({}, stationObj, {pixelX: currPixelX, pixelY: currPixelY}));
		showStationMap.put(stationObj.id, Object.assign({}, stationObj, {pointXPx: currPixelX, pointYPx: currPixelY}));
		
		// 画 station
		creatStationImg(stationObj.id, currPixelX, currPixelY);

	};

	/**
	 * 创建基站图标
	 * 必要字段：id,pixelX,pixelY
	 * @param values
	 * @returns
	 */
	function creatStationImg(id,pixelX,pixelY){

		// 已存在 先清除
		if(paperStationSetMap.containsKey(id)){

			paperStationSetMap.get(id).remove();		//移除图片
			paperStationSetMap.remove(id); 			//移除缓存

		}

		var bsObj = showStationMap.get(id);
		
		var _img_w_h = bs_width < bs_height ? bs_width : bs_height;
		
		var titArr = [
			'安装序号：'+ bsObj.bsSerial,
			'基站编号：'+ bsObj.bsId,
			'序列号：'+ bsObj.sid,
			'基站状态：'+ (GlobalParam.bsStatus[bsObj.status] ? GlobalParam.bsStatus[bsObj.status] : '----'),
			'uwb-ip：'+ bsObj.localAddress,
			'上位机IP：'+ bsObj.targetAddress,
			'时隙：'+ bsObj.timeSlot,
			'功率(db)：'+ (GlobalParam.power1s[bsObj.sendPower1] + ' + ' + GlobalParam.power2s[bsObj.sendPower2]),
			'坐标X(m)：'+ bsObj.pointX,
			'坐标Y(m)：'+ bsObj.pointY,
			'坐标Z(m)：'+ bsObj.pointZ
		];
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var bs_img = paper.image(base_station_img,
				(pixelX - _img_w_h/2) * svgImgScale + mapX,
				(pixelY - _img_w_h/2)  * svgImgScale + mapY,
				_img_w_h * svgImgScale,
				_img_w_h  * svgImgScale
		).attr({
			title: titArr.join('\n')
		}).dblclick(function(){
            clickBsImg && clickBsImg(bsObj);
        });
		var paperStationSet = paper.set();
		paperStationSet.push(
				bs_img
		);
		paperStationSetMap.put(id,paperStationSet);

		// 创建基站 TXT
		creatStationTxt(id,pixelX,pixelY);

	};

	// 创建基站 TXT
	function creatStationTxt(id,pixelX,pixelY) {

		// 已存在 先清除 基站序列号
		if(paperBsTxtSetMap.containsKey(id)){

			paperBsTxtSetMap.get(id).remove();		//移除图片
			paperBsTxtSetMap.remove(id); 			//移除缓存

		}

		var bsObj = showStationMap.get(id);
		// 空值 中止
		if(isItEmpty(bsObj)) return false;

		var _img_w_h = bs_width < bs_height ? bs_width : bs_height;

		var textOpt = !isItEmpty(bsObj.textOpt) ? bsObj.textOpt : {};
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var paperTxtSet = paper.set();
		var textArr = [(bsObj.sid + '('+ bsObj.timeSlot +')')];
		paperTxtSet.push(
			paper.text(
					pixelX * svgImgScale + mapX ,
					(pixelY - _img_w_h/2) * svgImgScale + mapY - (8 * textArr.length),
					textArr.join('\n') ).attr({
							"fill":(textOpt.fill ? textOpt.fill : "#39FCFF"),// dodgerblue
							"stroke-width": (textOpt.width ? textOpt.width : 5),
			                "font-size": (textOpt.fontSize ? textOpt.fontSize : "14px")
			            })
		);
		paperBsTxtSetMap.put(id,paperTxtSet);

	};


	// 加载 所有 已缓存 基站
	function loadAllStations() {
		
		// 遍历缓存 基站
		$.each(showStationMap.keySet(), function(n, key) {

			var values = showStationMap.get(key);
			creatStationImg(values.id, values.pointXPx, values.pointYPx);
			
		});

	};

	/**
	 * 清除图标 基站
	 * 字段：id,type
	 * @param "id" 			基站id
	 * @param "destroy" 	销毁缓存
	 * @returns
	 */
	this.clearStation = function (id, type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 移除 img 基站
		if(paperStationSetMap.containsKey(id)){

			paperStationSetMap.get(id).remove();		//移除图片
			paperStationSetMap.remove(id); 				//移除缓存

		}

		// 移除 text 基站
		if(paperBsTxtSetMap.containsKey(id)){

			paperBsTxtSetMap.get(id).remove();			//移除图片
			paperBsTxtSetMap.remove(id); 				//移除缓存

		}

		// 销毁 缓存数据 基站
		isDesTroy && showStationMap.containsKey(id) && showStationMap.remove(id);

	};

	/**
	 * 清除图标 基站
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearAllStations = function (type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 遍历 图元 map 基站
		$.each(paperStationSetMap.keySet(),function(n,key){

			paperStationSetMap.get(key).remove();	//移除图片
			paperStationSetMap.remove(key); 		//移除缓存

		});

		// 遍历 图元 map 基站TXT
		$.each(paperBsTxtSetMap.keySet(),function(n,key){

			paperBsTxtSetMap.get(key).remove();	//移除图片
			paperBsTxtSetMap.remove(key); 		//移除缓存

		});

		// 销毁 缓存数据 基站
		isDesTroy && showStationMap.clear();

	};

    /**
     * 设置参数 可外部调用
     * 必要字段：option
     * @param option json {}
     * @returns
     */
	this.setCameraOpt = function (option) {
	    if (!isItEmpty(option.clickCameraImg)) {
            clickCameraImg = option.clickCameraImg;
        }
    };
	/**
	 * 画 摄像头图元 可外部调用
	 * 必要字段：stationObj
	 * @param stationObj station数据json {}
	 * @returns
	 */
	this.loadCameraPosition = function (cameraObj) {

		// 坐标值 转换
		//var currPixelX = ( parseFloat( cameraObj.pixelX ) - pOffsetX ) * scaleToPmapW  + mapStartX;
		//var currPixelY = ( parseFloat( cameraObj.pixelY ) - pOffsetY ) * scaleToPmapH + mapStartY;
		//var currPixelX = parseFloat( cameraObj.pointXPx );
		//var currPixelY = parseFloat( cameraObj.pointYPx );
		
		var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: cameraObj.pointX,y: cameraObj.pointY}, ratioX, ratioY);
		var currPixelX = pointPx.xPx;// transToMap( cameraObj.pointX , 'X');
		var currPixelY = pointPx.yPx;// transToMap( cameraObj.pointY , 'Y');
		
		// 缓存 摄像头数据
		//showCamerasMap.put(cameraObj.id, $.extend({}, cameraObj, {pixelX: currPixelX, pixelY: currPixelY}));
		showCamerasMap.put(cameraObj.id, cameraObj);

		// 画 camera
		creatCameraImg(cameraObj.id, currPixelX, currPixelY);

	};

	/**
	 * 创建摄像头图标
	 * 必要字段：id,pixelX,pixelY
	 * @param values
	 * @returns
	 */
	function creatCameraImg(id,pixelX,pixelY){

		// 已存在 先清除
		if(paperCamerasSetMap.containsKey(id)){

			paperCamerasSetMap.get(id).remove();		//移除图片
			paperCamerasSetMap.remove(id); 			//移除缓存

		}

		var _img_w_h = camera_width < camera_height ? camera_width : camera_height;
        var cameraObj = showCamerasMap.get(id);
        // console.log(cameraObj)
        
        // 空值 中止
		if (isItEmpty(paper)) return false;
        
		var ca_img = paper.image(camera_img,
				(pixelX - _img_w_h/2) * svgImgScale + mapX,
				(pixelY - _img_w_h/2)  * svgImgScale + mapY,
				_img_w_h * svgImgScale,
				_img_w_h  * svgImgScale
		).attr({
            title: [('视频名称：'+ cameraObj.diskChannelName), ('视频编号：'+ cameraObj.number), ('视频IP：' + (cameraObj.readMode==1?cameraObj.diskIp:cameraObj.cameraIp)),('通道号：' + (cameraObj.readMode==1?cameraObj.diskChannelNo:'----')), ('坐标X(m)：'+ (!isItEmpty(cameraObj.pointX) ? cameraObj.pointX.toFixed(3) : '----')), ('坐标Y(m)：'+ (!isItEmpty(cameraObj.pointY) ? cameraObj.pointY.toFixed(3) : '----')), ('坐标Z(m)：'+ (!isItEmpty(cameraObj.pointZ) ? cameraObj.pointZ.toFixed(3) : '----'))].join('\n')
        }).dblclick(function(){
		    clickCameraImg && clickCameraImg(cameraObj);
		});
		var paperCameras_Set = paper.set();
		paperCameras_Set.push(
				ca_img
		);
		paperCamerasSetMap.put(id,paperCameras_Set);

	};

	// 加载 所有 已缓存 摄像头
	function loadAllCameras() {

		// 遍历缓存 摄像头
		$.each(showCamerasMap.keySet(), function(n, key) {

			var values = showCamerasMap.get(key);
			var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: values.pointX,y: values.pointY}, ratioX, ratioY);
			var pointXPx = pointPx.xPx;// transToMap( cameraObj.pointX , 'X');
			var pointYPx = pointPx.yPx;// transToMap( cameraObj.pointY , 'Y');
			creatCameraImg(values.id, pointXPx, pointYPx);

		});

	};

	/**
	 * 清除图标 摄像头
	 * 字段：id,type
	 * @param "id" 			摄像头id
	 * @param "destroy" 	销毁缓存
	 * @returns
	 */
	this.clearCamera = function (id, type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 移除 img 摄像头
		if(paperCamerasSetMap.containsKey(id)){

			paperCamerasSetMap.get(id).remove();		//移除图片
			paperCamerasSetMap.remove(id); 				//移除缓存

		}

		// 销毁 缓存数据 摄像头
		isDesTroy && showCamerasMap.containsKey(id) && showCamerasMap.remove(id);

	};

	/**
	 * 清除图标 摄像头
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearAllCameras = function (type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 遍历 图元 map 摄像头
		$.each(paperCamerasSetMap.keySet(),function(n,key){

			paperCamerasSetMap.get(key).remove();	//移除图片
			paperCamerasSetMap.remove(key); 		//移除缓存

		});

		// 销毁 缓存数据 摄像头
		isDesTroy && showCamerasMap.clear();

	};

	/**
	 * 画 旗帜图元 可外部调用
	 * 必要字段：flagimgObj
	 * @param flagimgObj flagimg数据json {}
	 * @returns
	 */
	this.loadFlagimgPosition = function (flagimgObj) {

		// 坐标值 转换
		//var currPixelX = ( parseFloat( flagimgObj.pixelX ) - pOffsetX ) * scaleToPmapW  + mapStartX;
		//var currPixelY = ( parseFloat( flagimgObj.pixelY ) - pOffsetY ) * scaleToPmapH + mapStartY;
		//var currPixelX = parseFloat( flagimgObj.pixelX );
		//var currPixelY = parseFloat( flagimgObj.pixelY );
		
		var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: flagimgObj.pointX,y: flagimgObj.pointY}, ratioX, ratioY);
		var currPixelX = pointPx.xPx;// transToMap( flagimgObj.pointX , 'X');
		var currPixelY = pointPx.yPx;// transToMap( flagimgObj.pointY , 'Y');

		// 缓存 旗帜数据
		showFlagimgMap.put(flagimgObj.id, $.extend({}, flagimgObj, {pixelX: currPixelX, pixelY: currPixelY}));
		//showFlagimgMap.put(flagimgObj.id, flagimgObj);

		// 画 flagimg
		creatFlagimgImg(flagimgObj.id, currPixelX, currPixelY, flagimgObj.textFlag);

	};

	/**
	 * 创建旗帜图标
	 * 必要字段：id,pixelX,pixelY
	 * @param values
	 * @returns
	 */
	function creatFlagimgImg(id,pixelX,pixelY, textFlag){

		// 已存在 先清除
		if(paperFlagimgSetMap.containsKey(id)){

			paperFlagimgSetMap.get(id).remove();		//移除图片
			paperFlagimgSetMap.remove(id); 			//移除缓存

		}

		var _flagimg_width = flagimg_width > flagimg_height * 0.76 ? flagimg_height * 0.76 : flagimg_width;
		var _flagimg_height = _flagimg_width / 0.76;
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var flagimg_img = paper.image(base_flagimg_img,
				(pixelX - _flagimg_width/2) * svgImgScale + mapX,
				(pixelY - _flagimg_height)  * svgImgScale + mapY,
				_flagimg_width * svgImgScale,
				_flagimg_height  * svgImgScale
		);
		var paperFlagimgSet = paper.set();
		paperFlagimgSet.push(
				flagimg_img
		);
		paperFlagimgSetMap.put(id,paperFlagimgSet);

		// 创建旗帜 TXT
		creatFlagimgTxt(id,pixelX,pixelY,textFlag);

	};

	// 创建旗帜 TXT
	function creatFlagimgTxt(id,pixelX,pixelY,textFlag) {

		// 已存在 先清除 旗帜编号
		if(paperFlagTxtSetMap.containsKey(id)){

			paperFlagTxtSetMap.get(id).remove();		//移除图片
			paperFlagTxtSetMap.remove(id); 				//移除缓存

		}
		// 不显示 Txt 中止
		if (!textFlag) return false;

		var flagimgObj = showFlagimgMap.get(id);
		// 空值 中止
		if(isItEmpty(flagimgObj)) return false;

		var textOpt = !isItEmpty(flagimgObj.textOpt) ? flagimgObj.textOpt : {};

		var _flagimg_width = flagimg_width > flagimg_height * 0.76 ? flagimg_height * 0.76 : flagimg_width;
		var _flagimg_height = _flagimg_width / 0.76;
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var paperTxtSet = paper.set();
		var textArr = [(flagimgObj.flagText)];
		paperTxtSet.push(
			paper.text(
					pixelX * svgImgScale + mapX ,
					(pixelY - _flagimg_height) * svgImgScale + mapY - (8 * textArr.length),
					textArr.join('\n') ).attr({
							"fill":(textOpt.fill ? textOpt.fill : "dodgerblue"),
							"stroke-width": (textOpt.width ? textOpt.width : 5),
			                "font-size": (textOpt.fontSize ? textOpt.fontSize : "14px")
			            })
		);
		paperFlagTxtSetMap.put(id,paperTxtSet);

	};


	// 加载 所有 已缓存 旗帜
	function loadAllFlagimgs() {

		// 遍历缓存 旗帜
		$.each(showFlagimgMap.keySet(), function(n, key) {

			var values = showFlagimgMap.get(key);
			creatFlagimgImg(values.id, values.pixelX, values.pixelY, values.textFlag);

		});

	};

	/**
	 * 清除图标 旗帜
	 * 字段：id,type
	 * @param "id" 			旗帜id
	 * @param "destroy" 	销毁缓存
	 * @returns
	 */
	this.clearFlagimg = function (id, type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 移除 img 旗帜
		if(paperFlagimgSetMap.containsKey(id)){

			paperFlagimgSetMap.get(id).remove();		//移除图片
			paperFlagimgSetMap.remove(id); 				//移除缓存

		}

		// 移除 text 旗帜
		if(paperFlagTxtSetMap.containsKey(id)){

			paperFlagTxtSetMap.get(id).remove();			//移除图片
			paperFlagTxtSetMap.remove(id); 				//移除缓存

		}

		// 销毁 缓存数据 旗帜
		isDesTroy && showFlagimgMap.containsKey(id) && showFlagimgMap.remove(id);

	};

	/**
	 * 清除图标 旗帜
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearAllFlagimgs = function (type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 遍历 图元 map 旗帜
		$.each(paperFlagimgSetMap.keySet(),function(n,key){

			paperFlagimgSetMap.get(key).remove();	//移除图片
			paperFlagimgSetMap.remove(key); 		//移除缓存

		});

		// 遍历 图元 map 旗帜TXT
		$.each(paperFlagTxtSetMap.keySet(),function(n,key){

			paperFlagTxtSetMap.get(key).remove();	//移除图片
			paperFlagTxtSetMap.remove(key); 		//移除缓存

		});

		// 销毁 缓存数据 旗帜
		isDesTroy && showFlagimgMap.clear();

	};

	/*
     * 设置参数 可外部调用
     * 必要字段：option
     * @param option json {}
     * @returns
     */
    this.setTkOpt = function (option) {
        if (!isItEmpty(option.clickTkImg)) {
            clickTkImg = option.clickTkImg;
        }
    };

	/**
	 * 画 工具柜图元 可外部调用
	 * 必要字段：toolkitObj
	 * @param toolkitObj toolkit数据json {}
	 * @returns
	 */
	this.loadTkPosition = function (toolkitObj) {

		// 坐标值 转换
		//var currPixelX = ( parseFloat( toolkitObj.pixelX ) - pOffsetX ) * scaleToPmapW  + mapStartX;
		//var currPixelY = ( parseFloat( toolkitObj.pixelY ) - pOffsetY ) * scaleToPmapH + mapStartY;
		//var currPixelX = parseFloat( toolkitObj.pointXPx );
		//var currPixelY = parseFloat( toolkitObj.pointYPx );
		
		var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: toolkitObj.pointX,y: toolkitObj.pointY}, ratioX, ratioY);
		var currPixelX = pointPx.xPx;// transToMap( toolkitObj.pointX , 'X');
		var currPixelY = pointPx.yPx;// transToMap( toolkitObj.pointY , 'Y');
		
		// 缓存 工具柜数据
		//showToolkitMap.put(toolkitObj.id, $.extend({}, toolkitObj, {pixelX: currPixelX, pixelY: currPixelY}));
		showToolkitMap.put(toolkitObj.id, toolkitObj);

		// 画 toolkit
		creatTkImg(toolkitObj.id, currPixelX, currPixelY);

	};

	/**
	 * 创建工具柜图标
	 * 必要字段：id,pixelX,pixelY
	 * @param values
	 * @returns
	 */
	function creatTkImg(id,pixelX,pixelY){

		// 已存在 先清除
		if(paperToolkitSetMap.containsKey(id)){

			paperToolkitSetMap.get(id).remove();		//移除图片
			paperToolkitSetMap.remove(id); 			//移除缓存

		}

		var toolkitObj = showToolkitMap.get(id);

		var _img_w_h = toolkit_width < toolkit_height ? toolkit_width : toolkit_height;
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var toolkit_img = paper.image(base_toolkit_img,
				(pixelX - _img_w_h/2) * svgImgScale + mapX,
				(pixelY - _img_w_h/2)  * svgImgScale + mapY,
				_img_w_h * svgImgScale,
				_img_w_h  * svgImgScale
		).attr({
			title: [('安装序号：'+ toolkitObj.toolkitSerial), ('工具柜编号：'+ toolkitObj.toolkitId), ('序列号：'+ toolkitObj.sid), ('工具柜状态：'+ (tkStates[toolkitObj.status] ? tkStates[toolkitObj.status] : '----')), ('uwb-ip：'+ toolkitObj.uwbIp), ('时隙：'+ toolkitObj.timeSlot),('功率：'+ toolkitObj.power), ('坐标X(m)：'+ toolkitObj.pointX), ('坐标Y(m)：'+ toolkitObj.pointY), ('坐标Z(m)：'+ toolkitObj.pointZ) ].join('\n')
		}).dblclick(function(){
            clickTkImg && clickTkImg(toolkitObj);
        });
		var paperToolkitSet = paper.set();
		paperToolkitSet.push(
				toolkit_img
		);
		paperToolkitSetMap.put(id,paperToolkitSet);

		// 创建工具柜 TXT
		creatTkTxt(id,pixelX,pixelY);

	};

	// 创建工具柜 TXT
	function creatTkTxt(id,pixelX,pixelY) {

		// 已存在 先清除 工具柜序列号
		if(paperToolkitTxtSetMap.containsKey(id)){

			paperToolkitTxtSetMap.get(id).remove();		//移除图片
			paperToolkitTxtSetMap.remove(id); 			//移除缓存

		}

		var toolkitObj = showToolkitMap.get(id);
		// 空值 中止
		if(isItEmpty(toolkitObj)) return false;

		var _img_w_h = toolkit_width < toolkit_height ? toolkit_width : toolkit_height;

		var textOpt = !isItEmpty(toolkitObj.textOpt) ? toolkitObj.textOpt : {};
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var paperTxtSet = paper.set();
		var textArr = [(toolkitObj.sid)];
		paperTxtSet.push(
			paper.text(
					pixelX * svgImgScale + mapX ,
					(pixelY - _img_w_h/2) * svgImgScale + mapY - (8 * textArr.length),
					textArr.join('\n') ).attr({
							"fill":(textOpt.fill ? textOpt.fill : "black"),// dodgerblue
							"stroke-width": (textOpt.width ? textOpt.width : 5),
			                "font-size": (textOpt.fontSize ? textOpt.fontSize : "14px")
			            })
		);
		paperToolkitTxtSetMap.put(id,paperTxtSet);

	};


	// 加载 所有 已缓存 工具柜
	function loadAllTks() {

		// 遍历缓存 工具柜
		$.each(showToolkitMap.keySet(), function(n, key) {

			var values = showToolkitMap.get(key);
			creatTkImg(values.id, values.pointXPx, values.pointYPx);

		});

	};

	/**
	 * 清除图标 工具柜
	 * 字段：id,type
	 * @param "id" 			工具柜id
	 * @param "destroy" 	销毁缓存
	 * @returns
	 */
	this.clearTk = function (id, type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 移除 img 工具柜
		if(paperToolkitSetMap.containsKey(id)){

			paperToolkitSetMap.get(id).remove();		//移除图片
			paperToolkitSetMap.remove(id); 				//移除缓存

		}

		// 移除 text 工具柜
		if(paperToolkitTxtSetMap.containsKey(id)){

			paperToolkitTxtSetMap.get(id).remove();			//移除图片
			paperToolkitTxtSetMap.remove(id); 				//移除缓存

		}

		// 销毁 缓存数据 工具柜
		isDesTroy && showToolkitMap.containsKey(id) && showToolkitMap.remove(id);

	};

	/**
	 * 清除图标 工具柜
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearAllTks = function (type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 遍历 图元 map 工具柜
		$.each(paperToolkitSetMap.keySet(),function(n,key){

			paperToolkitSetMap.get(key).remove();	//移除图片
			paperToolkitSetMap.remove(key); 		//移除缓存

		});

		// 遍历 图元 map 工具柜TXT
		$.each(paperToolkitTxtSetMap.keySet(),function(n,key){

			paperToolkitTxtSetMap.get(key).remove();	//移除图片
			paperToolkitTxtSetMap.remove(key); 		//移除缓存

		});

		// 销毁 缓存数据 工具柜
		isDesTroy && showToolkitMap.clear();

	};

	/**
	 * 刻度尺数据 可外部调用
	 * 必要字段：_ruleLineObj
	 * @param _ruleLineObj ruleLine数据json {}
	 * @returns
	 */
	this.setRuleLineData = function (_ruleLineObj) {

		// 解析 刻度尺 数据
		var ruleLineObj = analysisRuleLineData(_ruleLineObj.id, _ruleLineObj);

		// 缓存 记录刻度尺数据
		map_cord_ruleLine.put(_ruleLineObj.id, ruleLineObj);

	};

	/**
	 * 画 刻度尺图元 可外部调用
	 * 必要字段：ruleLineObj
	 * @param ruleLineObj ruleLine数据json {}
	 * @returns
	 */
	this.loadRuleLine = function (ruleLineObj) {

		// 缓存 刻度尺数据
		showRuleLinesMap.put(ruleLineObj.id, ruleLineObj);

		// 画 ruleLine
		creatRuleLineImg(ruleLineObj.id, ruleLineObj);

	};

	/**
	 * TODO 解析 刻度尺数据
	 * @param {Object} id
	 * @param {Object} ruleLineObj
	 * @return {Object} ruleLineObj
	 */
	function analysisRuleLineData(id, ruleLineObj) {
		
		var startMileage = parseFloat(ruleLineObj.startMileage);
		var finishMileage = parseFloat(ruleLineObj.finishMileage);
		var workMileage = parseFloat(ruleLineObj.workMileage);
		var endMileage = parseFloat(ruleLineObj.endMileage);

		var slotFinishMileage = finishMileage - startMileage;
		var slotWorkMileage = workMileage - startMileage;
		var slotEndMileage = endMileage - startMileage;
		
		//var startX = parseFloat(ruleLineObj.startX);
		//var startY = parseFloat(ruleLineObj.startY) + 350;
		
		var _ratioY = ratioY;
		var pointY = 0;
		if (mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e5') {
			_ratioY = 1;
		} else if (mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e6') {
			_ratioY = 3;
		}
		
		var pointPx_start = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: startMileage,y: pointY}, ratioX, _ratioY);
		var startX = pointPx_start.xPx;
		var startY = pointPx_start.yPx;
		
		var mapScaleXs = !isItEmpty(ruleLineObj.scaleX) ? ruleLineObj.scaleX.split('/') : [1, 1];
		mapScaleXs[0] = parseFloat(mapScaleXs[0]);mapScaleXs[1] = parseFloat(mapScaleXs[1]);

		var mapScaleYs = !isItEmpty(ruleLineObj.scaleY) ? ruleLineObj.scaleY.split('/') : [1, 1];
		mapScaleYs[0] = parseFloat(mapScaleYs[0]);mapScaleYs[1] = parseFloat(mapScaleYs[1]);

		// 起始里程
		if (ruleLineObj.mapType == 2) {// 掌子面
			//var slotStartXpx = slotFinishMileage * mapScaleXs[0] / mapScaleXs[1];
			//startX = startX - slotStartXpx;
			
			pointPx_start = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: (startMileage - slotFinishMileage),y: pointY}, ratioX, _ratioY);
			startX = pointPx_start.xPx;
			startY = pointPx_start.yPx;
		}
		var startPoint = [startX, startY];

		// 完成里程
		//var slotFinishXpx = slotFinishMileage * mapScaleXs[0] / mapScaleXs[1];
		//var finishX = startX + slotFinishXpx;
		var pointPx_finish = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: finishMileage,y: pointY}, ratioX, _ratioY);
		var finishX = pointPx_finish.xPx;
		var finishY = pointPx_finish.yPx;
		
		var finishPoint = [finishX, finishY];

		// 施工里程
		//var slotWorkXpx = slotWorkMileage * mapScaleXs[0] / mapScaleXs[1];
		//var workX = startX + slotWorkXpx;
		var pointPx_work = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: workMileage,y: pointY}, ratioX, _ratioY);
		var workX = pointPx_work.xPx;
		var workY = pointPx_work.yPx;
		
		var workPoint = [workX, workY];

		// 结束里程
		//var slotXpx = slotEndMileage * mapScaleXs[0] / mapScaleXs[1];
		//var endX = startX + slotXpx;
		var pointPx_end = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: endMileage,y: pointY}, ratioX, _ratioY);
		var endX = pointPx_end.xPx;
		var endY = pointPx_end.yPx;
		
		var endPoint = [endX, endY];

		var slotMileage = ruleLineObj.mapType == 2 ? (workMileage - finishMileage) : slotEndMileage;
		var baseSlot = slotMileage > 0 ? 100 : -100;
		var baseSlotXpx = baseSlot * mapScaleXs[0] / mapScaleXs[1];

		/*var mapBaseSlotPx = baseSlotXpx * svgImgScale;
		if (Math.abs(mapBaseSlotPx) < 50) {
			// 回推
			baseSlotXpx = slotMileage > 0 ? 50 / svgImgScale : -50 / svgImgScale;
			baseSlot = baseSlotXpx * mapScaleXs[1] / mapScaleXs[0];

			// 顺推
			var baseSlotL = slotMileage > 0 ? Math.ceil(baseSlot / 0.1) : Math.floor(baseSlot / 0.1);
			baseSlot = baseSlotL * 0.1;
			slotNum = Math.floor(slotMileage / baseSlot);
			baseSlotXpx = baseSlot * mapScaleXs[0] / mapScaleXs[1];
		}*/

		var btPointList = [];

		if (ruleLineObj.mapType == 1 || ruleLineObj.mapType == 0) {
			// 正洞

			var _startMileage = slotMileage > 0 ? ( Math.ceil(startMileage / 100) * 100 ) : ( Math.floor(startMileage / 100) * 100 );
			var _startX = (_startMileage - startMileage) * mapScaleXs[0] / mapScaleXs[1] + startX;

			var _endMileage = slotMileage > 0 ? ( Math.floor(endMileage / 100) * 100 ) : ( Math.ceil(endMileage / 100) * 100 );
			var _endX = (_endMileage - startMileage) * mapScaleXs[0] / mapScaleXs[1] + startX;

			var _slotMileage = _endMileage - _startMileage;
			var slotNum = Math.floor(_slotMileage / baseSlot);

			var iNum = startMileage % 100 == 0 ? 1 : 0;
			slotNum = (endMileage % 100 == 0) ? (slotNum - 1) : slotNum;

			for (var i = iNum; i <= slotNum; i++) {
				var _targetXpx = baseSlotXpx * i + _startX;
				var _targetMileage = baseSlot * i + _startMileage;
				btPointList.push({point: [_targetXpx, startY], mileage: _targetMileage.toFixed(0), textFlag: true});
				//if ((slotMileage > 0 && _targetMileage < endMileage) || (slotMileage < 0 && _targetMileage > endMileage)) {}
			}

		} else if (ruleLineObj.mapType == 2) {
			// 掌子面
			var _finishMileage = slotMileage > 0 ? ( Math.ceil(finishMileage / 100) * 100 ) : ( Math.floor(finishMileage / 100) * 100 );
			var _finishX = (_finishMileage - startMileage) * mapScaleXs[0] / mapScaleXs[1] + startX;

			var _workMileage = slotMileage > 0 ? ( Math.floor(workMileage / 100) * 100 ) : ( Math.ceil(workMileage / 100) * 100 );
			var _workX = (_workMileage - startMileage) * mapScaleXs[0] / mapScaleXs[1] + startX;

			var _slotMileage = _workMileage - _finishMileage;
			var slotNum = Math.floor(_slotMileage / baseSlot);

			var iNum = finishMileage % 100 == 0 ? 1 : 0;
			slotNum = (workMileage % 100 == 0) ? (slotNum - 1) : slotNum;

			for (var i = iNum; i <= slotNum; i++) {
				var _targetXpx = baseSlotXpx * i + _finishX;
				var _targetMileage = baseSlot * i + _finishMileage;
				btPointList.push({point: [_targetXpx, startY], mileage: _targetMileage.toFixed(0), textFlag: true});
				//if ((slotMileage > 0 && _targetMileage < endMileage) || (slotMileage < 0 && _targetMileage > endMileage)) {}
			}
		}

		var _ruleLineObj = $.extend(true, {}, ruleLineObj, {
			startPoint: [startX, startY],
			endPoint: endPoint,
			finishPoint: finishPoint,
			workPoint: workPoint,
			btPointList: btPointList
		});
		
		return _ruleLineObj;
	}

	/**
	 * 创建刻度尺图标
	 * 必要字段：id,pixelX,pixelY
	 * @param values
	 * @returns
	 */
	function creatRuleLineImg(id, _ruleLineObj){

		// 已存在 先清除
		if(paperRuleLinesSetMap.containsKey(id)){

			paperRuleLinesSetMap.get(id).remove();				//移除图片
			paperRuleLinesSetMap.remove(id); 					//移除缓存

		}

		// 画布不存在 种植
		if(!paper) return false;
		var paperRuleLineSet = paper.set();

		// 解析 刻度尺 数据
		var ruleLineObj = analysisRuleLineData(id, _ruleLineObj);
		var mapType = ruleLineObj.mapType;

		var startPoint = ruleLineObj.startPoint;
		var finishPoint = ruleLineObj.finishPoint;
		var workPoint = ruleLineObj.workPoint;
		var endPoint = ruleLineObj.endPoint;
		var btPointList = !isItEmpty(ruleLineObj.btPointList) ? [].concat(ruleLineObj.btPointList) : [];

		var startMileage = ruleLineObj.startMileage;
		var finishMileage = ruleLineObj.finishMileage;
		var workMileage = ruleLineObj.workMileage;
		var endMileage = ruleLineObj.endMileage;

		// 线
		var startX = parseFloat( startPoint[0] ) * svgImgScale + mapX;
		var startY = parseFloat( startPoint[1] ) * svgImgScale + mapY;

		var finishX = parseFloat( finishPoint[0] ) * svgImgScale + mapX;
		var finishY = parseFloat( finishPoint[1] ) * svgImgScale + mapY;

		var workX = parseFloat( workPoint[0] ) * svgImgScale + mapX;
		var workY = parseFloat( workPoint[1] ) * svgImgScale + mapY;

		var endX = parseFloat( endPoint[0] ) * svgImgScale + mapX;
		var endY = parseFloat( endPoint[1] ) * svgImgScale + mapY;
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		if (mapType == 1 || mapType == 0) {
			// 正洞

			var line_path = "M"+startX+","+startY+",L,"+endX+","+endY+" z";
			var line = paper.path(line_path).attr({"stroke": "#e0fb0f","stroke-width":2});
			paperRuleLineSet.push(line);
		} else if (mapType == 2) {
			// 掌子面

			var line_path = "M"+finishX+","+finishY+",L,"+workX+","+workY+" z";
			var line = paper.path(line_path).attr({"stroke": "#e0fb0f","stroke-width":2});
			paperRuleLineSet.push(line);
		}

		// 正洞
		if (mapType == 1 || mapType == 0) {
			// 起始刻度
			var lineS_path = "M"+startX+","+startY+",L,"+(startX - 30)+","+startY+" z";// "M"+startX+","+startY+",v,"+(10);
			var lineS = paper.path(lineS_path).attr({"stroke":"#e0fb0f","stroke-width":2});
			paperRuleLineSet.push(lineS);
		}
		
		if (!isItEmpty(finishX) && !isItEmpty(finishY)) {
			// 完成刻度
			var lineF_path = "M"+finishX+","+finishY+",L,"+(finishX - 30)+","+finishY+" z";// "M"+finishX+","+finishY+",v,"+(10);
			var lineF = paper.path(lineF_path).attr({"stroke":"#e0fb0f","stroke-width":2});
			paperRuleLineSet.push(lineF);
		}

		// 不重合 显示 施工刻度
		if (mapType == 2 && workMileage != finishMileage) {
			// 施工刻度
			var lineW_path = "M"+workX+","+workY+",L,"+(workX - 30)+","+workY+" z";// "M"+workX+","+workY+",v,"+(10);
			var lineW = paper.path(lineW_path).attr({"stroke":"#e0fb0f","stroke-width":2});
			paperRuleLineSet.push(lineW);
		}

		// 正洞
		if (mapType == 1 || mapType == 0) {
			// 结束刻度
			var lineE_path = "M"+endX+","+endY+",L,"+(endX - 30)+","+endY+" z";// "M"+endX+","+endY+",v,"+(10);
			var lineE = paper.path(lineE_path).attr({"stroke":"#e0fb0f","stroke-width":2});
			paperRuleLineSet.push(lineE);
		}

		// 中间刻度
		$.each(btPointList, function(index, value) {
			// 空值 跳过
			if (isItEmpty(value)) return true;

			var mileage = !isItEmpty(value.mileage) ? value.mileage : '';
			// 重合 跳过
			var isCover = (mapType == 1 && (mileage == startMileage || mileage == finishMileage || mileage == endMileage)) || (mapType == 2 && (mileage == finishMileage || mileage == workMileage));
			if (isCover) return true;

			var point = value.point;

			var pointX = parseFloat( point[0] ) * svgImgScale + mapX;
			var pointY = parseFloat( point[1] ) * svgImgScale + mapY;

			// 刻度线
			var lineSlot_path = "M"+pointX+","+pointY+",L,"+(pointX - 30)+","+pointY+" z";// "M"+pointX+","+pointY+",v,"+(8);
			var lineSlot = paper.path(lineSlot_path).attr({"stroke":"#e0fb0f","stroke-width":2});
			paperRuleLineSet.push(lineSlot);
		});

		paperRuleLinesSetMap.put(id,paperRuleLineSet);

		// 创建刻度尺 TXT
		creatRuleLineTxt(id, ruleLineObj);

	};

	// 创建刻度尺 TXT
	function creatRuleLineTxt(id,ruleLineObj) {
		
		// 已存在 先清除 刻度尺编号
		if(paperRuleLineTxtSetMap.containsKey(id)){

			paperRuleLineTxtSetMap.get(id).remove();			//移除图片
			paperRuleLineTxtSetMap.remove(id); 				//移除缓存

		}

		if (!paper) return false;
		var paperTxtSet = paper.set();

		//var ruleLineObj = showRuleLinesMap.get(id);
		// 空值 中止
		if(isItEmpty(ruleLineObj)) return false;

		var mapType = ruleLineObj.mapType;
		var textOpt = !isItEmpty(ruleLineObj.textOpt) ? ruleLineObj.textOpt : {};

		var startPoint = ruleLineObj.startPoint;
		var finishPoint = ruleLineObj.finishPoint;
		var workPoint = ruleLineObj.workPoint;
		var endPoint = ruleLineObj.endPoint;
		var btPointList = !isItEmpty(ruleLineObj.btPointList) ? [].concat(ruleLineObj.btPointList) : [];

		var startMileage = parseFloat(ruleLineObj.startMileage).toFixed(3);
		var finishMileage = parseFloat(ruleLineObj.finishMileage).toFixed(3);
		var workMileage = parseFloat(ruleLineObj.workMileage).toFixed(3);
		var endMileage = parseFloat(ruleLineObj.endMileage).toFixed(3);

		var startTextAttr = ['起始里程', (startMileage + 'm')];
		var finishTextAttr = ['完成里程', (finishMileage + 'm')];
		var workTextAttr = ['施工里程', (workMileage + 'm')];
		var endTextAttr = ['结束里程', (endMileage + 'm')];

		// 完成里程 重合
		//if (finishMileage == startMileage) startTextAttr.unshift('完成里程');
		//if (finishMileage == endMileage) endTextAttr.unshift('完成里程');

		if (mapType == 2) {
			// 施工里程 重合
			//if (workMileage == startMileage) startTextAttr.unshift('施工里程');
			if (workMileage == finishMileage) finishTextAttr.unshift('施工里程');
			//if (workMileage == endMileage) endTextAttr.unshift('施工里程');
		}

		// 正洞
		if (mapType == 1 || mapType == 0) {
			var startTextStr = startTextAttr.join(' ');
			// 起始文本
			var startTextImg = paper.text(
				startPoint[0] * svgImgScale + mapX - 8*(startTextStr.length) - 5,
				(startPoint[1]) * svgImgScale + mapY ,// - (4 * startTextAttr.length),
				startTextStr
			).attr({
				"fill":(textOpt.fill ? textOpt.fill : "dodgerblue"),
				"stroke-width": (textOpt.width ? textOpt.width : 5),
				"font-size": (textOpt.fontSize ? textOpt.fontSize : "14px")
			});
			paperTxtSet.push(startTextImg);
		}
		
		if (!isItEmpty(finishPoint[0]) && !isItEmpty(finishPoint[1])) {
			var finishTextStr = finishTextAttr.join(' ');
			// 完成文本
			var finishTextImg = paper.text(
				finishPoint[0] * svgImgScale + mapX - 8*(finishTextStr.length) - 5,
				(finishPoint[1]) * svgImgScale + mapY ,// - (4 * finishTextAttr.length),
				finishTextStr
			).attr({
				"fill":(textOpt.fill ? textOpt.fill : "dodgerblue"),
				"stroke-width": (textOpt.width ? textOpt.width : 5),
				"font-size": (textOpt.fontSize ? textOpt.fontSize : "14px")
			});
			paperTxtSet.push(finishTextImg);
		}

		// 不重合 显示 施工里程
		if (mapType == 2 && workMileage != finishMileage) {
			var workTextStr = workTextAttr.join(' ');
			// 施工文本
			var workTextImg = paper.text(
				workPoint[0] * svgImgScale + mapX - 8*(workTextStr.length) - 5,
				(workPoint[1]) * svgImgScale + mapY ,// - (4 * workTextAttr.length),
				workTextStr
			).attr({
				"fill":(textOpt.fill ? textOpt.fill : "dodgerblue"),
				"stroke-width": (textOpt.width ? textOpt.width : 5),
				"font-size": (textOpt.fontSize ? textOpt.fontSize : "14px")
			});
			paperTxtSet.push(workTextImg);
		}

		// 正洞
		if (mapType == 1 || mapType == 0) {
			var endTextStr = endTextAttr.join(' ');
			// 结束文本
			var endTextImg = paper.text(
				endPoint[0] * svgImgScale + mapX - 8*(endTextStr.length) - 5,
				(endPoint[1]) * svgImgScale + mapY ,// - (4 * endTextAttr.length),
				endTextStr
			).attr({
				"fill":(textOpt.fill ? textOpt.fill : "dodgerblue"),
				"stroke-width": (textOpt.width ? textOpt.width : 5),
				"font-size": (textOpt.fontSize ? textOpt.fontSize : "14px")
			});
			paperTxtSet.push(endTextImg);
		}

		// 中间 文本
		$.each(btPointList, function(index, value) {
			// 空值 跳过
			if (isItEmpty(value)) return true;
			// 不展示 跳过
			if (!value.textFlag) return true;

			var mileage = !isItEmpty(value.mileage) ? value.mileage : '';
			// 重合 跳过
			var isCover = (mapType == 1 && (mileage == startMileage || mileage == finishMileage || mileage == endMileage)) || (mapType == 2 && (mileage == finishMileage || mileage == workMileage));
			if (isCover) return true;

			var _textOpt = !isItEmpty(value.textOpt) ? value.textOpt : textOpt;

			var point = value.point;
			var pointX = point[0];
			var pointY = point[1];
			var str = (mileage + 'm');
			var textImg = paper.text(
				pointX * svgImgScale + mapX - 8*(str.length) - 5,
				(pointY) * svgImgScale + mapY ,// - (8 * 1),
				str
			).attr({
				"fill":(_textOpt.fill ? _textOpt.fill : "dodgerblue"),
				"stroke-width": (_textOpt.width ? _textOpt.width : 5),
				"font-size": (_textOpt.fontSize ? _textOpt.fontSize : "14px")
			});

			paperTxtSet.push(textImg);
		});

		paperRuleLineTxtSetMap.put(id,paperTxtSet);

	};


	// 加载 所有 已缓存 刻度尺
	function loadAllRuleLines() {

		// 遍历缓存 刻度尺
		$.each(showRuleLinesMap.keySet(), function(n, key) {

			var values = showRuleLinesMap.get(key);
			creatRuleLineImg(values.id, values);

		});

	};

	/**
	 * 清除图标 刻度尺
	 * 字段：id,type
	 * @param "id" 			刻度尺id
	 * @param "destroy" 	销毁缓存
	 * @returns
	 */
	this.clearRuleLine = function (id, type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 移除 img 刻度尺
		if(paperRuleLinesSetMap.containsKey(id)){

			paperRuleLinesSetMap.get(id).remove();			//移除图片
			paperRuleLinesSetMap.remove(id); 					//移除缓存

		}

		// 移除 text 刻度尺
		if(paperRuleLineTxtSetMap.containsKey(id)){

			paperRuleLineTxtSetMap.get(id).remove();			//移除图片
			paperRuleLineTxtSetMap.remove(id); 				//移除缓存

		}

		// 销毁 缓存数据 刻度尺
		isDesTroy && showRuleLinesMap.containsKey(id) && showRuleLinesMap.remove(id);

	};

	/**
	 * 清除图标 刻度尺
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearAllRuleLines = function (type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 遍历 图元 map 刻度尺
		$.each(paperRuleLinesSetMap.keySet(),function(n,key){

			paperRuleLinesSetMap.get(key).remove();			//移除图片
			paperRuleLinesSetMap.remove(key); 				//移除缓存

		});

		// 遍历 图元 map 刻度尺TXT
		$.each(paperRuleLineTxtSetMap.keySet(),function(n,key){

			paperRuleLineTxtSetMap.get(key).remove();		//移除图片
			paperRuleLineTxtSetMap.remove(key); 				//移除缓存

		});

		// 销毁 缓存数据 刻度尺
		isDesTroy && showRuleLinesMap.clear();

	};

	// ======================================================== 比例坐标系 start ========================================================
	/**
	 * 允许 比例图元 可外部调用
	 * 必要字段：scaleLineObj
	 * @param scaleLineObj scaleLine数据json {}
	 * @returns
	 */
	this.allowShowScaleLine = function (flag, option) {
		// flag 允许显示 地图比例
		showScaleFlag = flag && true;
		
		// 创建比例图标
		creatScaleLineImg();
	};
	
	/**
	 * 画 比例图元 可外部调用
	 * 必要字段：scaleLineObj
	 * @param scaleLineObj scaleLine数据json {}
	 * @returns
	 */
	this.loadScaleLine = function (scaleLineObj) {
		// 缓存 比例数据
		showScaleLinesMap.put(scaleLineObj.id, scaleLineObj);

		// 画 scaleLine
		creatScaleLineImg(scaleLineObj.id, scaleLineObj);
	};
	
	/**
	 * 创建比例图标
	 * 必要字段：id,pixelX,pixelY
	 * @param values
	 * @returns
	 */
	function creatScaleLineImg(id=SCALELINE, _scaleLineObj){
		
		// 已存在 先清除
		if(paperScaleLinesSetMap.containsKey(id)){

			paperScaleLinesSetMap.get(id).remove();				//移除图片
			paperScaleLinesSetMap.remove(id); 					//移除缓存

		}
		
		// 已存在 先清除 比例编号
		if(paperScaleLineTxtSetMap.containsKey(id)){

			paperScaleLineTxtSetMap.get(id).remove();			//移除图片
			paperScaleLineTxtSetMap.remove(id); 				//移除缓存

		}
		
		// flag false 中止
		if (!showScaleFlag) return false;
		
		// 画布不存在 中止
		if(!paper) return false;
		var paperScaleLineSet = paper.set();
		
		// 比例空值 中止
		if (isItEmpty(mapWidthScale) && isItEmpty(mapHeightScale)) return false;
		
		// 默认参数
		var defaultLineObj = {id: SCALELINE,originX: 50,originY: 50,slot: 100,lineOpt: {color: 'dodgerblue', width: 2}, textOpt: {color: 'dodgerblue', width: 5, fontSize: '14px'}};
		
		// 解析 比例 数据
		var scaleLineObj = Object.assign({}, defaultLineObj, _scaleLineObj);
		var lineOpt = !isItEmpty(scaleLineObj.lineOpt) ? scaleLineObj.lineOpt : {};
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		// 有X比例
		if (!isItEmpty(mapWidthScale)) {
			var pointY = scaleLineObj.originY;
			var startX = scaleLineObj.originX - 30;
			var endX = scaleLineObj.originX + scaleLineObj.slot + 20;
			var originX = scaleLineObj.originX;
			var slotX = scaleLineObj.originX + scaleLineObj.slot;
			
			// X轴
			var line_path = "M"+ startX +","+ pointY +",L,"+ endX +","+ pointY +" z";
			// X轴刻度 原点
			line_path += "M"+ originX +","+ pointY +",v,"+(-10);
			// X轴刻度 单位长度点
			line_path += "M"+ slotX +","+ pointY +",v,"+(-10);
			
			// 箭头
			var arrowLine = that.getArrowLine({x: endX,y: pointY}, {x: (endX + 10),y: pointY}, 10, true);
			line_path += arrowLine.join(',');
			
			var line = paper.path(line_path).attr({"stroke": (lineOpt.color ? lineOpt.color : 'dodgerblue'),"stroke-width": (lineOpt.width ? lineOpt.width : 2)});
			paperScaleLineSet.push(line);
		}
		
		// 有Y比例
		if (!isItEmpty(mapHeightScale)) {
			var pointX = scaleLineObj.originX;
			var startY = scaleLineObj.originY - 30;
			var endY = scaleLineObj.originY + scaleLineObj.slot + 20;
			var originY = scaleLineObj.originY;
			var slotY = scaleLineObj.originY + scaleLineObj.slot;
			
			// Y轴
			var line_path = "M"+ pointX +","+ startY +",L,"+ pointX +","+ endY +" z";
			// Y轴刻度 原点
			line_path += "M"+ pointX +","+ originY +",L,"+ (pointX + 10) +","+ originY +" z";
			// Y轴刻度 单位长度点
			line_path += "M"+ pointX +","+ slotY +",L,"+ (pointX + 10) +","+ slotY +" z";
			
			// 箭头
			var arrowLine = that.getArrowLine({x: pointX,y: endY}, {x: pointX,y: (endY + 10)}, 10, true);
			line_path += arrowLine.join(',');
			
			var line = paper.path(line_path).attr({"stroke": (lineOpt.color ? lineOpt.color : '#e0fb0f'),"stroke-width": (lineOpt.width ? lineOpt.width : 2)});
			paperScaleLineSet.push(line);
		}
		
		paperScaleLinesSetMap.put(id,paperScaleLineSet);

		// 创建比例 TXT
		creatScaleLineTxt(id, scaleLineObj);

	};

	// 创建比例 TXT
	function creatScaleLineTxt(id,scaleLineObj) {
		
		// 已存在 先清除 比例编号
		if(paperScaleLineTxtSetMap.containsKey(id)){

			paperScaleLineTxtSetMap.get(id).remove();			//移除图片
			paperScaleLineTxtSetMap.remove(id); 				//移除缓存

		}

		if (!paper) return false;
		var paperTxtSet = paper.set();

		//var scaleLineObj = showScaleLinesMap.get(id);
		// 空值 中止
		if(isItEmpty(scaleLineObj)) {
			scaleLineObj = {id: SCALELINE,originX: 50,originY: 50,slot: 100,lineOpt: {color: 'dodgerblue', width: 2}, textOpt: {color: 'dodgerblue', width: 5, fontSize: '14px'}};
		};
		
		var textOpt = !isItEmpty(scaleLineObj.textOpt) ? scaleLineObj.textOpt : {};
		
		var originX = scaleLineObj.originX - 10;
		var originY = scaleLineObj.originY + 10;
		if (isItEmpty(mapWidthScale)) {
			originY -= 10;
		}
		if (isItEmpty(mapHeightScale)) {
			originX += 10;
		}
		
		// 文本 原点
		var originTextImg = paper.text(
			originX,
			originY,
			'0'
		).attr({
			"fill":(textOpt.color ? textOpt.color : "dodgerblue"),
			"stroke-width": (textOpt.width ? textOpt.width : 5),
			"font-size": (textOpt.fontSize ? textOpt.fontSize : "14px")
		});
		paperTxtSet.push(originTextImg);
		
		// 有X比例
		if (!isItEmpty(mapWidthScale)) {
			
			// 文本 标识、单位 X/米
			var xTextImg = paper.text(
				scaleLineObj.originX + scaleLineObj.slot + 15,
				scaleLineObj.originY + 15,
				'X / 米'
			).attr({
				"fill":(textOpt.color ? textOpt.color : "dodgerblue"),
				"stroke-width": (textOpt.width ? textOpt.width : 5),
				"font-size": (textOpt.fontSize ? textOpt.fontSize : "14px")
			});
			paperTxtSet.push(xTextImg);
			
			if (svgWidth > 0) {
				// 比例
				var scaleXs = mapWidthScale.split('/'),
					scaleX = parseFloat( scaleXs[0] ) / parseFloat( scaleXs[1] );
				// slot X
				var slotNX = scaleLineObj.slot * mapWidth  / svgWidth / scaleX;
				// 文本 比例 X
				var slotNXTextImg = paper.text(
					scaleLineObj.originX + scaleLineObj.slot,
					scaleLineObj.originY - 20,
					slotNX.toFixed(3)
				).attr({
					"fill":(textOpt.color ? textOpt.color : "dodgerblue"),
					"stroke-width": (textOpt.width ? textOpt.width : 5),
					"font-size": (textOpt.fontSize ? textOpt.fontSize : "14px")
				});
				paperTxtSet.push(slotNXTextImg);
			}
			
		}
		
		// 有Y比例
		if (!isItEmpty(mapHeightScale)) {
			
			// 文本 标识、单位 Y/米
			var YTextImg = paper.text(
				scaleLineObj.originX - 25,
				scaleLineObj.originY + scaleLineObj.slot + 10,
				['Y / 米'].join('\n')
			).attr({
				"fill":(textOpt.color ? textOpt.color : "dodgerblue"),
				"stroke-width": (textOpt.width ? textOpt.width : 5),
				"font-size": (textOpt.fontSize ? textOpt.fontSize : "14px")
			});
			paperTxtSet.push(YTextImg);
			
			if (svgHeight > 0) {
				// 比例
				var scaleYs = mapHeightScale.split('/'),
					scaleY = parseFloat( scaleYs[0] ) / parseFloat( scaleYs[1] );
				// slot Y
				var slotNY = scaleLineObj.slot * mapHeight  / svgHeight / scaleY;
				// 文本 比例 Y
				var slotNYTextImg = paper.text(
					scaleLineObj.originX + 35,
					scaleLineObj.originY + scaleLineObj.slot,
					slotNY.toFixed(3)
				).attr({
					"fill":(textOpt.color ? textOpt.color : "dodgerblue"),
					"stroke-width": (textOpt.width ? textOpt.width : 5),
					"font-size": (textOpt.fontSize ? textOpt.fontSize : "14px")
				});
				paperTxtSet.push(slotNYTextImg);
			}
			
		}
		
		paperScaleLineTxtSetMap.put(id,paperTxtSet);
		
	};


	// 加载 所有 已缓存 比例
	function loadAllScaleLines() {

		// 遍历缓存 比例
		$.each(showScaleLinesMap.keySet(), function(n, key) {

			var values = showScaleLinesMap.get(key);
			// 创建比例图标
			creatScaleLineImg(values.id, values);

		});

	};

	/**
	 * 清除图标 比例
	 * 字段：id,type
	 * @param "id" 			比例id
	 * @param "destroy" 	销毁缓存
	 * @returns
	 */
	this.clearScaleLine = function (id, type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 移除 img 比例
		if(paperScaleLinesSetMap.containsKey(id)){

			paperScaleLinesSetMap.get(id).remove();			//移除图片
			paperScaleLinesSetMap.remove(id); 					//移除缓存

		}

		// 移除 text 比例
		if(paperScaleLineTxtSetMap.containsKey(id)){

			paperScaleLineTxtSetMap.get(id).remove();			//移除图片
			paperScaleLineTxtSetMap.remove(id); 				//移除缓存

		}

		// 销毁 缓存数据 比例
		isDesTroy && showScaleLinesMap.containsKey(id) && showScaleLinesMap.remove(id);

	};

	/**
	 * 清除图标 比例
	 * 字段：type
	 * @param "destroy" 销毁缓存
	 * @returns
	 */
	this.clearAllScaleLines = function (type) {

		// 是否销毁缓存
		var isDesTroy = type == "destroy";

		// 遍历 图元 map 比例
		$.each(paperScaleLinesSetMap.keySet(),function(n,key){

			paperScaleLinesSetMap.get(key).remove();			//移除图片
			paperScaleLinesSetMap.remove(key); 				//移除缓存

		});

		// 遍历 图元 map 比例TXT
		$.each(paperScaleLineTxtSetMap.keySet(),function(n,key){

			paperScaleLineTxtSetMap.get(key).remove();		//移除图片
			paperScaleLineTxtSetMap.remove(key); 				//移除缓存

		});

		// 销毁 缓存数据 比例
		isDesTroy && showScaleLinesMap.clear();

	};
	
	// ======================================================== 比例坐标系 end ========================================================
	
	//------------------------------------------- 轨迹 相关 ----------------------------------------------

	/**
	 * 获取坐标间的距离
	 * @Param pt1		坐标点1
	 * @Param pt2		坐标点2
	 */
	this.getDist = function(pt1,pt2) {
		return Math.sqrt((pt1.x-pt2.x)*(pt1.x-pt2.x)+(pt1.y-pt2.y)*(pt1.y-pt2.y));
	};

	/**
	 *  @Param pt_list		路线点集合
	 *  @Param dst			待画箭头的线段最短长度
	 *  @Param len			待画箭头的长度
	 *  @Param ang			待画箭头与线段夹角（角度制，单位：°，建议输入不要超过45°）
	 */
	this.getArrowPoint = function(pt_list, dst, len, ang) {

		var N = pt_list.length;
		var pt_arrow = [];

		// 轨迹至少包含2个点才计算
		if (N>=2) {
			// 根据轨迹确定待画箭头的线段的2个端点
			var pt1 = new Object(), pt2 = new Object();
			pt1.x = pt_list[N-1].pixelX;
			pt1.y = pt_list[N-1].pixelY;
			var d = 0;
			var i = 1;
			while (i<N && d<dst) {
				i++;
				pt2.pixelX = pt_list[N-i].pixelX;
				pt2.y = pt_list[N-i].pixelY;

				d = that.getDist(pt1, pt2);
			}
			// 计算待画箭头的线段的角度（弧度制-pi~pi）
			var dy = pt1.y-pt2.y;
			var dx = pt1.x-pt2.x;
			var ang_line = Math.atan2(dy,dx);

			// 计算2个箭头线段的角度（弧度制-pi~pi）
			var ang_arrow1 = ang_line+(Math.PI-ang/180*Math.PI);
			var ang_arrow2 = ang_line-(Math.PI-ang/180*Math.PI);

			// 计算2个箭头的端点坐标
			var pt3 = new Object(), pt4 = new Object();
			pt3.x = pt1.x+len*Math.cos(ang_arrow1);
			pt3.y = pt1.x+len*Math.sin(ang_arrow1);
			pt4.x = pt1.x+len*Math.cos(ang_arrow2);
			pt4.y = pt1.x+len*Math.sin(ang_arrow2);

			pt_arrow.push(pt3);
			pt_arrow.push(pt4);
		}
		return pt_arrow;
	};


	/**
	 * 获取箭头线段
	 * @param startPoint		线段起点
	 * @param endPoint			线段终点
	 * @param size				线段长度
	 * @param flag				是否需要中间的线段
	 */
	this.getArrowLine = function (startPoint, endPoint, size, flag){
//		console.log({startPoint, endPoint, size, flag})
		var x1 = startPoint.x, y1 = startPoint.y, x2 = endPoint.x, y2 = endPoint.y;
		var angle = Raphael.angle(x1, y1, x2, y2);//得到两点之间的角度
        var a45 = Raphael.rad(angle - 30);		//角度转换成弧度
        var a45m = Raphael.rad(angle + 30);
        var x2a = x2 + Math.cos(a45) * size;
        var y2a = y2 + Math.sin(a45) * size;
        var x2b = x2 + Math.cos(a45m) * size;
        var y2b = y2 + Math.sin(a45m) * size;
        var result = [];
        if(flag){
        	result = ["M", x1, y1, "L", x2, y2, "L", x2a, y2a, "M", x2, y2, "L", x2b, y2b];
        }else{
        	result = ["M", x2a, y2a, "L", x2, y2, "L", x2b, y2b];
        }
        return result;
	};

	/**
	 * 清除轨迹箭头
	 * @Param id
	 */
	var trackArrowSetMap = new HashMap();							// 轨迹的箭头
	this.clearTrackArrow = function(id){
		if(trackArrowSetMap.containsKey(id)){
			trackArrowSetMap.get(id).remove();
			trackArrowSetMap.remove(id);
		}
	};

	/**
	 * 清除轨迹线
	 * @Param id
	 */
	var trackLinesSetMap = new HashMap();							// 移动的线
	this.clearTrackLines = function(id){
		if(trackLinesSetMap.containsKey(id)){
			var trackLines = trackLinesSetMap.get(id);
			$.each(trackLines,function(n){
				trackLines[n].remove();
			})
			trackLinesSetMap.remove(id);
		}
	};

	/**
	 * 清除人员
	 * @Param id
	 */
	var trackPeopleSetMap = new HashMap();							// 静态人员
	var trackPeopleTextSetMap = new HashMap();						// 静态人员文字
	this.clearTrackPeople = function(id){
		if(trackPeopleSetMap.containsKey(id)){
			trackPeopleSetMap.get(id).remove();
			trackPeopleSetMap.remove(id);
		}
		if(trackPeopleTextSetMap.containsKey(id)){
			trackPeopleTextSetMap.get(id).remove();
			trackPeopleTextSetMap.remove(id);
		}
	};

	/**
	 * 清除运动人员
	 * @Param id
	 */
	var trackMovePeopleSetMap = new HashMap();						// 运动人员
	var trackMovePeopleTextSetMap = new HashMap();					// 运动人员文字
	this.clearTrackMovePeople = function(id){
		if(trackMovePeopleSetMap.containsKey(id)){
			trackMovePeopleSetMap.get(id).remove();
			trackMovePeopleSetMap.remove(id);
		}
		if(trackMovePeopleTextSetMap.containsKey(id)){
			trackMovePeopleTextSetMap.get(id).remove();
			trackMovePeopleTextSetMap.remove(id);
		}
	};


	/**
	 * 清除所有
	 * @Param id
	 */
	this.clearTrackAll = function(){
		//清除箭头
		$.each(trackArrowSetMap.keySet(), function (n, key) {
			that.clearTrackArrow(key);
		});
		//清除线
		$.each(trackLinesSetMap.keySet(), function (n, key) {
			that.clearTrackLines(key);
		});
		//清除人
		$.each(trackPeopleSetMap.keySet(), function (n, key) {
			that.clearTrackPeople(key);
		});
		//清除运动人员
		$.each(trackMovePeopleSetMap.keySet(), function (n, key) {
			that.clearTrackMovePeople(key);
		});
	};


	/**
	 * 绘制箭头
	 * @Param id			人员id
	 * @Param pointStart	起始点
	 * @Param pointEnd		结束点
	 * @Param color    		箭头颜色
	 */
	this.drawStaticArrow = function (id,pointStart,pointEnd,color) {
//		console.log({id,pointStart,pointEnd,color})
		//清除箭头
		that.clearTrackArrow(id);

		//var _x0 = ( pointStart.x - pOffsetX ) * scaleToPmapW  + mapStartX;
		//var _y0 = ( pointStart.y - pOffsetY ) * scaleToPmapH + mapStartY;
		
		var _ratioY = ratioY;
		if (mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e5') {
			_ratioY = 0.5;
		}
		
		// 偏移量
		let _ratioX = ratioX;
		// 定制隧道
		if (mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e11') {
			_ratioX = 0.5;
		}
		
		var _pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: pointStart.x,y: pointStart.y}, _ratioX, _ratioY);
		var _x0 = _pointPx.xPx;// transToMap( pointStart.x , 'X');
		var _y0 = _pointPx.yPx;// transToMap( pointStart.y , 'Y');
		
		pointStart.x = _x0 * svgImgScale + mapX;
		pointStart.y = _y0 * svgImgScale + mapY;

		//var _x1 = ( pointEnd.x - pOffsetX ) * scaleToPmapW  + mapStartX;
		//var _y1 = ( pointEnd.y - pOffsetY ) * scaleToPmapH + mapStartY;
		
		var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: pointEnd.x,y: pointEnd.y}, _ratioX, _ratioY);
		var _x1 = pointPx.xPx;// transToMap( pointEnd.x , 'X');
		var _y1 = pointPx.yPx;// transToMap( pointEnd.y , 'Y');
		pointEnd.x = _x1 * svgImgScale + mapX;
		pointEnd.y = _y1 * svgImgScale + mapY;
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var arrowLine = that.getArrowLine(pointStart, pointEnd, 10, false);
		var paperArrow = paper.path(arrowLine).attr({fill:color,"stroke":color,"stroke-width":2});
		var paperArrowSet = paper.set();
		paperArrowSet.push(
				paperArrow
		);
		trackArrowSetMap.put(id,paperArrowSet);
	};

	/**
	 * 绘制静态轨迹线
	 * @Param id			人员id
	 * @Param points		绘制集合点
	 * @Param color			绘制颜色
	 */
	this.drawStaticTrackLine = function(id,points,color,selMapId){
//		console.log({id,points,color})
		//清除线
		that.clearTrackLines(id);
		if(points.length < 2){
			return;
		}
		
		var _ratioY = ratioY;
		if (mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e5') {
			_ratioY = 0.5;
		}
		
		// 偏移量
		let _ratioX = ratioX;
		// 定制隧道
		if (mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e11') {
			_ratioX = 0.5;
		}
		
		var line_path = "";
		var pointStart = points[0];
		var pointEnd = points[1];
		var mapIdTemp = '';
		$.each(points, function (n, point) {
			// 坐标值 转换
			//var _x = ( parseFloat( point.x ) - pOffsetX ) * scaleToPmapW  + mapStartX;
			//var _y = ( parseFloat( point.y ) - pOffsetY ) * scaleToPmapH + mapStartY;
			
			var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: parseFloat( point.x ),y: parseFloat( point.y )}, _ratioX, _ratioY);
			var _x = pointPx.xPx;// transToMap( parseFloat( point.x ) , 'X');
			var _y = pointPx.yPx;// transToMap( parseFloat( point.y ) , 'Y');
			
			var x = _x * svgImgScale + mapX;
			var y = _y * svgImgScale + mapY;
			if(point.mapId == selMapId){
				// 坐标的场景 与 选中的场景 相同
				if(mapIdTemp == ''){
					line_path += "M " + x + "," + y;
				}else{
					if(points[n].x - points[n-1].x != 0
							|| points[n].y - points[n-1].y != 0){
						line_path += " L" + x + "," + y;
					}
				}
				mapIdTemp = selMapId;
			}else{
				// 坐标的场景 与 选中的场景 不相同，置为空
				mapIdTemp = '';
			}
			if(n > 1){
				if(point.mapId == selMapId){
					if(points[n].x - pointEnd.x != 0
							|| points[n].y - pointEnd.y != 0){
						pointStart = pointEnd;
						pointEnd = points[n];
					}
				}else{
					pointStart = points[n];
					pointEnd = points[n];
				}
			}
		});
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var lineT = paper.path(line_path).attr({"stroke":color,"stroke-width":2});
		var paperLineSet = paper.set();
		paperLineSet.push(
			lineT
		);
		if(trackLinesSetMap.containsKey(id)){
			trackLinesSetMap.get(id).push(paperLineSet);
		}else{
			trackLinesSetMap.put(id,[paperLineSet]);
		}

//		console.log({pointStart,pointEnd})
		//创建箭头
		that.drawStaticArrow(id,pointStart,pointEnd,color);
	};

	/**
	 * 创建静态人员
	 * @Param id			人员id
	 * @Param info			人员信息
	 */
	this.creatStaticPeople = function(id,info){
		//清除静态人员
		that.clearTrackPeople(id);

		var _img_w_h = people_width < people_height ? people_width : people_height;

		//var _x = ( info.point.x - pOffsetX ) * scaleToPmapW  + mapStartX - _img_w_h/2;
		//var _y = ( info.point.y - pOffsetY ) * scaleToPmapH + mapStartY  - _img_w_h;
		
		var _ratioY = ratioY;
		if (mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e5') {
			_ratioY = 0.5;
		}
		
		// 偏移量
		let _ratioX = ratioX;
		// 定制隧道
		if (mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e11') {
			_ratioX = 0.5;
		}
		
		var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: info.point.x,y: info.point.y}, _ratioX, _ratioY);
		var _x = pointPx.xPx - _img_w_h/2;// transToMap( info.point.x , 'X') - _img_w_h/2;
		var _y = pointPx.yPx - (_img_w_h);// transToMap( info.point.y, 'Y') - _img_w_h;
		var x = _x * svgImgScale + mapX;
		var y = _y * svgImgScale + mapY;
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var paperPeopleSet = paper.set();
		paperPeopleSet.push(
				paper.image(info.img,
					x,
					y,
					_img_w_h * svgImgScale,
					_img_w_h * svgImgScale
				)
		);
		trackPeopleSetMap.put(id,paperPeopleSet);

		if(info.showName){
			var name = info.userName;
			if(info.userNo){
				//name += '('+info.userNo+')';
			}
			var paperTxtSet = paper.set();
			paperTxtSet.push(
				paper.text(
						(_x + _img_w_h/2) * svgImgScale + mapX,
						(_y - txt_oheight) * svgImgScale + mapY,
						name).attr({
								"fill": info.color,//"dodgerblue",
								"stroke-width": "2",
				                "font-size":"8px"
				            })
			);
			trackPeopleTextSetMap.put(id,paperTxtSet);
		}
	};

	/**
	 *  创建移动的图元
	 *  @Param id			人员id
	 *  @Param info			信息
	 *  @returns
	 */
	this.creatMovePel = function(id,info,speedV){

//		console.log(info);

		if(info.points == undefined || info.points.length < 2){
			//坐标点长度 < 2，不进行动画
			return ;
		}

		if(!playFlag){
			//停止播放
			return ;
		}

		//移动时间
		var moveTimer = (info.points[1].t - info.points[0].t) / speedV;

		//清除人员
		that.clearTrackPeople(id);

		//清除动画
		that.clearTrackMovePeople(id);

		var _img_w_h = people_width < people_height ? people_width : people_height;

		//创建人员动画
		//var _x = ( info.points[0].x - pOffsetX ) * scaleToPmapW  + mapStartX - _img_w_h/2;
		//var _y = ( info.points[0].y - pOffsetY ) * scaleToPmapH + mapStartY - _img_w_h;
		
		var _ratioY = ratioY;
		if (mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e5') {
			_ratioY = 0.5;
		}
		
		// 偏移量
		let _ratioX = ratioX;
		// 定制隧道
		if (mapInfo.appId == '624b863a82a1e7bed3e066baaddf8a3e11') {
			_ratioX = 0.5;
		}
		
		var _pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: info.points[0].x,y: info.points[0].y}, _ratioX, _ratioY);
		var _x = _pointPx.xPx - _img_w_h/2;// transToMap( info.points[0].x , 'X') - _img_w_h/2;
		var _y = _pointPx.yPx - (_img_w_h);// transToMap( info.points[0].y , 'Y') - _img_w_h;
		var x = _x * svgImgScale + mapX;
		var y = _y * svgImgScale + mapY;
		//var _x2 = ( info.points[1].x - pOffsetX ) * scaleToPmapW  + mapStartX - _img_w_h/2;
		//var _y2 = ( info.points[1].y - pOffsetY ) * scaleToPmapH + mapStartY - _img_w_h;
		
		var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: info.points[1].x,y: info.points[1].y}, _ratioX, _ratioY);
		var _x2 = pointPx.xPx - _img_w_h/2;// transToMap( info.points[1].x , 'X') - _img_w_h/2;
		var _y2 = pointPx.yPx - (_img_w_h);// transToMap( info.points[1].y , 'Y') - _img_w_h;
		var x2 = _x2 * svgImgScale + mapX;
		var y2 = _y2 * svgImgScale + mapY;
		
		// 空值 中止
		if (isItEmpty(paper)) return false;
		
		var movePeopleSet = paper.set();
		movePeopleSet.push(
				paper.image(info.img,
					x,
					y,
					_img_w_h * svgImgScale,
					_img_w_h * svgImgScale
				).animate({
					x: x2,
					y: y2
				}, moveTimer, function(){
				})
			);
		trackMovePeopleSetMap.put(id,movePeopleSet);

		//创建文字动画
		if(info.showName){

			//绘制动态文字
			var name = info.userName;
			if(info.userNo != ''){
				//name += '('+info.userNo+')';
			}
			
			//var _xT = ( info.points[0].x - pOffsetX ) * scaleToPmapW  + mapStartX;
			//var _yT = ( info.points[0].y - pOffsetY ) * scaleToPmapH + mapStartY - _img_w_h - 30;
			
			var _pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: info.points[0].x,y: info.points[0].y}, _ratioX, _ratioY);
			var _xT = _pointPx.xPx;// transToMap( info.points[0].x , 'X');
			var _yT = _pointPx.yPx - (_img_w_h) - 30;// transToMap( info.points[0].y , 'Y') - _img_w_h - 30;
			var xT = _xT * svgImgScale + mapX;
			var yT = _yT * svgImgScale + mapY;
			
			//var _x2T = ( info.points[1].x - pOffsetX ) * scaleToPmapW  + mapStartX;
			//var _y2T = ( info.points[1].y - pOffsetY ) * scaleToPmapH + mapStartY - _img_w_h - 30;
			
			var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: info.points[1].x,y: info.points[1].y}, _ratioX, _ratioY);
			var _x2T = pointPx.xPx;// transToMap( info.points[1].x , 'X');
			var _y2T = pointPx.yPx - (_img_w_h) - 30;// transToMap( info.points[1].y , 'Y') - _img_w_h - 30;
			var x2T = _x2T * svgImgScale + mapX;
			var y2T = _y2T * svgImgScale + mapY;

			var paperTxtSet = paper.set();
			paperTxtSet.push(
				paper.text(
						xT,
						yT,
						name)
					.animate(
						{
	                        "font-size": 8,
	                        "stroke-width": 2,
	                        fill: info.color,
	                        x: x2T,
	                        y: y2T
	                    },
	                    moveTimer,
	                    "bounce"
	                 )
			);
			trackMovePeopleTextSetMap.put(id,paperTxtSet);

		}

//		console.log("开始绘制轨迹线");
		//创建移动轨迹线
		var line_path = "";
		
		// 坐标值 转换
		//var _xL = ( info.points[0].x - pOffsetX ) * scaleToPmapW  + mapStartX;
		//var _yL = ( info.points[0].y - pOffsetY ) * scaleToPmapH + mapStartY;
		
		var _pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: info.points[0].x,y: info.points[0].y}, _ratioX, _ratioY);
		var _xL = _pointPx.xPx;// transToMap( info.points[0].x , 'X');
		var _yL = _pointPx.yPx;// transToMap( info.points[0].y , 'Y');
		var xL = _xL * svgImgScale + mapX;
		var yL = _yL * svgImgScale + mapY;
		
		//var _x2L = ( info.points[1].x - pOffsetX ) * scaleToPmapW  + mapStartX;
		//var _y2L = ( info.points[1].y - pOffsetY ) * scaleToPmapH + mapStartY;
		
		var pointPx = GlobalMap.realPointToMapPoint(Object.assign({}, mapInfo), {x: info.points[1].x,y: info.points[1].y}, _ratioX, ratioY);
		var _x2L = pointPx.xPx;// transToMap( info.points[1].x , 'X');
		var _y2L = pointPx.yPx;// transToMap( info.points[1].y , 'Y');
		var x2L = _x2L * svgImgScale + mapX;
		var y2L = _y2L * svgImgScale + mapY;

		line_path += "M " + xL + "," + yL + " L" + x2L + "," + y2L + " ";

		var paperLineSet = paper.set();
		paperLineSet.push(
			paper.path(line_path).animate({
				 fill: info.color,
				"stroke": info.color,
				"stroke-width":2
			},moveTimer,'bounce',function(){
//				console.log('轨迹线动画完毕:'+moveTimer);
			})
		);
		if(trackLinesSetMap.containsKey(id)){
			var lineArray = trackLinesSetMap.get(id);
			lineArray.push(paperLineSet);
			trackLinesSetMap.put(id,lineArray);
		}else{
			trackLinesSetMap.put(id,[paperLineSet]);
		}

		//清除箭头
		that.clearTrackArrow(id);

		//创建移动箭头
		var arrowLine = that.getArrowLine({
			x: xL,
			y: yL
		}, {
			x: x2L,
			y: y2L
		}, 10, false);

		var paperArrowSet = paper.set();
		paperArrowSet.push(
			paper.path(arrowLine).animate(
					{
						fill: info.color,
						"stroke": info.color,
						"stroke-width":2
					},moveTimer,'bounce',function(){

					})
		);
		trackArrowSetMap.put(id,paperArrowSet);

	};


	/**
	 * @Des 设置播放flag
	 * @Auth
	 * @Date 2021/9/10
	 */
	this.setPlayFlag = function (flag) {
		playFlag = flag;
	};

	/**
	 * 随即获取颜色
	 */
	this.getRandomColor = function(){
		  //return '#'+Math.floor(Math.random()*16777215).toString(16);
		  //var randomColor = mapRandomColor();
		  var randomColor =  Raphael.getColor(0.9);
		  return randomColor;
	};

	/**
	 * @Des 轨迹方法
	 * @Auth
	 * @Date 2021/9/10
	 */
	this.setTrackFns = function (fnOpt) {
		// 空值 中止
		if (isItEmpty(fnOpt)) return false;

		// 轨迹 外部方法 绘制静态图元
		if (typeof fnOpt.creatStaticPel == 'function') {
			creatStaticPel = fnOpt.creatStaticPel;
		}

		// 轨迹 外部方法 绘制静态图元
		if (typeof fnOpt.startMorePlay == 'function') {
			startMorePlay = fnOpt.startMorePlay;
		}

	};

};// function svgMapPaper

/**
 * 验证数据是否正确
 * @param data
 * @returns
 */
function isItEmpty(data){
	return data === false || data == "false" || data === undefined || data == "undefined" || data === null || data == "null" || (typeof data == "number" && isNaN(data) ) || data == "NaN" || ( typeof data == "object" && $.isEmptyObject(data)  || (typeof data == "string" && data.replace(/\s*/g,"") === ""));
};

/**
 * 计算两点之间 距离
 * @param {Object} p1
 * @param {Object} p2
 */
function calcDis(p1, p2, scalingX=1, scalingY=1) {
	var dx = Math.abs((parseFloat(p2.x) - parseFloat(p1.x)) / parseFloat(scalingX));
	var dy = Math.abs((parseFloat(p2.y) - parseFloat(p1.y)) / parseFloat(scalingY));

	var dis = Math.sqrt(Math.pow(dx,2)+Math.pow(dy,2));
	return dis;
}

//调整浏览器显示比例【仅能查看】
function ChangeRatio() {
	// 页面缩放级别
    return !isItEmpty(Store.state.zoom) ? parseFloat(Store.state.zoom) : 1;
	
	var ratio = 1;
	var screen = window.screen;
	var ua = navigator.userAgent.toLowerCase();
	
	if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
		ratio = window.outerWidth / window.innerWidth;
    } else if (~ua.indexOf('msie')) {
		if (screen.deviceXDPI && screen.logicalXDPI) {
			ratio = screen.deviceXDPI / screen.logicalXDPI;
		}
	} else if (window.devicePixelRatio !== undefined) {
		ratio=window.devicePixelRatio;
	}
    
    // 页面缩放级别
    var bodyZoom = !isItEmpty(Store.state.zoom) ? parseFloat(Store.state.zoom) : 1;
    
    return parseFloat((ratio * bodyZoom).toFixed(4));
}


// WEBPACK FOOTER //
// ./src/static_dazzle/plugins/svg/svg_draw_map.js